<style *ngIf="config.title === 'Kubendran'">
  @media screen and (min-width:0px) {
    .bombayhardware1-title {
      height: 60px;
    }

    .bombayhardware2-title {
      height: 30px;
    }

    /*.page-home{
      zoom:130%
    }*/
    .bombayhardware1-img-holder {
      height: 145px !important;
    }

    .bombayhardware2-img-holder {
      height: 190px !important;
    }

    .bestgift-image {
      max-height: 170px;
      width: 500px;
    }

    .img-holder1 {
      height: 295px !important;
      justify-content: center;
      display: flex;
    }

    .text-primary {
      font-size: 6vw;
    }

    .category_images {
      display: none;
      height: 15vw;
    }

    .categoryList {
      font-size: 3vw;
      width: 20vw;
    }

    .categoryListactive {
      font-size: 3vw;
      width: 20vw;
      background-color: #cbe7f2;
    }

    .bombayhardware1-submit-btn {
      margin-left: 1vw !important;
    }

    .bombayhardware2-submit-btn {
      margin-left: 1vw !important;
    }
  }

  @media screen and (min-width:1100px) {
    .bombayhardware1-submit-btn {
      margin-left: 4.3vw !important;
    }

    .bombayhardware2-submit-btn {
      margin-left: 1.3vw !important;
    }

    .bombayhardware1-title {
      height: 50px;
    }

    .img-holder1 {
      justify-content: center;
      display: flex;
      height: 295px !important;

    }

    .bombayhardware2-title {
      height: 30px;
    }

    .bombayhardware1-img-holder {
      height: 295px !important;
    }

    .bombayhardware2-img-holder {
      height: 330px !important;
    }

    .bestgift-image {
      max-height: 295px;
      width: 500px;
    }

    /*.page-home{
      zoom:100%
    }*/
    .text-primary {
      font-size: 2vw;
    }

    .category_images {
      display: block;
      height: 100px;
    }

    .categoryList {
      font-size: 1vw;
      width: auto;
    }

    .categoryListactive {
      font-size: 1vw;
      color: #fbcb0c;
      width: auto;
      background-color: transparent;
    }
  }

  .category_images {
    cursor: pointer;
    margin-left: 10px;
  }

  .categoryListactive {
    cursor: pointer;
    font-weight: 700;
    text-align: center;
  }
</style>

<style>
  @media (max-width: 1920px) {
    .bestgift-category-image {
      display: block;
      object-fit: contain !important;
    }

    .category_list {
      display: block !important;
    }

    .category_list1 {
      display: none !important;
    }

    .content-title1 {
      text-align: center;
      padding: 60px 0 30px;
    }

    .category-name {
      width: 10%;
    }

  }

  @media (min-width: 360px) and (max-width: 600px) {
    .bestgift-category-image {
      display: none;
    }

    .category_list {
      display: none !important;
    }

    .category_list1 {
      display: block !important;
    }

    .content-title1 {
      text-align: center;
      padding: 25px 0 30px;
    }

    .category-name {
      width: 100%;
    }
  }
</style>


<div class="page-home">
  <app-alerts></app-alerts>
  <app-banner></app-banner>

  <!-- <app-banner-two *ngIf="config.title==='Vimpro'"></app-banner-two> -->
  
  <div class="container"
    *ngIf="config.title!=='LinenRaj' && config.title!=='Schift Cosmetics' && config.title!=='Babys Pride' && config.title!=='LushNGreen' && config.title!=='Taazah' && config.title!=='KatbookStore' && config.title!=='ShubhCards' && config.title!=='Deera' && config.title!=='SriSenbaga' && config.title!=='HOB' && config.title!=='PaulCaroline' && config.title!=='Srimaware' && config.title!=='UrbanBox' ">
    <section class="tab-product featured-collections m-0"
      *ngIf="config.title !== 'BestGifts' && config.title !== 'AvonSeals' && config.title !== 'Schift Cosmetics' && config.title != 'Deera' && config.title !== 'SpecialWires' && config.title !== 'Vimpro' && config.title !== 'Vistas' && config.title !== 'LinenRaj' ">
      <div class="row">
        <div class="col-sm-12 col-lg-12 our_featured-products">
          <div class="content-title padding_bottom">
            <div class="title-box title-spacing-mob">
              <h2 class="title main-title "
                *ngIf="config.title != 'LuckMe' && config.title != 'Schift Cosmetics' && config.title != 'Accel' && config.title != 'ShubhCards' && config.title != 'Deera' && config.title != 'BestGifts' && config.title !== 'SpecialWires' &&config.title != 'Kubendran' && config.title != 'Aiema' && config.title != 'Cle' && config.title != 'Beaubelle' && config.title != 'AvonSeals' && config.title != 'BombayHardware'">
                Explore Our Classified Categories
              </h2>

              <h2 class="title main-title" *ngIf="config.title === 'Aiema'"
                style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #d57c30;">
                Explore AIEMA
              </h2>
              <!-- <h2 class="title main-title" *ngIf="config.title === 'Cle'" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #827e77;">
                Explore CLE
               </h2> -->
              <div class="desktop-only">
                <h2 class="title main-title" *ngIf="config.title === 'Cle'" class="cle-homeprodtitle">
                  Discover and Embrace the vast choice<br>of India's Leather and Non Leather Manufacture.
                </h2>
              </div>
              <div class="mobile-only">
                <h2 class="title main-title" *ngIf="config.title === 'Cle'" class="cle-homeprodtitle">
                  Discover and Embrace the<br>vast choice of India's<br>Leather and Non Leather Manufacture.
                </h2>
              </div>

              <h2 class="title main-title" *ngIf="config.title === 'Beaubelle'"
                style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #d57c30;">
                Explore Beaubelle
               </h2>
               <div *ngIf="config.title === 'Cle'">
                <a style="display: none;" href="https://www.schift.in/#/"></a>
                <div class="desk-cleprod" style="margin-top: 2%;margin-left: 6%;">
                  <div class="cle-homeprod" *ngFor="let cate of allCategories ;let i = index">
                    <!-- <img src="../../../../assets/images/cle/beautiful-home-decoration1.png" (click)="routeToLists(cate)" class="cle-deskprodimg" alt=""> -->
                    <img [src]="cate.image" (click)="routeToLists(cate)" class="cle-deskprodimg" alt="" style="cursor: pointer;">
                    <p class="cle-deskprodtitle" style="cursor: pointer;">{{cate.name}}</p>
                  </div>
                  <!-- <div class="cle-homeprod">
                  <img src="../../../../assets/images/cle/creative-flower-vase1.png" class="cle-deskprodimg" alt="">
                  <p class="cle-deskprodtitle">Creative Flower Vase</p>
                </div> -->
                  <!-- <div  class="cle-homeprod">
                  <img src="../../../../assets/images/cle/eco-flower-stand-02-021.png" class="cle-deskprodimg" alt="">
                  <p class="cle-deskprodtitle">Eco Friendly Flower Vase</p>
                </div> -->
                  <!-- <div class="cle-homeprod">
                  <img src="../../../../assets/images/cle/modern-hanging-light-02-021.png" class="cle-deskprodimg" alt="">
                  <p class="cle-deskprodtitle">Modern Hanging Light</p>
                </div> -->
                  <!-- <div class="cle-homeprod">
                  <img src="../../../../assets/images/cle/modern-plant-pot-021.png" class="cle-deskprodimg" alt="">
                  <p class="cle-deskprodtitle">Creative Plant Pot</p>
                </div> -->
                  <!-- <div class="cle-homeprod">
                  <img src="../../../../assets/images/cle/modern-plant-pot1.png" class="cle-deskprodimg" alt="">
                  <p class="cle-deskprodtitle">Modern Plant Pot</p>
                </div> -->
                  <!-- <div  class="cle-homeprod">
                  <img src="../../../../assets/images/cle/portable-speaker1.png" class="cle-deskprodimg" alt="">
                  <p class="cle-deskprodtitle">Single Seater Chair</p>
                </div> -->
                  <!-- <div class="cle-homeprod">
                  <img src="../../../../assets/images/cle/Stylish-Earring1.png" class="cle-deskprodimg" alt="">
                  <p class="cle-deskprodtitle">Stylish Earring</p>
                </div> -->
                </div>
              </div>
              <!-- <div *ngIf="config.title == 'ShubhCards'">
               <h3 class="text-primary" style="font-family: Helvetica;">Shop from Top Categories</h3>
              </div > -->
              <!-- <div *ngIf="config.title == 'Deera'">
               <h3 class="text-primary">Shop From Top Categories</h3>
              </div > -->
              <h2 class="title main-title" *ngIf="config.title == 'LuckMe'">
                Explore Our Classified Brands
              </h2>
              <h4 class="sub-title submain-title"
                *ngIf="config.title !== 'ShubhCards' && config.title !== 'Accel' && config.title !== 'Aiema' && config.title !== 'Cle' && config.title !== 'Beaubelle' && config.title !== 'Deera' && config.title !== 'BestGifts'&& config.title !== 'Kubendran' && config.title !== 'BombayHardware' && config.title !== 'AvonSeals'  && config.title !== 'Schift Cosmetics' && config.title !== 'SpecialWires'">
                Save Time in search of Suppliers</h4>
              <h4 class="sub-title submain-title" *ngIf="config.title === 'Aiema'|| config.title === 'Beaubelle'"
                style="font-family: 'proxima-regular','sans-serif'!important;">Save Time in search of Suppliers</h4>
            </div>
          </div>
          <h2 class="content-title title-box title main-title" *ngIf="config.title === 'BombayHardware'"
            style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #1e1e73;justify-content: center;display: flex;padding-top: 0px;margin-top: -5%;">
            <!-- Explore Bombay Hardware Pipes -->
            PRODUCTS
          </h2>
          <section *ngIf="config.title === 'BombayHardware' ">
            <div>
              <div *ngFor="let cate of allCategories ;let i = index">
                <div *ngIf="cate.name=='Pipes'" class="home-container2">
                  <div *ngFor="let sub of cate.subcategories" style="transition: none !important;cursor: pointer;"
                    class="isempty">
                    <div *ngIf="sub.name!='GI Pipes - Jindal Star' && sub.name!='MS Pipes - Jindal Star'">
                      <div class="home-card" style="padding: 10px;" (click)="productsListTazTest1(sub.name)">
                        <div class="">
                          <!-- <div class="card-heading2">
                              {{sub.name | titlecase }}
                          </div> -->
                          <div style="width:100%">
                            <img style="height: 100%; object-fit: contain;width:100% !important;border-radius: 5px;"
                              [src]="sub.category_icon">
                            <div class="centered">{{sub.name | uppercase }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>




          <app-featured-collections *ngIf="config.title == 'EarthyWorthy'"
            [collections]="featuredCollections"></app-featured-collections>
          <app-featured-collections *ngIf="config.title == 'BBold'"
            [collections]="featuredCollectionsBBold"></app-featured-collections>
          <app-featured-collections *ngIf="config.title == 'Aiema'"
            [collections]="featuredCollections1"></app-featured-collections>

          <!-- <app-featured-collections *ngIf="config.title == 'Cle'"
          [collections]="featuredCleCollections"
        ></app-featured-collections> -->
          <app-featured-collections *ngIf="config.title == 'Beaubelle'"
            [collections]=" featuredCollections_beaubelle"></app-featured-collections>
          <!-- <app-featured-collections *ngIf="config.title == 'BombayHardware'"
          [collections]="featuredCollections2"
        ></app-featured-collections> -->
          <!-- <h2 class="content-title title-box title main-title" *ngIf="config.title === 'BombayHardware'" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #AD342A;">
          Supreme Pipes
         </h2>
        <app-featured-collections *ngIf="config.title == 'BombayHardware'"
        [collections1]="featuredCollections3"
      ></app-featured-collections> -->
          <!-- <h2 class="content-title title-box title main-title" *ngIf="config.title === 'BombayHardware'" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #AD342A;">
       
        Other Categories
       </h2>
      <app-featured-collections *ngIf="config.title == 'BombayHardware'"
      [collections2]="featuredCollections4"
    ></app-featured-collections> -->
          <app-featured-collections *ngIf="config.title == 'LuckMe'"
            [collections]="featuredCollectionsLuckme"></app-featured-collections>
          <app-featured-collections *ngIf="config.title == 'ShubhCards'"
            [collections]="featuredCollectionsShubhCards"></app-featured-collections>
          <!-- <app-featured-collections *ngIf="config.title == 'Deera'"
      [collections]="featuredCollectionsDeera"
    ></app-featured-collections> -->
          <app-featured-collections *ngIf="config.title == 'Carience'"
            [collections]="featuredCollectionsCarience"></app-featured-collections>
          <app-featured-collections *ngIf="config.title == 'Karupattiraja'"
            [collections]="featuredCollectionsKarupattiraja"></app-featured-collections>
        </div>
      </div>
    </section>
    <section *ngIf="config.title==='Vimpro'">
      <div class="home-vimpro1">
        <div class="home-vimpro-flex">
          <div class="vimpro-icon-out">
            <img class="vimpro-home-icon" src="../../../../assets/images/vimpro/delivery-truck.png">
          </div>
          <div class="border_mobile" style="width:75%;border-right: 1px solid #ccc;">
            <p class="t1-vimpro">Safe Shipping<br>On time delivery</p>
          </div>
        </div>
        <!-- <div class="home-vimpro-flex">
          <div class="vimpro-icon-out" style="margin-left:4%">
            <img class="vimpro-home-icon" src="../../../../assets/images/vimpro/money-bag.png">
          </div>
          <div   class="border_mobile" style="width:71%;border-right: 1px solid #ccc;">
            <p class="t1-vimpro">Secured Payment<br>100% moneyback</p>
          </div>
        </div> -->
        <div class="home-vimpro-flex">
          <div class="vimpro-icon-out" style="margin-left:4%">
            <img class="vimpro-home-icon" src="../../../../assets/images/vimpro/insignia.png">
          </div>
          <div class="border_mobile" style="width:71%;border-right: 1px solid #ccc;">
            <p class="t1-vimpro">Quality Assured<br>for all products</p>
          </div>
        </div>
        <div class="home-vimpro-flex">
          <div class="vimpro-icon-out" style="margin-left:4%">
            <img class="vimpro-home-icon" src="../../../../assets/images/vimpro/packing11.png">
          </div>
          <div style="width:71%">
            <p class="t1-vimpro">Customizable<br>packing solutions</p>
          </div>
        </div>
      </div>
    </section>






    <section class="desktop-only" *ngIf="config.title==='Vimpro'" style="margin-top: 50px;background-color: #fbfbfb;">
      <div class="row">

        <div class="col-1"></div>
        <div class="col-5" style="background-color: #c1c1c129; margin-bottom: 30px; ">
          <div class="card mb-3" id="precies12">
            <div class="row g-0 align-items-center">
              <div class="col-md-6">
                <div class="container" *ngFor="let category of allCategories;let i=index">
                  <img *ngIf="category.name==='VACUUM FORMING'" [src]="category.image" class="img-fluid rounded-start"
                    alt="..." style="width: 100%;height: 100%;
                  margin-top: 40px">
                </div>

              </div>
              <div class="col-md-6">
                <div class="card-body">
                  <div class="container container_vimpro" style="margin-top: 70px">
                    <h5 class="card-text new_arr" style="white-space: nowrap">Customizable Products</h5>
                    <h5 class="card-text new_arr1" style="text-align: left;">Vacuum Forming</h5>
                    <button class="btn btn-primary btn_size"
                      style="background-color: black!important;border: black!important;position:relative;top: 20px; width: 133px;"
                      (click)="routeToCategory('VACUUM FORMING')">ENQUIRY NOW</button>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1"></div>
        <div class="col-5" style="background-color: #c1c1c129;position: relative;right:65px; margin-bottom: 30px;">
          <div class="card mb-3" style="max-width: 540px;height: 330px;border: none!important;">
            <div class="row g-0">
              <div class="col-md-6">
                <div class="card-body" style="position: relative;
                left: 27px;">
                  <div class="container container_vimpro" style="margin-top: 70px">
                    <h5 class="card-text new_arr" style="white-space:nowrap">Customizable Products</h5>
                    <h5 class="card-text new_arr1" style="text-align: left!important;text-transform: none;">PP Flute
                      Board</h5>
                    <button class="btn btn-primary btn_size"
                      style="background-color: black!important;border: black!important;position:relative;top: 20px; width: 133px;"
                      (click)="routeToCategory('PP FLUTE BOARD')">ENQUIRY NOW </button>
                  </div>


                </div>







              </div>
              <div class="col-md-6">
                <div class="container" *ngFor="let category of allCategories;let i=index">
                  <img *ngIf="category.name==='PP FLUTE BOARD'" [src]="category.image" class="img-fluid rounded-start"
                    alt="..." style="width: 100%;height: 100%;
                  margin-top: 55px">
                </div>

              </div>
            </div>
          </div>

        </div>


      </div>
      <div class="row">
        <div class="col-1"></div>
        <div class="col-5" style="background-color: #c1c1c129; margin-bottom: 30px; ">
          <div class="card mb-3" style="max-width: 540px;height: 330px;border: none!important;">
            <div class="row g-0">
              <div class="col-md-6">
                <div class="container" *ngFor="let category of allCategories;let i=index">
                  <img *ngIf="category.name==='FOLDABLE CRATE'" [src]="category.image" class="img-fluid rounded-start"
                    alt="..." style="width: 100%;height: 100%;
                  margin-top: 55px">
                </div>

              </div>
              <div class="col-md-6">
                <div class="card-body">
                  <div class="container container_vimpro" style="margin-top: 70px">
                    <h5 class="card-text new_arr" style="white-space: nowrap">Standard Products</h5>
                    <h5 class="card-text new_arr1" style="text-align: left;">Foldable Crate</h5>
                    <button class="btn btn-primary btn_size"
                      style="background-color: black!important;border: black!important;position:relative;top: 20px;"
                      (click)="routeToCategory('FOLDABLE CRATE')">SHOP NOW</button>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1"></div>
        <div class="col-5" style="background-color: #c1c1c129;position: relative;right:65px; margin-bottom: 30px;">
          <div class="card mb-3" style="max-width: 540px;height: 330px;border: none!important;">
            <div class="row g-0">
              <div class="col-md-6">
                <div class="card-body" style="position: relative;
                left: 27px;">
                  <div class="container container_vimpro" style="margin-top: 70px">
                    <h5 class="card-text new_arr" style="white-space:nowrap">Standard Products</h5>
                    <h5 class="card-text new_arr1" style="text-align: left!important">Pallet Set</h5>
                    <button class="btn btn-primary btn_size"
                      style="background-color: black!important;border: black!important;position:relative;top: 20px;"
                      (click)="routeToCategory('PALLET SET')">SHOP NOW</button>
                  </div>


                </div>







              </div>
              <div class="col-md-6">
                <div class="container" *ngFor="let category of allCategories;let i=index">
                  <img *ngIf="category.name==='PALLET SET'" [src]="category.image" class="img-fluid rounded-start"
                    alt="..." style="width: 100%;height: 100%;
                  margin-top: 55px">
                </div>

              </div>
            </div>
          </div>

        </div>


      </div>
      <div class="row">
        <div class="col-1"></div>
        <div class="col-5" style="background-color: #c1c1c129">
          <div class="card mb-3" style="max-width: 540px;height: 330px;border: none!important;">
            <div class="row g-0">
              <div class="col-md-6">
                <div class="container" *ngFor="let category of allCategories;let i=index">
                  <img *ngIf="category.name==='FOOD CONTAINER'" [src]="category.image" class="img-fluid rounded-start"
                    alt="..." style="width: 100%;height: 100%;
                  margin-top: 55px">
                </div>

              </div>
              <div class="col-md-6">
                <div class="card-body">
                  <div class="container container_vimpro" style="margin-top: 70px">
                    <h5 class="card-text new_arr" style="white-space: nowrap">Standard Products</h5>
                    <h5 class="card-text new_arr1" style="text-align: left;">Food Container</h5>
                    <button class="btn btn-primary btn_size"
                      style="background-color: black!important;border: black!important;position:relative;top: 20px;"
                      (click)="routeToCategory('FOOD CONTAINER')">SHOP NOW</button>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1"></div>
        <div class="col-5" style="background-color: #c1c1c129;position: relative;right:65px">
          <div class="card mb-3" style="max-width: 540px;height: 330px;border: none!important;">
            <div class="row g-0">
              <div class="col-md-6">
                <div class="card-body" style="position: relative;
                left: 27px;">
                  <div class="container container_vimpro" style="margin-top: 70px">
                    <h5 class="card-text new_arr" style="white-space:nowrap">Standard Products</h5>
                    <h5 class="card-text new_arr1" style="text-align: left!important">Agricultural Tray</h5>
                    <button class="btn btn-primary btn_size"
                      style="background-color: black!important;border: black!important;position:relative;top: 20px;"
                      (click)="routeToCategory('AGRICULTURAL TRAY')">SHOP NOW</button>
                  </div>


                </div>







              </div>
              <div class="col-md-6">
                <div class="container" *ngFor="let category of allCategories;let i=index">
                  <img *ngIf="category.name==='AGRICULTURAL TRAY'" [src]="category.image"
                    class="img-fluid rounded-start" alt="..." style="width: 100%;height: 100%;
                  margin-top: 55px">
                </div>

              </div>
            </div>
          </div>

        </div>


      </div>


    </section>
    <section class="mobile-only" *ngIf="config.title==='Vimpro'" style="margin-top: 10px;background-color: #fbfbfb;">

      <div class="container" style="position: relative;width: 108% !important;margin: 21px -14px;">
        <div class="col-12" style="background-color: #c1c1c129;height:165px">
          <div style="display: flex;">
            <div class="container" style="width:80%;position:relative;right: 35px;">
              <div class="container8" *ngFor="let category of allCategories;let i=index">
                <img *ngIf="category.name==='VACUUM FORMING'" [src]="category.image"
                  class="img-fluid rounded-start vacuum_height" style="max-width: 100%;height: 160px;margin:0px 37px;"
                  alt="...">

              </div>
            </div>

            <div style="margin: 32px 3px;">
              <h5 class="card-text new_arr">Customizable Products</h5>
              <h5 class="card-text new_arr1">Vacuum Forming</h5>
              <button class="btn btn-primary btn_size"
                style="background-color: black!important;border: black!important;width:125px;position:relative;top:8px;font-size: 11px;left:2px;height: 31px !important;"
                (click)="routeToCategory('VACUUM FORMING')">ENQUIRY NOW</button>

            </div>

          </div>
        </div>
      </div>



      <!-- 
        <section>
          <div class="col-12"  style="background-color: #c1c1c129">
            <div class="row align-items-center" >
              <div class="col-6">
                <div class="img_catrgory">
                  <div class="container9" *ngFor="let category of allCategories;let i=index">
                    <img *ngIf="category.name==='VACUUM FORMING'"[src]="category.image" class="img-fluid rounded-start vacuum_height" style="max-width: 100%;height: 160px;margin:0px 37px;" alt="...">
                  </div>
                </div>
           
              </div>
              <div class="col-6">
                <div class="cont_category text-center">
                  <h5 class="card-text new_arr">Customizable Products</h5>
                  <h5 class="card-text new_arr1">Vacuum Forming</h5>
                    <button class="btn btn-primary btn_size" style="background-color: black!important;border: black!important;width:125px;position:relative;top:8px;font-size: 11px;left:2px;" (click)="routeToCategory('VACUUM FORMING')">ENQUIRY NOW</button>
  
                </div>
              </div>
            </div>
          </div>
        </section>

 -->












      <!-- <div class="col-12" style="background-color: #c1c1c129;height:183px;position: relative;margin-top: 30px;">
          <div style="display: flex;" >
           
            
            <div style="position: relative;margin-top: 50px;white-space: nowrap;">
              <h5 class="card-text new_arr">Customizable Products</h5>
                  <h5 class="card-text new_arr1" style="text-transform: none;" >PP Flute Board</h5>
                  <button class="btn btn-primary btn_size" style="background-color: black!important;border: black!important;width:126px;position:relative;top: 10px;font-size: 12px;" (click)="routeToCategory('PP Flute Board')">ENQUIRY NOW</button>

            </div>
            <div class="container" style="width:80%;position:relative;">
              <div class="container9" *ngFor="let category of allCategories;let i=index">
                <img  *ngIf="category.name==='PP FLUTE BOARD'"[src]="category.image"class="img-fluid rounded-start" alt="..."  style="height:100%;    width:75%;;margin-left: 18px;margin-top:20px">

              </div>
            </div>
          
          </div>
        </div> -->


      <section>
        <div class="col-12" style="background-color: #c1c1c129 ; height: 165px;">
          <div class="row align-items-center">
            <div class="col-6">
              <div class="cont_category text-center">
                <h5 class="card-text new_arr">Customizable Products</h5>
                <h5 class="card-text new_arr1" style="text-transform: none;">PP Flute Board</h5>
                <button class="btn btn-primary btn_size"
                  style="background-color: black!important;border: black!important;width:126px;position:relative;top: 10px;font-size: 12px;"
                  (click)="routeToCategory('PP FLUTE BOARD')">ENQUIRY NOW</button>


              </div>
            </div>
            <div class="col-6">
              <div class="img_catrgory">
                <div class="container9" style="width:86%;height: auto; margin: 10px;"
                  *ngFor="let category of allCategories;let i=index">
                  <img *ngIf="category.name==='PP FLUTE BOARD'" [src]="category.image" class="img-fluid rounded-start"
                    alt="...">
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>













      <section>
        <div class="col-12" style="background-color: #c1c1c129 ;margin-top: 30px;height: 163px;">
          <div class="row align-items-center">
            <div class="col-6">
              <div class="img_catrgory">
                <div class="container9" *ngFor="let category of allCategories;let i=index">
                  <img *ngIf="category.name==='FOLDABLE CRATE'" [src]="category.image" class="img-fluid rounded-start"
                    alt="..." style="width:80%;margin: 16px;">
                </div>
              </div>


            </div>
            <div class="col-6">
              <div class="cont_category text-center">
                <h5 class="card-text new_arr">Standard Products</h5>
                <h5 class="card-text new_arr1">Foldable Crate</h5>
                <button class="btn btn-primary btn_size"
                  style="background-color: black!important;border: black!important;width: 105px;position:relative;top: 10px;"
                  (click)="routeToCategory('FOLDABLE CRATE')">Shop now</button>

              </div>
            </div>
          </div>
        </div>
      </section>










      <!-- 

        <div class="col-12" style="background-color: #c1c1c129;height:163px;margin-top: 30px;">
          <div style="display: flex;" >
            <div class="container" style="width:80%;position:relative;right: 35px;">
              <div class="container9" *ngFor="let category of allCategories;let i=index">
                <img *ngIf="category.name==='FOLDABLE CRATE'"[src]="category.image" class="img-fluid rounded-start" alt="..."  style="height: 69%;width:67%;margin-left:38px;margin-top: 22px ">   

              </div>
            
            </div>
            
            <div style="position: relative;margin-top: 50px;">
              <h5 class="card-text new_arr">Standard Products</h5>
                  <h5 class="card-text new_arr1">Foldable Crate</h5>
                  <button class="btn btn-primary btn_size" style="background-color: black!important;border: black!important;width: 105px;position:relative;top: 10px;" (click)="routeToCategory('FOLDABLE CRATE')">Shop now</button>

            </div>
          
          </div>
        </div> -->







      <section>
        <div class="col-12" style="background-color: #c1c1c129;height:163px;position: relative;margin-top: 30px;">
          <div class="row align-items-center">
            <div class="col-6">
              <div class="cont_category text-center">
                <h5 class="card-text new_arr">Standard Products</h5>
                <h5 class="card-text new_arr1">Pallet Set</h5>
                <button class="btn btn-primary btn_size"
                  style="background-color: black!important;border: black!important;position:relative;width: 105px;top: 10px;"
                  (click)="routeToCategory('PALLET SET')">Shop now</button>


              </div>
            </div>
            <div class="col-6">
              <div class="img_catrgory">
                <div class="container9" *ngFor="let category of allCategories;let i=index">
                  <img *ngIf="category.name==='PALLET SET'" [src]="category.image" class="img-fluid rounded-start"
                    alt="..." style="width:85%;margin: 8px;">

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>









      <!-- 



        <div class="col-12" style="background-color: #c1c1c129;height:163px;position: relative;margin-top: 30px;">
          <div style="display: flex;" >
           
            
            <div class="cont_category text-center" style="position: relative;margin-top: 50px;white-space: nowrap;">
              <h5 class="card-text new_arr">Standard Products</h5>
                  <h5 class="card-text new_arr1">Pallet Set</h5>
                  <button class="btn btn-primary btn_size" style="background-color: black!important;border: black!important;position:relative;width: 105px;top: 10px;" (click)="routeToCategory('PALLET SET')">Shop now</button>

            </div>
            <div class="container" style="width:80%;position:relative;">
              <div class="container9" *ngFor="let category of allCategories;let i=index">
                <img  *ngIf="category.name==='PALLET SET'"[src]="category.image" class="img-fluid rounded-start" alt="..."  style="height: 82%;width:65%;    margin-left: 25px;    margin-top: 21px;">

              </div>

            </div>
          
          </div>
        </div> -->











      <section>
        <div class="col-12" style="background-color: #c1c1c129 ;margin-top: 30px;height: 163px;">
          <div class="row align-items-center">
            <div class="col-6">
              <div class="img_catrgory">
                <div class="container9" *ngFor="let category of allCategories;let i=index">
                  <img *ngIf="category.name==='FOOD CONTAINER'" [src]="category.image" class="img-fluid rounded-start"
                    alt="..." style="width:75%;margin: 21px 17px">
                </div>
              </div>


            </div>
            <div class="col-6">
              <div class="cont_category text-center">
                <h5 class="card-text new_arr">Standard Products</h5>
                <h5 class="card-text new_arr1">Food Container</h5>
                <button class="btn btn-primary btn_size"
                  style="background-color: black!important;border: black!important;width: 105px;position:relative;top: 10px;"
                  (click)="routeToCategory('FOOD CONTAINER')">Shop now</button>

              </div>
            </div>
          </div>
        </div>
      </section>





      <!-- 



        <div class="col-12" style="background-color: #c1c1c129;height:163px;margin-top: 30px;">
          <div style="display: flex;" >
            <div class="container" style="width:80%;position:relative;right: 35px;">
              <div class="container9" *ngFor="let category of allCategories;let i=index">
                <img  *ngIf="category.name==='FOOD CONTAINER'"[src]="category.image" class="img-fluid rounded-start" alt="..."  style="height:90%;width:62%;margin-left:47px;margin-top:25px">

              </div>
            </div>
            
            <div style="position: relative;margin-top: 50px;">
              <h5 class="card-text new_arr">Standard Products</h5>
                  <h5 class="card-text new_arr1">Food Container</h5>
                  <button class="btn btn-primary btn_size" style="background-color: black!important;border: black!important;width: 105px;position:relative;top: 10px;" (click)="routeToCategory('FOOD CONTAINER')">Shop now</button>

            </div>
          
          </div>
        </div> -->




      <section>
        <div class="col-12" style="background-color: #c1c1c129;height: 163px;position: relative;margin-top: 30px;">
          <div class="row align-items-center">
            <div class="col-6">
              <div class="cont_category text-center">
                <h5 class="card-text new_arr">Standard Products</h5>
                <h5 class="card-text new_arr1">Agricultural Tray</h5>
                <button class="btn btn-primary btn_size"
                  style="background-color: black!important;border: black!important;width: 105px;position:relative;top: 10px;"
                  (click)="routeToCategory('AGRICULTURAL TRAY')">Shop now</button>


              </div>
            </div>
            <div class="col-6">
              <div class="img_catrgory">
                <div class="container9" *ngFor="let category of allCategories;let i=index">
                  <img *ngIf="category.name==='AGRICULTURAL TRAY'" [src]="category.image"
                    class="img-fluid rounded-start" alt="..." style="width:74%;margin:21px 19px;">

                </div>
              </div>
            </div>
          </div>
        </div>

      </section>














      <!-- 
        <div class="col-12" style="background-color: #c1c1c129;height:183px;position: relative;margin-top: 30px;">
          <div style="display: flex;" >
           
            
            <div style="position: relative;margin-top: 50px;white-space: nowrap;">
              <h5 class="card-text new_arr">Standard Products</h5>
                  <h5 class="card-text new_arr1">Agricultural Tray</h5>
                  <button class="btn btn-primary btn_size" style="background-color: black!important;border: black!important;width: 105px;position:relative;top: 10px;" (click)="routeToCategory('AGRICULTURAL TRAY')">Shop now</button>

            </div>
            <div class="container" style="width:80%;position:relative;">
              <div class="container9" *ngFor="let category of allCategories;let i=index">
                <img  *ngIf="category.name==='AGRICULTURAL TRAY'"[src]="category.image"  class="img-fluid rounded-start" alt="..."  style="height: 80%;width:69%;margin-top:14px;margin-left:22px">

              </div>
            </div>
          
          </div>
        </div> -->


    </section>





    <section style="background-color: #fbfbfb" *ngIf="config.title==='Vimpro'">
      <div
        style="padding: 3%; width: 80%; margin-left: 10%; display: flex; justify-content: center;font-size: 30px;font-weight: 700;">
        What makes our products special?
      </div>
      <div class="home-vimpro2">
        <div class="home-vimpro-block">
          <div class="vimpro-icon-out2">
            <img class="vimpro-home-icon" src="../../../../assets/images/vimpro/sun.png">
          </div>
          <div>
            <p class="t1-vimpro">Eco-Concious</p>
            <p class="t2-vimpro">Sustainability is our main goal, that's why our packaging is recyclable</p>
            <p routerLink="about-us"
              style="text-align: center;color: #e84c4c;text-decoration: underline; cursor: pointer;">Learn More</p>
          </div>
        </div>
        <div class="home-vimpro-block">
          <div class="vimpro-icon-out2">
            <img class="vimpro-home-icon" src="../../../../assets/images/vimpro/leaf.png">
          </div>
          <div>
            <p class="t1-vimpro">Quality Policy</p>
            <p class="t2-vimpro">Committed to supply robust Quality with reliable thermoformed and</p>
            <p routerLink="about-us"
              style="text-align: center;color: #e84c4c;text-decoration: underline; cursor: pointer;">Learn More</p>
          </div>
        </div>
        <div class="home-vimpro-block">
          <div class="vimpro-icon-out2">
            <img class="vimpro-home-icon" src="../../../../assets/images/vimpro/people.png">
          </div>
          <div>
            <p class="t1-vimpro">Our Infrastructure</p>
            <p class="t2-vimpro">Our Infrastructure is well equipped with latest technology machines </p>
            <p routerLink="about-us"
              style="text-align: center;color: #e84c4c;text-decoration: underline; cursor: pointer;">Learn More</p>
          </div>
        </div>
      </div>
    </section>
    <section class="wrapper ht_home_category" *ngIf="config.title==='Vimpro'">

      <div class="tabs-vim">
        <input type="radio" name="css-tabs" id="tab-1" checked class="tab-switch-vim ">
        <label for="tab-1" class="tab-label-vim mob-font" style="white-space: nowrap;">
          <p class="pro_list_color" (click)="routeToList1($event)" class="vimpro_list" tabindex="1">Vacuum Forming</p>
        </label>
        <input type="radio" name="css-tabs" id="tab-2" class="tab-switch-vim ">
        <label for="tab-2" class="tab-label-vim" style="white-space: nowrap;">
          <p class="pro_list_color" (click)="routeToList1($event)" class="vimpro_list" tabindex="1">PP Flute Board</p>
        </label>

        <!-- <input type="radio" name="css-tabs" id="tab-2" class="tab-switch-vim "> -->
        <!-- <label for="tab-2" class="tab-label-vim" id="Agricultural-list" ><a (click)="routeToList1($event)" class="vimpro_list"  tabindex="1">Agricultural Tray</a></label> -->

        <input type="radio" name="css-tabs" id="tab-3" class="tab-switch-vim ">
        <label for="tab-3" class="tab-label-vim" style="white-space: nowrap;">
          <p class="pro_list_color" (click)="routeToList1($event)" class="vimpro_list" tabindex="1">Foldable Crate</p>
        </label>

        <input type="radio" name="css-tabs" id="tab-4" class="tab-switch-vim ">
        <label for="tab-4" class="tab-label-vim" style="white-space: nowrap;">
          <p class="pro_list_color" (click)="routeToList1($event)" class="vimpro_list" tabindex="1">Pallet Set</p>
        </label>

        <input type="radio" name="css-tabs" id="tab-5" class="tab-switch-vim ">
        <label for="tab-5" class="tab-label-vim" id="tab-label-vim_1">
          <p class="pro_list_color" (click)="routeToList1($event)" class="vimpro_list" tabindex="1">Food Container</p>
        </label>

      </div>

      <div class="vimpro-container1">
        <div class="tab-content-vim" class="vimpro-card" *ngFor="let pro of allproducts1 | slice:0:8;;let i=index">
          <div class="container_2">
            <div class="vimpro-img">
              <img *ngIf="pro.product_type=='Variable' && pro.variant.option_values[0].child!=undefined"
                [src]="pro.variant.option_values[0].child[0].assets[0].image_source" (click)="productDetails(pro.id)"
                id="img-list" style="height: 100%;width:100%">
              <img *ngIf="pro.product_type=='Variable' && pro.variant.option_values[0].child==undefined"
                [src]="pro.variant.option_values[0].assets[0].image_source" (click)="productDetails(pro.id)"
                id="img-list" style="height: 100%;width:100%">
              <img *ngIf="pro.product_type=='Simple'" [src]="pro.assets[0].image_source"
                (click)="productDetails(pro.id)" id="img-list" style="height: 100%;width:100%">

            </div>


          </div>

          <div class="vimpro-head">
            <div class="vimpro-title h_font_title{
                font-size: 12px;
              }
              ">
              {{pro.name}}
            </div>
            <div class="inner-star-icon review-mob1 pd-1 star-height">
              <span [class]="pro && pro.reviews && pro.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'"
                style="font-size: 13px !important;color: orange !important;"></span>
              <span [class]="pro && pro.reviews && pro.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'"
                style="font-size: 13px !important;color: orange !important;"></span>
              <span [class]="pro && pro.reviews && pro.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'"
                style="font-size: 13px !important;color: orange !important;"></span>
              <span [class]="pro && pro.reviews && pro.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'"
                style="font-size: 13px !important;color: orange !important;"></span>
              <span [class]="pro && pro.reviews && pro.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'"
                style="font-size: 13px !important;color: orange !important;"></span>
              <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
            </div>
            <div class="vimpro-price" *ngIf="pro.product_type=='Simple'">
              Price will be provided on Enquiry
            </div>
            <div class="vimpro-price"
              *ngIf="pro.product_type=='Variable' && pro.variant.option_values[0].child!=undefined">
              {{pro.variant.option_values[0].child[0].pricing.raw.price}}
            </div>
            <div class="vimpro-price"
              *ngIf="pro.product_type=='Variable'&& pro.variant.option_values[0].child==undefined">
              {{pro.variant.option_values[0].pricing.raw.price}}
            </div>
          </div>
        </div>
      </div>
      <!-- (click)="routeToList($event.target.value)" -->

      <!-- <div class="tab-vim">
        <input type="radio" name="css-tabs" id="tab-3" class="tab-switch-vim ">
        <label for="tab-3" class="tab-label-vim" style="border:none !important"  style="white-space: nowrap;"><a (click)="routeToList1($event)" style="color: #2554c7!important;">Bubble guard</a></label>
        <div class="tab-content-vim">
          <div class="vimpro-container1">
            
            <div class="vimpro-card" *ngFor="let pro of allproducts1;let i=index">
              <div class="vimpro-img">
                <img [src]="pro.assets[0].image_source" (click)="productDetails(pro.id)" id="img-list" style="height: 100%;width:100%">
              </div>
              <div class="inner-star-icon review-mob pd-1">
                <span [class]="pro && pro.reviews && pro.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                <span [class]="pro && pro.reviews && pro.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                <span [class]="pro && pro.reviews && pro.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                <span [class]="pro && pro.reviews && pro.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                <span [class]="pro && pro.reviews && pro.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'" style="font-size: 13px !important;color: orange !important;"></span>
                
              </div>
              <div class="vimpro-title h_font_title">
                {{pro.name}}
              </div>
              <div class="vimpro-price">
                Price will be provided on Enquiry
              </div>
            </div>
          </div>
        </div>
      </div> -->

    </section>


    <section *ngIf="config.title === 'Kubendran'">
      <div class="top-category-container">
        <div class="text-center mb-2">
          <h3 class="text-primary" style="color: #2a7d2e!important;">Categories</h3>
          <!--<h3 class="text-primary">Shop from Top Categories</h3>-->
        </div>

        <div style="padding-left: 10px;margin-top: 17px;">
          <div class="row d-flex justify-content-center">
            <div *ngFor="let category of allCategorieskub" class="top-image-cover" style="margin-top: 15px;">
              <!-- <img class='mayantopcategory1-img' [src]="(category.image != '') ? category.image : 'assets/images/mayan/NoImage.png'" (click)="getProductByFilter(category);"> -->
              <!-- <i class="fa fa-gift fa-2x" aria-hidden="true" style="margin-left: 28px;cursor: pointer;" (click)="getFilterByProduct(category);"></i> -->
              <img class="category_images" style="object-fit: contain !important;" [src]="category.category_icon"
                (click)="getFilterByProduct(category);">
              <!-- <img style="object-fit: contain !important;" [src]="category.category_icon" style="cursor: pointer;" (click)="getFilterByProduct(category);"> -->

              <!-- <p class="topcategory-text" style="cursor: pointer;" (click)="getFilterByProduct(category);">{{category.name}}</p> -->
              <p *ngIf="active!==category.name" class="categoryList"
                style="cursor: pointer;font-weight:700;color:black;text-align: center;"
                (click)="getFilterByProduct(category);">{{category.name}}</p>
              <p *ngIf="active===category.name" class="categoryListactive" (click)="getFilterByProduct(category);">
                {{category.name}}</p>

            </div>
          </div>
        </div>
        <div *ngIf="totalLength > 0">
          <owl-carousel-o [options]="ProductSliderConfig2" class="slider rounder-corner-nav">
            <ng-container *ngFor="let product of products;let i =index">
              <ng-template carouselSlide>
                <div id="bombayhardwarecards1" style="margin-bottom: 42px;">
                  <div class="bombayhardware1 text-center">
                    <div class="bombayhardware1-img-holder" style="cursor: pointer;"
                      (click)="sendProductDetails(product.id)">
                      <div class="bombayhardware1-img text-center">
                        <img style="object-fit: contain !important;" [src]="product.assets[0].image_source">
                      </div>
                    </div>
                    <div class="bombayhardware1-description-holder">
                      <div class="bombayhardware1-title"><b style="font-size: 18px;">{{product.name}}</b></div>
                      <div class="bombayhardware1-subtitle">
                        <p style="font-weight: 900;">₹{{product.pricing.raw.price}}</p>
                      </div>
                      <div class="bombayhardware1-submit-btn">
                        <!-- <button class="btn btn-block bombayhardware-btn" (click)="submitEnquiry(product)">Submit Enquiry</button> -->
                        <!-- <button class="btn btn-block bombayhardware-btn" (click)="submitEnquiry(product)">Submit Enquiry</button> -->
                        <button
                          *ngIf="(appService.productIdinCart.indexOf(product.id) == -1 && product.product_type!='Variable') && (appService.productIdinCart.indexOf(product.id) == -1 && product.type!='Variable')"
                          class="btn btn-primary shubhcards-btn"
                          style="background-color: #2a7d2e!important;min-width: max-content;"
                          (click)="addToCart(product)">Add to Cart</button>
                        <button *ngIf="product.product_type=='Variable' ||product.type=='Variable'"
                          class="btn btn-primary earthy-btn" (click)='productDetails(product.id)'>Select
                          Options</button>
                        <!-- <button     class="btn btn-secondary listing"   *ngIf="(appService.productIdinCart.indexOf(product.id) != -1 && product.product_type!='Variable' && appService.productIdinCart.indexOf(product.id) > -1)"  routerLink="/cart">View Cart</button> -->
                        <div *ngFor="let cart of appService.cartProducts.results;let i = index">
                          <div class="btn btn-secondary inq-btn-st ml-1 viewCart"
                            style="background-color: #2a7d2e!important;min-width:max-content;"
                            *ngIf="cart.product_id === product.id || cart.product_id === product.checkVariantInCart">


                            <span>
                              <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                style="font-size:12px;cursor:pointer;"></i></span>
                            <span class="inq-sp-2" style="color: white;">{{cart.quantity}}</span>
                            <span>
                              <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                style="font-size:12px;cursor:pointer;"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
        <div *ngIf="totalLength < 1">

          <ng-container>
            <div id="bombayhardwarecards1" style="margin-top: 22px;">
              <div class="bombayhardware1 text-center">
                <div class="bombayhardware1-img-holder" style="cursor: pointer;">
                  <div class="bombayhardware1-img text-center">
                    <h3 class="text-primary">Sorry No Data Found</h3>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>

        </div>

        <!-- <div class="text-center mb-2" style="margin-top:40px"> -->
        <!-- <p class="mayanwelcom-text">FEATURED @ BEST GIFTS</p> -->
        <!--<h3 class="text-primary">Shop from Top Categories</h3>-->
        <!-- </div> -->
      </div>
    </section>
    <section *ngIf="config.title === 'BestGifts'" style="margin-bottom: 30px;">
      <div>
        <h2 class="content-title title-box title main-title"
          style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #2661a0;padding-top: 0px; margin-top: -25px;">
          Our Categories
        </h2>
      </div>
      <div>
        <div class="home-container3">
          <div *ngFor="let cate of allCategories3 ;let i = index">
            <div style="transition: none !important;cursor: pointer;" class="isempty">
              <div>
                <div class="home-card" style="padding: 10px;" (click)="productsListBest(cate)">
                  <div class="text-centre" style="height: 200px">
                    <div class="card-heading" style="background-color: #e594a4!important;font-weight: 700!important;">
                      {{cate.name | titlecase }}
                    </div>
                    <div style="width:100%">
                      <img style="height: 148px; object-fit: contain;width:100% !important" [src]="cate.image">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="cursor: pointer;">
            <div class="home-card" style="padding: 10px;" (click)="productsListTazTest()">
              <div class="text-centre " style="height: 200px">
                <div class="card-heading" style="background-color: #e594a4!important;font-weight: 700!important;">
                  All Categories
                </div>
                <div style="width:100%">
                  <img style="height: 148px; object-fit: contain;width:100% !important"
                    src="https://ecbee-labes-images.s3.ap-south-1.amazonaws.com/Bestgifts/StoreGallery/1686725196621%20-%20bestgifts.png">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section *ngIf="config.title === 'BestGifts'">
      <div class="top-category-container">
        <!-- <div class="text-center mb-2">
          <h3 class="text-primary" style="color: #2661a0!important;">Our Categories</h3>
      </div> -->

        <!-- <div  style="padding-left: 10px;margin-top: 17px;" class="category_list">
              
                <div class="row d-flex justify-content-center">
                  <div *ngFor="let category of allCategories3" class="top-image-cover category-name" style="margin-top: 15px;text-align: center !important;">
                     
                      <span class="d-flex justify-content-center">
                        <img class="bestgift-category-image" [src]="category.image" style="cursor: pointer;" (click)="routeToList(category);">
                      </span>
                    
                      <p class="categoryList" style="cursor: pointer;font-weight:700;color:black" (click)="routeToList(category);">{{category.name}}</p>

                    </div>
                    </div>
              </div>
              <div  style="padding-left: 10px;margin-top: 17px;" class="category_list1">
                <div *ngFor="let category of allCategories3" style="text-align: center!important;">                      
                  <p style="cursor: pointer;font-weight:700;margin-top: 15px;color:black" (click)="routeToList(category);">{{category.name}}</p>
                </div>
                </div> -->
        <!-- <div class="text-center mb-2 category_list">
              <h3 class="text-primary" style="color: #2661a0!important;margin-top: 4%!important;">New Arrivals</h3>
          </div>
          <div class="text-center mb-2 category_list1">
            <h3 class="text-primary" style="color: #2661a0!important;margin-top: 6%!important;font-size: 8vw!important;">New Arrivals</h3>
        </div> -->


        <!-- <div  style="padding-left: 10px;margin-top: 17px;" class="category_list">
                 
                    <div class="row d-flex justify-content-center">
                      <div *ngFor="let category of allCategories2" class="top-image-cover category-name" style="margin-top: 15px;text-align: center !important;">
                        
                          <span class="d-flex justify-content-center">
                            <img class="bestgift-category-image" [src]="category.image" style="cursor: pointer;" (click)="getFilterByProduct(category);">
                          </span>
                         
                          <p *ngIf="active!==category.name" class="categoryList" style="cursor: pointer;font-weight:700;color:black" (click)="getFilterByProduct(category);">{{category.name}}</p>
                          <p *ngIf="active===category.name" class="categoryList" style="cursor: pointer;font-weight:700;color:#ed98d2" (click)="getFilterByProduct(category);">{{category.name}}</p>

                        </div>
                        </div>
                  </div> -->
        <!-- <div  style="padding-left: 10px;margin-top: 17px;" class="category_list1">
                    <div *ngFor="let category of allCategories2" style="text-align: center!important;">                      
                      <p *ngIf="active!==category.name"  style="cursor: pointer;font-weight:700;margin-top: 15px;color:black" (click)="getFilterByProduct(category);">{{category.name}}</p>
                      <p *ngIf="active===category.name"  style="cursor: pointer;font-weight:700;margin-top: 15px;color:#ed98d2" (click)="getFilterByProduct(category);">{{category.name}}</p>

                    </div>
                    </div> -->
        <!-- <div *ngIf="totalLength > 0" style="margin-top: 20px;">
                <owl-carousel-o [options]="ProductSliderConfig1" class="slider rounder-corner-nav" >
                  <ng-container 
                    *ngFor="let product of products;let i =index"
                  >
                    <ng-template carouselSlide>
                      <div id="bombayhardwarecards1" style="margin-top: 42px;">
                        <div class="bombayhardware1 text-center">
                            <div class="bombayhardware2-img-holder" style="cursor: pointer;" (click)="sendProductDetails(product.id)">
                                <div class="bombayhardware1-img text-center">
                                    <img style="object-fit: contain !important;"  class="bestgift-image" [src]="product.assets[0].image_source">
                                </div>
                            </div>
                            <div class="bombayhardware1-description-holder">
                                <div class="bombayhardware2-title"><b>{{product.name}}</b></div>
                                <div class="bombayhardware1-subtitle"><b>₹{{product.pricing.raw.price}}</b></div>
                                <div class="bombayhardware2-submit-btn">
                                   
                                                             <button class="btn btn-primary shubhcards-btn" style="background-color: #ed98d2!important;" (click)="sendProductDetails(product.id)">Go To Details</button>

                                                              </div>
                            </div>
                        </div>
                    </div>                   
                    </ng-template>                 
                  </ng-container>
                </owl-carousel-o>            
            </div>
            <div *ngIf="totalLength < 1">
              
                <ng-container>
                  <div id="bombayhardwarecards1" style="margin-top: 22px;">
                    <div class="bombayhardware1 text-center">
                        <div class="bombayhardware2-img-holder" style="cursor: pointer;">
                            <div class="bombayhardware1-img text-center">
                              <h3 class="text-primary">Sorry No Data Found</h3>   
                            </div>
                        </div>
                
                    </div>
                </div>        
                </ng-container>
              
            </div> -->
        <!-- <div class="row">
              <div class="col-md-5" style="margin-top: 15px;">
                  <img src="assets/images/bestgifts/category1.png" style="width: 77%;">
              </div>
              <div class="col-md-7">
                  <div class="text-center mb-2" style="margin-top:55px">
                      <h3 class="text-primary text-left" style="color: #2661a0!important;">Our general product and design philosophy</h3>
                      <p class="font-weight-light text-left">Today when we think of frames we think of an object used to hold pieces of art, photographs or</p>
                      <p class="font-weight-light text-left">documents,however,they were once considered to be a vital part of the piece they were holding, and sometimes even</p>
                      <p class="font-weight-light text-left">a work of art themselves.Emphasis was often put on matching a frame to the architecture and style of the space where </p>
                      <p class="font-weight-light text-left"> it would be placed rather than solely considering the artwork it would hold. Often frames were actually built before</p>
                      <p class="font-weight-light text-left"> they had a piece to be put in them, and then the art work would be created to the perfect size. Today, in contrast,</p>
                      <p class="font-weight-light text-left">Today, people normally do not want the frames to take any focus away from what they are displaying.</p> 
                      <p class="font-weight-light text-left">Across the centuries, caricatures have evolved into their own interesting art form that can be loved by people of all</p>
                      <p class="font-weight-light text-left">ages. Now, you can enjoy a personalized caricature of you and your family in your own home. Mark Hall Caricature Art</p>
                      <p class="font-weight-light text-left">is excited to be a part of your special event whether you are planning a birthday, anniversary, corporate retreat, wedding or any other type of gathering.</p>
                      <button type="button" (click)="goto()" class="btn btn-outline-primary btn-rounded" style="float: left;;margin-top: 10px;">KNOW MORE</button>
  
                  </div>
              </div>
          </div> -->
        <!-- <div class="row">
              <div class="col-md-7">
                  <div class="text-center mb-2" style="margin-top:55px">
                      <h3 class="text-primary text-left" style="color: #2661a0!important;">Best Gifts Products</h3>
                      <p class="font-weight-light text-left">These printed key rings are the best gifts that can be given to your loved ones, friends and family. This is a very </p>
                      <p class="font-weight-light text-left">personal and special product - as it has your photo, text printed on it. The print is completely permanent and will never</p>
                      <p class="font-weight-light text-left">fade off. The keychains are available in various shapes, all of them can be customized exactly as per your preference.</p>
                      <p class="font-weight-light text-left">You can design the key chain yourself.Consumers enjoy choice in their purchase of a product or service and</p>
                      <p class="font-weight-light text-left">customized goods invite them to engage with a sale even more. With the rise in online retail and mass customization </p>
                      <p class="font-weight-light text-left">in manufacturing, more businesses across nearly every industry offer elements of customization for their goods and</p>
                      <p class="font-weight-light text-left"> services. Learning about product customization and how you can apply it in business can help you in your career, even</p>
                      <p class="font-weight-light text-left"> in a variety of industries or fields. In this article, we explore what product customization is, give examples of it and discover five benefits for companies to offer customized products or services.</p>
                      <p class="font-weight-light text-left">Customization of a product is the manufacturing ability to offer a variety of designs or details for one product, made</p> 
                      <p class="font-weight-light text-left">specifically to a buyer's liking, much in part because of advances in technology and manufacturing production.</p>
                      <p class="font-weight-light text-left">processes Several online photo printing sites let customers create photo books, prints, personalized greeting cards, </p>
                      <p class="font-weight-light text-left">canvas, stationary,gifts and more using their own photographs and digital images. You can select everything from</p>
                      <p class="font-weight-light text-left">layout,typeface, colors,phrases and wording, designs and quantity. There is even an app feature that pre-selects images </p>
                      <p class="font-weight-light text-left">from your phone's camera roll to show you what a potential design or purchase can look like to encourage a sale.</p>

                      <button type="button" (click)="goto()" class="btn btn-outline-primary btn-rounded" style="float: right;margin-top: 10px;">LEARN MORE</button>
                  </div>
              </div>
              <div class="col-md-5 img_height">
                  <img src="assets/images/bestgifts/category2.png" style="width: 65%;">
              </div>
          </div> -->

        <!-- <div class="text-center mb-2" style="margin-top:40px"> -->
        <!-- <p class="mayanwelcom-text">FEATURED @ BEST GIFTS</p> -->
        <!--<h3 class="text-primary">Shop from Top Categories</h3>-->
        <!-- </div> -->
      </div>
    </section>



    <section *ngIf="config.title === 'AvonSeals'" style="margin-bottom: 30px;">
      <div style="display: flex;justify-content: center;">
        <!-- <h2 class="content-title title-box title main-title" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -25px;">
        Our Products
       </h2> -->
        <div class="avon_line" *ngIf="config.title == 'AvonSeals'">
        </div>
      </div>
      <div>
        <!-- <p class="content-title title-box title main-title" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: 10px;font-size: 20px;">
        Shop By Seals
      </p>  -->
      </div>
      <div class="title-div" style="display: grid; justify-content: center;">
        <p class="avon_cont" *ngIf="config.title === 'AvonSeals'">
          Shop By Seals<br>
        </p>

      </div>
      <div class="title-div avon-title3">
        <p class="content-title2 title-box title main-title" *ngIf="config.title === 'AvonSeals'">
          India's Largest Manufacturer of Mechanical Seals
        </p>
      </div>
      <div style="display: flex;justify-content: center;">
        <p *ngIf="config.title === 'AvonSeals'" class="content-title title-box title main-title"
          style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: 0px;font-size: 18px;width: 55%;">
          Avon Seals Pvt. Ltd. is one of the largest Indian manufacturer of Mechanical Seals for Agricultural, Domestic
          and Automotive Water Pump. The company pioneered the introduction of seals, which are immune to dry running of
          pumps, in India.
        </p>
      </div>
      <div *ngIf="totalLength > 0">
        <owl-carousel-o [options]="ProductSliderConfig" class="slider1 rounder-corner-nav">
          <ng-container class="prodinfo" style="margin-left: 2%!important;"
            *ngFor="let product of recommededProducts; let i = index">
            <ng-template carouselSlide>
              <br>
              <br>
              <div class="product-list-cards-avonseals1" style="color: lightgray">
                <div class="avon1-img">
                  <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                    onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                    class="product-list-image-avonseals" />
                </div>
                <div class="product-list-description-deera">
                  <div style="display:flex;justify-content: center;margin-left: -3%;">
                    <div class="d-flex avon_prodname">

                      <div>
                        <p (click)="productDetails(product.id)" class="product-list-tile-avon">{{product.name}}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex" style="margin-bottom: 10px;justify-content: center;">
                    <button class="avon-atc1" style="border-radius: 25px!important;padding: 5px;"
                      (click)="productDetails(product.id)">
                      BUY NOW
                      <span> <i class="fa fa-shopping-cart"></i></span>
                    </button>
                  </div>
                </div>

              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
      <div class="row avonHome" style="margin-top: 55px;">
        <div class="col-md-3">
          <!-- <img src="assets/images/avonseals/factory.jpg" style="width: 100%;height: 92%;"> -->
          <div style="position:relative;padding-top:20px;display:inline-block;">
            <span style="position: absolute;
          right:-20px;
          top:10px;
          background:#d11ae6;
          text-align: center;
          border-radius: 30px 30px -1px 0px;
          color:white;
          padding:5px 10px;
          font-size:20px;">SHOP FLOOR</span>
            <img src="assets/images/avonseals/Shop Floor 1.jpg" style="width: 100%;height: 92%;" />
          </div>
        </div>
        <div class="col-md-7" style="margin-top: 25px;">
          <div style="display: flex;justify-content: center;">
            <!-- <h2 class="content-title title-box title main-title" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -25px;">
            Our Products
           </h2> -->
            <div style="border-left: 3px solid black;
            height: 40px;">
            </div>
          </div>
          <div>
            <!-- <p class="content-title title-box title main-title" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: 10px;font-size: 20px;">
            CUSTOMIZED DESIGNS
          </p>  -->
          </div>
          <div style="display: flex;justify-content: center;">
            <p class="content-title title-box main-title avon_cont2" *ngIf="config.title=='AvonSeals'">
              At the forefront of providing quality Mechanical Seals for agriculture, automotive and domestic pumps
            </p>
          </div>
          <div>
            <p class="content-title title-box title main-title" *ngIf="config.title=='AvonSeals'"
              style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -18px;font-size: 18px;">
              The high degree of dependability of the product has enabled the company to win the confidence of almost
              all the big names In the above mentioned segments of the Indian Pump Industry
            </p>
          </div>
        </div>
        <div class="col-md-2">
          <img src="assets/images/avonseals/Lab 4.jpg" class="avonhomeimage">
        </div>
      </div>


      <div class="row avonHome1" style="margin-top: 55px;">
        <div class="col-md-3" style="margin-top: 2%;">
          <!-- <img src="assets/images/avonseals/factory.jpg" style="width: 100%;height: 92%;"> -->
          <div style="position:relative;padding-top:20px;display:inline-block;">

            <img src="assets/images/avonseals/Shop Floor 1.jpg" style="width: 100%;height: 92%;" />
          </div>
        </div>
        <div class="col-md-7" style="margin-top: 25px;">
          <div style="display: flex;justify-content: center;">
            <!-- <h2 class="content-title title-box title main-title" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -25px;">
            Our Products
           </h2> -->
            <div style="border-left: 3px solid black;
            height: 40px;">
            </div>
          </div>
          <div>
            <!-- <p class="content-title title-box title main-title" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: 10px;font-size: 20px;">
            CUSTOMIZED DESIGNS
          </p>  -->
          </div>
          <div style="display: flex;justify-content: center;">
            <p class="content-title title-box main-title avon_cont2">
              At the forefront of providing quality Mechanical Seals for agriculture, automotive and domestic pumps
            </p>
          </div>
          <div>
            <p class="content-title title-box title main-title"
              style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -18px;font-size: 18px;">
              The high degree of dependability of the product has enabled the company to win the confidence of almost
              all the big names In the above mentioned segments of the Indian Pump Industry
            </p>
          </div>
        </div>
        <div class="col-md-2">
          <img src="assets/images/avonseals/Lab 4.jpg" class="avonhomeimage">
        </div>
      </div>
      <div class="row avonHome2" style="margin-top: 55px;">
        <div class="col-md-3" style="margin-top: 6%;">
          <!-- <img src="assets/images/avonseals/factory.jpg" style="width: 100%;height: 92%;"> -->
          <div style="position:relative;padding-top:20px;display:inline-block;">
            <span style="position: absolute;
          right:-20px;
          top:10px;
          background:#d11ae6;
          text-align: center;
          border-radius: 30px 30px -1px 0px;
          color:white;
          padding:5px 10px;
          font-size:20px;">SHOP FLOOR</span>
            <img src="assets/images/avonseals/Shop Floor 1.jpg" style="width: 100%;height: 92%;" />
          </div>

        </div>
        <div class="col-md-7" style="margin-top: 25px;">
          <div style="display: flex;justify-content: center;">
            <!-- <h2 class="content-title title-box title main-title" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -25px;">
            Our Products
           </h2> -->
            <div style="border-left: 3px solid black;
            height: 40px;">
            </div>
          </div>
          <div>
            <!-- <p class="content-title title-box title main-title" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: 10px;font-size: 20px;">
            CUSTOMIZED DESIGNS
          </p>  -->
          </div>
          <div style="display: flex;justify-content: center;">
            <p class="content-title title-box main-title avon_cont2">
              At the forefront of providing quality Mechanical Seals for agriculture, automotive and domestic pumps
            </p>
          </div>
          <div>
            <p class="content-title title-box title main-title"
              style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -18px;font-size: 18px;">
              The high degree of dependability of the product has enabled the company to win the confidence of almost
              all the big names In the above mentioned segments of the Indian Pump Industry
            </p>
          </div>
        </div>
        <div class="col-md-2">
          <img src="assets/images/avonseals/Lab 4.jpg" class="avonhomeimage">
        </div>
      </div>
      <div class="row avonHome3" style="margin-top: 55px;">
        <div class="col-md-3" style="margin-top: 7%;">
          <!-- <img src="assets/images/avonseals/factory.jpg" style="width: 100%;height: 92%;"> -->
          <div style="position:relative;padding-top:20px;display:inline-block;">
            <span style="position: absolute;
          right:-20px;
          top:10px;
          background:#d11ae6;
          text-align: center;
          border-radius: 30px 30px -1px 0px;
          color:white;
          padding:5px 10px;
          font-size:20px;">SHOP FLOOR</span>
            <img src="assets/images/avonseals/Shop Floor 1.jpg" style="width: 100%;height: 92%;" />
          </div>
        </div>
        <div class="col-md-7" style="margin-top: 25px;">
          <div style="display: flex;justify-content: center;">
            <!-- <h2 class="content-title title-box title main-title" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -25px;">
            Our Products
           </h2> -->
            <div style="border-left: 3px solid black;
            height: 40px;">
            </div>
          </div>
          <div>
            <!-- <p class="content-title title-box title main-title" style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: 10px;font-size: 20px;">
            CUSTOMIZED DESIGNS
          </p>  -->
          </div>
          <div style="display: flex;justify-content: center;">
            <p class="content-title title-box main-title avon_cont2">
              At the forefront of providing quality Mechanical Seals for agriculture, automotive and domestic pumps
            </p>
          </div>
          <div>
            <p class="content-title title-box title main-title"
              style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -18px;font-size: 18px;">
              The high degree of dependability of the product has enabled the company to win the confidence of almost
              all the big names In the above mentioned segments of the Indian Pump Industry
            </p>
          </div>
        </div>
        <div class="col-md-2">
          <img src="assets/images/avonseals/Lab 4.jpg" class="avonhomeimage">
        </div>
      </div>
      <hr width="100%;" color="black" size="10" style="border-top: 3px solid rgba(0,0,0,.1);">
    </section>
    <div class="row" *ngIf="config.title === 'AvonSeals'">
      <span class="col-md-12" style="font-size: 33px;
    font-weight: 900;text-align: center;text-shadow: none;
    font-family: 'proxima-regular','sans-serif'!important;
    color: #373230;" *ngIf="config.title === 'AvonSeals'">Our Seals Applications</span>
    </div>

    <!-- <section class="product-title" style="margin-left: 10%; width: 80%;" *ngIf="config.title === 'AvonSeals'">
    
    <owl-carousel-o [options]="ProductSliderConfig" class="slider rounder-corner-nav">   
       
      <ng-container class="prodinfo" *ngFor="let product of featuredAvonProductsCollection;let i =index">
        <ng-template carouselSlide >
        <div class="product-list-avon1" style="color: lightgray;">
          <div class="avon-img" style="width: auto;
          height: 428px">
        <img [src]="product.image" id="img-list"
        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.title }}"
        class="product-list-image-avonseals" style="display: initial;"/>
      </div>
      </div>
      </ng-template>
</ng-container>          
</owl-carousel-o>
</section> -->

    <section *ngIf="config.title === 'AvonSeals'" style="margin-bottom: 30px;">
      <div>
        <div class="home-container7">
          <div *ngFor="let pro of featuredAvonProductsCollection ;let i = index">
            <div style="transition: none !important;cursor: pointer;height: 450px;" class="isempty">
              <div>
                <div class="home-card" style="padding: 10px;height: 450px;">
                  <div style="height: 450px">

                    <div style="width:100%">
                      <img style="height: 425px; object-fit: contain;width:100% !important" [src]="pro.image"
                        (click)="avonListRouting()">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section *ngIf="config.title === 'AvonSeals'">
      <div class="top-category-container">
            <div class="row">
              <div class="col-md-5" style="margin-top: 15px;">
                  <img src="assets/images/avonseals/ISO.png" style="width: 77%;height: 100%;">
              </div>
              <div class="col-md-7">
                  <div class="text-center mb-2" style="margin-top:55px">
                      <h3 class="text-primary text-left" style="color: #373230!important;">ISO Certified</h3>
                      <p class="font-weight-light text-left">The company has implemented the quality systems conforming</p>
                      <p class="font-weight-light text-left">to ISO 9001:2000 since May 2003 (presently ISO 9001:2015) and is certified by DAS Certification, UK.</p>
                      <p class="font-weight-light text-left">The company produces all seal components (except spring and ceramic seal face) in-house</p>
                      <p class="font-weight-light text-left">which ensures highest component quality and thereby ultimate product reliability.</p>
                      
  
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col-md-7">
                  <div class="text-center mb-2" style="margin-top:55px">
                      <h3 class="text-primary text-left" style="color: #373230!important;">Our Factory</h3>
                      <p class="font-weight-light text-left">Covering over 20,000 Sq Ft. and equipped with most modern manufacturing machineries as well as sophisticated testing equipments,</p>
                      <p class="font-weight-light text-left">Avon Seals is the largest manufacturer of Mechanical Seals for the domestic and agricultural pumps in India.</p>
                      <p class="font-weight-light text-left">Avon Seals Private Limited is the largest manufacturer of Mechanical Seals for the domestic and agricultural pumps in India and is situated at G-1 & G-2,Ambattur Industrial Estate, Chennai, South India.</p>
                      <p class="font-weight-light text-left">Today, the company caters to more than 70% of the OEM segment of domestic and agricultural pump sector in India. In export front, the company caters to</p>
                      <p class="font-weight-light text-left">many discerning customers both in the developing as well as developed countries. Moreover, the company exports Mechanical Seals to two European</p>
                      <p class="font-weight-light text-left">and one US Seal manufacturers, which are being marketed world over by those companies.</p>
                     

                  </div>
              </div>
              <div class="col-md-5">
                  <img src="assets/images/avonseals/factory.jpg" style="width: 95%;height: 100%;">
              </div>
          </div>
  
         
      </div>
  </section> -->

  </div>
  <div class="container1" *ngIf="config.title==='ShubhCards' ">
    <section class="ShubhCards-homepage-grid">
      <div class="homepage-grid">

        <div class="grid-item" (click)="productsListTazTest1('Premium')">
          <img style="width:100%; height:45rem;margin-top:-1rem;object-fit:cover;cursor: pointer;"
            src="../../../../assets/images/ShubhCards/premium.jpg">
          <!-- <div class="owl-next"><i class="fa fa-angle-down"></i></div> -->
          <!-- <img class="overlay-image" src="../../../../assets/images/ShubhCards/categoryone.jpg"> -->
          <a class="owl-next-button" style="cursor: pointer;">
            <i class="fa fa-angle-right i-c" style="font-weight:100;"></i>
          </a>
        </div>
        <div class="grid-item" (click)="productsListTazTest1('Elite')">
          <img style="width:100%; height: 45rem;margin-top:-1rem;object-fit:cover;cursor: pointer;"
            src="../../../../assets/images/ShubhCards/elite.jpg">
          <!-- <img class="overlay-image" src="../../../../assets/images/ShubhCards/category2 - Copy (2).jpg"> -->
          <a class="owl-next-button elite" style="cursor: pointer;">
            <i class="fa fa-angle-right i-c" style="font-weight:100;"></i>
          </a>
        </div>
        <div class="grid-item" (click)="routeToListshub('Classic')">
          <img style="width:100%; height: 45rem;margin-top:-1rem;object-fit:cover;cursor: pointer;"
            src="../../../../assets/images/ShubhCards/classic.jpg">
        </div>
        <div class="grid-item" (click)="routeToListshub('Luxury')">
          <img style="width:100%; height: 45rem;margin-top:-1rem;object-fit:cover;cursor: pointer;"
            src="../../../../assets/images/ShubhCards/luxury.jpg" class="align-bottom">
          <!-- <img class="overlay-image" src="../../../../assets/images/ShubhCards/category4 - Copy (2).jpg"> -->
          <a class="owl-next-button luxury" style="cursor: pointer;">
            <i class="fa fa-angle-right i-c" style="font-weight:100;"></i>
          </a>
        </div>
        <div class="grid-item video desktop-only">
          <video #videoPlayerDesktop controls style="width:100%; height: 45rem; margin-top: -1rem; object-fit: cover;"
            class="desktop-only">
            <source src="../../../../assets/images/ShubhCards/anvitha_&_rakshit__invite_by_shubh_cards (Original).mp4"
              type="video/mp4">
          </video>
          <!-- <video #videoPlayerMobile controls style="width:100%; margin-top: -1rem; object-fit: cover;" class="mobile-only">
              <source src="../../../../assets/images/ShubhCards/Untitled design.mp4" type="video/mp4">
            </video> -->
          <div class="video-controls" (click)="toggleVideo()" [hidden]="hideOverlay">
            <i class="play-pause-icon fa fa-play"></i>
          </div>
          <img class="overlay-image video-image1" src="../../../../assets/images/ShubhCards/shubhcard_.jpg"
            [hidden]="hideOverlay">
          <img class="overlay-image video-image" src="../../../../assets/images/ShubhCards/video-img.png"
            [hidden]="hideOverlay">
        </div>
        <div class="grid-item video mobile-only">
          <!-- <video #videoPlayerDesktop controls style="width:100%; height: 45rem; margin-top: -1rem; object-fit: cover;" class="desktop-only">
              <source src="../../../../assets/images/ShubhCards/anvitha_&_rakshit__invite_by_shubh_cards (Original).mp4" type="video/mp4">
            </video> -->
          <video #videoPlayerMobile controls style="width:100%; margin-top: -3rem; object-fit: cover;"
            class="mobile-only">
            <source src="../../../../assets/images/ShubhCards/anvitha_&_rakshit__invite_by_shubh_cards (Original).mp4" type="video/mp4">
          </video>
          <div class="video-controls" (click)="toggleVideo1()" [hidden]="hideOverlay">
            <i class="play-pause-icon fa fa-play"></i>
          </div>
          <img class="overlay-image video-image1" src="../../../../assets/images/ShubhCards/shubhcard_.jpg"
            [hidden]="hideOverlay">
          <img class="overlay-image video-image" src="../../../../assets/images/ShubhCards/video-img.png"
            [hidden]="hideOverlay">
        </div>
      </div>
    </section>
  </div>
  <section *ngIf="config.title === 'LushNGreen'">
    <div class="baby-age">
      <div class="product-list-description-baby">
        <div class="product-center-baby22">
          <div>
            <img src="../../../../assets/images/lushngreen/LnG-icon-1.png" 
              class="product-list-image-baby" />
          </div>
          <div class="d-flex avon_prodname">

            <div style="width: 100%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Bestsellers
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="product-list-description-baby">
        <div class="product-center-baby22">
          <div>
            <img src="../../../../assets/images/lushngreen/LnG-icon-2.png"
              class="product-list-image-baby" />
          </div>
          <div class="d-flex avon_prodname">

            <div style="width: 100%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Easy to Care
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="product-list-description-baby">
        <div class="product-center-baby22">
          <div>
            <img src="../../../../assets/images/lushngreen/LUSHNGREEN_.png"
              class="product-list-image-baby">
          </div>
          <div class="d-flex avon_prodname">

            <div style="width: 100%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Subscription
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="product-list-description-baby">
        <div class="product-center-baby22">
          <div>
            <img src="../../../../assets/images/lushngreen/LnG-icon-4.png"
              class="product-list-image-baby">
          </div>
          <div class="d-flex avon_prodname">

            <div style="width: 100%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Pots
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="product-list-description-baby">
        <div class="product-center-baby22">
          <div>
            <img src="../../../../assets/images/lushngreen/LnG-icon-5.png"
              class="product-list-image-baby">
          </div>
          <div class="d-flex avon_prodname">

            <div style="width: 100%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Seeds
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="product-list-description-baby">
        <div class="product-center-baby22">
          <div>
            <img src="../../../../assets/images/lushngreen/LnG-icon-6.png"
              class="product-list-image-baby">
          </div>
          <div class="d-flex avon_prodname">

            <div style="width: 100%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Fertilizers
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="lushhomesec-1">
      <div class="lushhomecard-1" id="precies12">
        <div class="">
          <div class="">
              <img src="../../../../assets/images/lushngreen/LnG-image-1.jpg" alt="" style="width: 100%;">
          </div>
          <div class="lushoverlay">
              <div class="container container_vimpro">
                <p class="lushovertext1">Plants</p>
                <p class="lushovertext2">Only On Our Store</p>
                <button class="btlush" (click)="productsListTazTest1('Plants')">EXPLORE ALL</button>
              </div>
          </div>
        </div>
      </div>
      <div class="lushhomecard-1 lushCardMarTB" id="precies12">
            <div class="">
              <img src="../../../../assets/images/lushngreen/LnG-image-2.jpg" alt="" style="width: 100%;">
          <div class="lushoverlay">
            <div class="">
              <div class="container container_vimpro">
                <p class="lushovertext1">Stands</p>
                <p class="lushovertext2">Only On Our Store</p>
                <button class="btlush" (click)="productsListTazTest1('Stand')">EXPLORE ALL</button>
              </div>


            </div>
          </div>
        </div>

      </div>
    </div>
    <div>
      <div class="lushhomebes1">BEST SELLER</div>
      <div style="display: flex;justify-content: center;">
        <hr style="border: 1.5px solid #a5c30b;width: 90px; margin-top: 5px;">
      </div>
      <div class="lushhomebes2">Best Seller Product This Week</div>
      <div class="desktop-only lushbests">
        <div class="thumb2-lush">
          <div *ngFor="let product of recommededProductsLush; let i = index">
            <div style="width: 90%;">

              <div class="inq-pro-sec-st listProducthome">

              <div class="product-list-cards-Lushnn" style=" margin-top: 15px;width: 100%;">

                  <div class="deera-img button-overlay" style="width: 100%; cursor: pointer;"
                    (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">

                    <img [src]="product.assets[0].image_source" id="img-list"
                      (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                      class="newcollection-image-baby" width="100%" />
                  </div>

                  <div class="product-list-description-baby1" style="width: 100%;">
                    <div class="d-flex" style="cursor: pointer;justify-content: center;"
                      (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                      <!-- <div class="d-flex justify-content-between" style="cursor: pointer;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"> -->
                      <div>
                        <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                          class="baby-newcol-name"> {{product.name}}
                        </p>
                      </div>
                    </div>

                    <div class="d-flex mt-1" style="justify-content: center;">

                      <span class="col-right">
                        <div style="display: flex;">

                          <p class="baby-newcol-price"> ₹{{product.pricing.raw.price}}
                          </p>
                          <span class="lush-strikehome">₹{{product.pricing.raw.msrp}}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="mobile-only lushbests">
        <div class="thumb2-lush">
          <div *ngFor="let product of recommededProductsLush; let i = index" style="display: flex;justify-content: center;">
            <div style="width: 95%;">

              <div class="inq-pro-sec-st listProducthome">

              <div class="product-list-cards-Lushnn" style=" margin-top: 15px;width: 100%;">

                  <div class="deera-img button-overlay" style="width: 100%; cursor: pointer;"
                    (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">

                    <img [src]="product.assets[0].image_source" id="img-list"
                      (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                      class="newcollection-image-baby" width="100%" />
                  </div>

                  <div class="product-list-description-baby1" style="width: 100%;">
                    <div class="d-flex" style="cursor: pointer;justify-content: center;"
                      (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                      <!-- <div class="d-flex justify-content-between" style="cursor: pointer;" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"> -->
                      <div>
                        <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                          class="baby-newcol-name"> {{product.name}}
                        </p>
                      </div>
                    </div>

                    <div class="d-flex mt-1" style="justify-content: center;">

                      <span class="col-right">
                        <div style="display: flex;">

                          <p class="baby-newcol-price"> ₹{{product.pricing.raw.price}}
                          </p>
                          <span class="lush-strikehome">₹{{product.pricing.raw.msrp}}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="lushbanho">
      <img src="../../../../assets/images/lushngreen/LnG-Ad-Screen.jpg" style="width: 100%;">
    </div>
    <div class="lushoverlay1">
      <div class="">
        <div class="container container_vimpro">
          <button class="btlush1" (click)="productsListLush('Plants')">SHOP NOW</button>
        </div>
      </div>
    </div>
    <div style="margin-top: 50px;">
      <div class="lushhomebes1">HOT DEALS</div>
      <div style="display: flex;justify-content: center;">
        <hr style="border: 1.5px solid #a5c30b;width: 90px; margin-top: 5px;">
      </div>
      <div class="lushhomebes2">Don't Miss Today's Deals</div>
      <div class="desktop-only" style="margin-left: 3%; margin-right: 3%; margin-top: 20px;">
        <owl-carousel-o [options]="ProductSliderConfig8" class="slider2 rounder-corner-nav" style="width: 92%;">

          <ng-container class="revinfo" *ngFor="let product of newArrival; let i = index">
            <ng-template carouselSlide>
              <div style="width: 100%;display: flex;justify-content: center;">

                <div class="inq-pro-sec-st listProducthome22">

                  <div class="product-list-cards-baby2" style=" margin-top: 15px;width: 100%;">

                    <div class="deera-img button-overlay" style="width: 100%;cursor: pointer;"
                      (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">

                      <img [src]="product.assets[0].image_source" class="newcollection-image-baby" width="100%" />
                    </div>

                    <div class="product-list-description-baby1" style="width: 100%;cursor: pointer;">
                      <div class="d-flex" style="cursor: pointer;justify-content: center;"
                        (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                        <div>
                          <p class="baby-newcol-name"> {{product.name}}
                          </p>
                        </div>
                      </div>

                      <div class="d-flex mt-1" style="justify-content: center;">

                        <span class="col-right">
                          <div style="display: flex;">

                            <p class="baby-newcol-price"> ₹{{product.pricing.raw.price}}.00
                            </p>
                            <span
                              style="font-size: 13px !important;margin-right: 5px !important;margin-top: 1%; text-decoration: line-through;color: #8080806e !important;">₹{{product.pricing.raw.msrp}}.00</span>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>

        </owl-carousel-o>
      </div>
      <div class="mobile-only" style="margin-top: 20px;">
        <owl-carousel-o [options]="ProductSliderConfig6" class="slider2 rounder-corner-nav" style="width: 92%;">

          <ng-container class="revinfo" *ngFor="let product of newArrival; let i = index">
            <ng-template carouselSlide>
              <div style="width: 95%;display: flex;justify-content: center;">

                <div class="inq-pro-sec-st listProducthome22">

                  <div class="product-list-cards-Lush2" style=" margin-top: 15px;width: 100%;">

                    <div class="deera-img button-overlay" style="width: 100%;cursor: pointer;"
                      (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">

                      <img [src]="product.assets[0].image_source" class="newcollection-image-baby" width="100%" />
                    </div>

                    <div class="product-list-description-baby1" style="width: 100%;cursor: pointer;">
                      <div class="d-flex" style="cursor: pointer;justify-content: center;"
                        (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                        <div>
                          <p class="baby-newcol-name"> {{product.name}}
                          </p>
                        </div>
                      </div>

                      <div class="d-flex mt-1" style="justify-content: center;">

                        <span class="col-right">
                          <div style="display: flex;">

                            <p class="baby-newcol-price"> ₹{{product.pricing.raw.price}}.00
                            </p>
                            <span
                              style="font-size: 13px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{product.pricing.raw.msrp}}.00</span>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>

        </owl-carousel-o>
      </div>
    </div>
    <div style="width: 100%;" class="desktop-only">
      <div style="margin-left: 3%; margin-right: 3%;padding-bottom: 40px;margin-top: 50px; margin-bottom: 50px;">
        <!-- <img src="../../../../assets/images/lushngreen/LnG-NL-Screen.jpg" style="width: 100%;"> -->
        <!-- <div class="subscribelush"> -->
        <div style="background-image: url(../../../../assets/images/lushngreen/LnG-NL-Screen.jpg); background-size: cover;
                padding-top: 100px;
                padding-bottom: 100px;
                text-align: center;">
          <div>
            <div style="display: flex;justify-content: center;">
              <i class="fa fa-envelope-open-o" style="color: white;"></i>

            </div>
            <div>
              <div class="lushhomebes3">NEWSLETTER SIGNUP</div>
            </div>

            <div style="display: flex;justify-content: center;">
              <hr style="border: 1.5px solid #a5c30b;width: 90px; margin-top: 5px;">
            </div>
            <div>
              <div class="lushhomebes4">Join our list and get 15% off on your first purchase</div>
            </div>
            <div style="display: flex;justify-content: center;height: 60px;">
              <form [formGroup]="subscribeForm" novalidate class="responive_acc" style="width: 30%;">
                <input type="text" placeholder="Enter your email address.." class="email lushsubscribe"
                  formControlName="email" [class.is-invalid]="f.email.invalid && validateForm" required>
                <button class="lush-subbtn" (click)="subscribe()">
                  <p style="
                    background-color: #a6c40c;color: white;font-size: 13px;padding-top: 7px;padding-bottom: 7px;">
                    SUBSCRIBE</p>
                </button>
                <div class="invalid-feedback" *ngIf="f.email.errors">
                  <div style="text-align: left;color: white;" *ngIf="f.email.errors.required">
                    Email Id is required.
                  </div>
                  <div style="text-align: left;color: white;" *ngIf="f.email.errors.pattern">
                    Enter correct Email Id.
                  </div>
                  <div style="text-align: left;color: white;" *ngIf="f.email.errors.maxlength">
                    Email can't be more than 50 characters long.
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div style="width: 100%;" class="mobile-only">
      <div style="padding-bottom: 40px;margin-top: 50px; margin-bottom: 50px;">
        <img src="../../../../assets/images/lushngreen/Untitled-2.jpg" style="width: 100%;">
        <div style="display: flex; justify-content: center;">
          <div class="subscribelush">
            <div style="display: flex;justify-content: center;">
              <i class="fa fa-envelope-open-o" style="color: white;"></i>

            </div>
            <div style="display: flex;justify-content: center;">
              <div class="lushhomebes3">NEWSLETTER SIGNUP</div>
            </div>

            <div style="display: flex;justify-content: center;">
              <hr style="border: 1.5px solid #a5c30b;width: 90px; margin-top: 5px;">
            </div>
            <div style="display: flex;justify-content: center;">
              <div class="lushhomebes4">Join our list and get 15% off on your first purchase</div>
            </div>
            <div style="display: flex;justify-content: center;">
              <form [formGroup]="subscribeForm" novalidate class="responive_acc" style="position: fixed;width: 95%;">
                <input type="text" placeholder="Enter your email address.." class="email lushsubscribe"
                  formControlName="email" [class.is-invalid]="f.email.invalid && validateForm" required>
                <button class="lush-subbtn" (click)="subscribe()">
                  <p style="
                    background-color: #a6c40c;color: white;font-size: 13px;padding-top: 7px;padding-bottom: 7px;">
                    SUBSCRIBE</p>
                </button>
                <div class="invalid-feedback" *ngIf="f.email.errors">
                  <div *ngIf="f.email.errors.required" style="color: white;">
                    Email Id is required.
                  </div>
                  <div *ngIf="f.email.errors.pattern" style="color: white;">
                    Enter correct Email Id.
                  </div>
                  <div *ngIf="f.email.errors.maxlength" style="color: white;">
                    Email can't be more than 50 characters long.
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>

    </div>
    <div style="margin-top: 50px;">
      <div class="lushhomebes1">TESTIMONIALS</div>
      <div style="display: flex;justify-content: center;">
        <hr style="border: 1.5px solid #a5c30b;width: 90px; margin-top: 5px;">
      </div>
      <div class="lushhomebes2">What Our Clients Says</div>
      <div class="desktop-only" style="margin-left: 3%; margin-right: 3%; margin-top: 20px;">
        <owl-carousel-o [options]="ProductSliderConfig8" class="slider2 rounder-corner-nav" style="width: 92%;">
          <ng-container class="revinfo">
            <ng-template carouselSlide>
              <div style="margin-right: 20px;width: 100%;">
                <div class=" inq-pro-sec-st listProducthome">

                  <div class="product-list-cards-baby2" style="margin-top: 15px;width: 100%;">

                    <div class="deera-img button-overlay" style="width: 100%;">

                      <img src="../../../../assets/images/lushngreen/LnG-T-image-1.jpg" class="newcollection-image-baby"
                        width="100%" />
                    </div>

                    <div class="product-list-description-lush" style="width: 100%;background-color: #666666;">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="baby-newcol-name1"> Kasthoori Mehta
                          </p>
                          <p class="baby-newcol-name1"> Chennai
                          </p>
                          <p class="lush-newcol-name">After receiving this plant,the plant was mature,tall as promised
                            with a healthy growth...it was well hydrated and full of node..The packaging was great...
                            Thank you @lushngreen for this delightful Monstera.. I'll be happy to buy it again</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template carouselSlide>
              <div style="margin-right: 20px;width: 100%;">
                <div class=" inq-pro-sec-st listProducthome">

                  <div class="product-list-cards-baby2" style="margin-top: 15px;width: 100%;">

                    <div class="deera-img button-overlay" style="width: 100%;">

                      <img src="../../../../assets/images/lushngreen/LnG-T-image-2.jpg" class="newcollection-image-baby"
                        width="100%" />
                    </div>

                    <div class="product-list-description-lush" style="width: 100%;background-color: #666666;">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="baby-newcol-name1"> Lakshman Gunashekar
                          </p>
                          <p class="baby-newcol-name1"> Chennai
                          </p>
                          <p class="lush-newcol-name1">It was always wonderful experience with ugaoo plants what they
                            show is what customer receives always</p>
                          <p class="lush-newcol-name1">And that is too big thing to manage packaging and quality</p>
                          <p class="lush-newcol-name1">Love for ugaoo foundation will remain infinite</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template carouselSlide>
              <div style="margin-right: 20px;width: 100%;">
                <div class=" inq-pro-sec-st listProducthome">

                  <div class="product-list-cards-baby2" style="margin-top: 15px;width: 100%;">

                    <div class="deera-img button-overlay" style="width: 100%;">

                      <img src="../../../../assets/images/lushngreen/LnG-T-image-3.jpg" class="newcollection-image-baby"
                        width="100%" />
                    </div>

                    <div class="product-list-description-lush" style="width: 100%;background-color: #666666;">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="baby-newcol-name1"> Ashok Dhandapani
                          </p>
                          <p class="baby-newcol-name1"> Chennai
                          </p>
                          <p class="lush-newcol-name">LushNGreen is a brand that's synonymous with trust.. you know your
                            plants will have a long life once you buy from them, not only because their plants and seeds
                            quality is good, but they handhold you through every small part of the lifecycle.. they are
                            my plant buddies for life... I am so glad lushngreen is in my life</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template carouselSlide>
              <div style="margin-right: 20px;width: 100%;">
                <div class=" inq-pro-sec-st listProducthome">

                  <div class="product-list-cards-baby2" style="margin-top: 15px;width: 100%;">

                    <div class="deera-img button-overlay" style="width: 100%;">

                      <img src="../../../../assets/images/lushngreen/LnG-T-image-2.jpg" class="newcollection-image-baby"
                        width="100%" />
                    </div>

                    <div class="product-list-description-lush" style="width: 100%;background-color: #666666;">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="baby-newcol-name1"> Sundaravadivel
                          </p>
                          <p class="baby-newcol-name1"> Chennai
                          </p>
                          <p class="lush-newcol-name">“During covid, all deliveries became
                            online..food,plants,groceries..wait..plants? Who would have thought?..well..Ugaoo did and is
                            best at it. They make sure that we get the greenest and lushest plants so that we can love &
                            care for them as they do. I personally am in love with their service and would totally
                            recommend it to anyone who wants to make the first step in making their home a jungle ”</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
      <div class="mobile-only" style="margin-left: 1%; margin-top: 20px; margin-bottom: 35px;">
        <owl-carousel-o [options]="ProductSliderConfig3" class="slider2 rounder-corner-nav"
          style="display: block; width: 98%;">
          <ng-container class="revinfo">
            <ng-template carouselSlide>
              <div style="width: 100%;">
                <div class=" inq-pro-sec-st listProducthome">

                  <div class="product-list-cards-lush2" style="margin-top: 15px;width: 100%;">

                    <div class="deera-img button-overlay" style="width: 100%;">

                      <img src="../../../../assets/images/lushngreen/LnG-T-image-1.jpg" class="newcollection-image-baby"
                        width="100%" />
                    </div>

                    <div class="product-list-description-lush" style="width: 100%;background-color: #666666;">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="baby-newcol-name1"> Kasthoori Mehta
                          </p>
                          <p class="baby-newcol-name1"> Chennai
                          </p>
                          <p class="lush-newcol-name">After receiving this plant,the plant was mature,tall as promised
                            with a healthy growth...it was well hydrated and full of node..The packaging was great...
                            Thank you @lushngreen for this delightful Monstera.. I'll be happy to buy it again</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template carouselSlide>
              <div style="width: 100%;">
                <div class=" inq-pro-sec-st listProducthome">

                  <div class="product-list-cards-lush2" style="margin-top: 15px;width: 100%;">

                    <div class="deera-img button-overlay" style="width: 100%;">

                      <img src="../../../../assets/images/lushngreen/LnG-T-image-2.jpg" class="newcollection-image-baby"
                        width="100%" />
                    </div>

                    <div class="product-list-description-lush" style="width: 100%;background-color: #666666;">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="baby-newcol-name1"> Lakshman Gunashekar
                          </p>
                          <p class="baby-newcol-name1"> Chennai
                          </p>
                          <p class="lush-newcol-name1">It was always wonderful experience with ugaoo plants what they
                            show is what customer receives always</p>
                          <p class="lush-newcol-name1">And that is too big thing to manage packaging and quality</p>
                          <p class="lush-newcol-name1">Love for ugaoo foundation will remain infinite</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template carouselSlide>
              <div style="width: 100%;">
                <div class=" inq-pro-sec-st listProducthome">

                  <div class="product-list-cards-lush2" style="margin-top: 15px;width: 100%;">

                    <div class="deera-img button-overlay" style="width: 100%;">

                      <img src="../../../../assets/images/lushngreen/LnG-T-image-3.jpg" class="newcollection-image-baby"
                        width="100%" />
                    </div>

                    <div class="product-list-description-lush" style="width: 100%;background-color: #666666;">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="baby-newcol-name1"> Ashok Dhandapani
                          </p>
                          <p class="baby-newcol-name1"> Chennai
                          </p>
                          <p class="lush-newcol-name">LushNGreen is a brand that's synonymous with trust.. you know your
                            plants will have a long life once you buy from them, not only because their plants and seeds
                            quality is good, but they handhold you through every small part of the lifecycle.. they are
                            my plant buddies for life... I am so glad lushngreen is in my life</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template carouselSlide>
              <div style="width: 100%;">
                <div class=" inq-pro-sec-st listProducthome">

                  <div class="product-list-cards-lush2" style="margin-top: 15px;width: 100%;">

                    <div class="deera-img button-overlay" style="width: 100%;">

                      <img src="../../../../assets/images/lushngreen/LnG-T-image-2.jpg" class="newcollection-image-baby"
                        width="100%" />
                    </div>

                    <div class="product-list-description-lush" style="width: 100%;background-color: #666666;">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p class="baby-newcol-name1"> Sundaravadivel
                          </p>
                          <p class="baby-newcol-name1"> Chennai
                          </p>
                          <p class="lush-newcol-name">“During covid, all deliveries became
                            online..food,plants,groceries..wait..plants? Who would have thought?..well..Ugaoo did and is
                            best at it. They make sure that we get the greenest and lushest plants so that we can love &
                            care for them as they do. I personally am in love with their service and would totally
                            recommend it to anyone who wants to make the first step in making their home a jungle ”</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>

  </section>
  <section *ngIf="config.title === 'KatbookStore'">
    <div class="mobile-only">
      <div class="kat_home_title">
        <span style="font-size: 20px;font-weight: 600;font-family: system-ui;margin-left: 3%;">New Arrivals</span>
        <a (click)="productsListkat()"
          style="font-size: 17px;font-weight: 600;font-family: system-ui;color: #23a6f0 !important;cursor: pointer;">See
          all <i class="fa fa-arrow-right" (click)="productsListkat()"
            style="font-size: 16px !important;transform: translate(0px, -2px);"></i></a>
      </div>
      <div
        style="display: grid; grid-template-columns: repeat(2, 1fr);margin-left: 2%;margin-right: 2%;margin-top: 10px;">

        <div style="margin-left: 6%; margin-right: 6%; margin-top: 20px; box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);"
          *ngFor="let product of newArrivalKatMobile; let i = index">

          <div>


            <div class="baby-newcollection">
              <div class="product-list-description-baby">
                <div class="product-centering-baby">
                  <div>
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                      class="newcollection-image-baby" style="width: 60%;" />
                  </div>
                  <div class="d-flex Kat_newprodname">

                    <div style="width: 100%;margin-bottom: 15px;">
                      <div style="display: flex;justify-content: center;" class="justify-center-kat"
                        (click)="productDetails(product.id)">
                        <p class="kat-newcol-sku"> {{product.sku}}
                        </p>
                      </div>
                      <div style="display: flex;justify-content: center;" class="justify-center-kat"
                        (click)="productDetails(product.id)">
                        <p class="kat-newcol-name"> {{product.name}}
                        </p>
                      </div>
                      <div style="display: flex;justify-content: center;" class="justify-center-kat kat_martop-col">

                        <p class="kat-newcol-price"> ₹{{product.pricing.raw.price}}.00
                          <span
                            style="font-size: 11px !important;margin-left: 5px !important;text-decoration: line-through;color: #fa6464d9 !important;">₹{{
                            product.pricing.raw.msrp}}.00</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex;justify-content: center;margin-bottom: 10px;">
                    <button class="btn_kat_home" (click)="productDetails(product.id)">Choose Book</button>
                  </div>
                </div>
              </div>
            </div>


          </div>

        </div>
      </div>
    </div>
    <div class="mobile-only">
      <div class="kat_home_title">
        <span style="font-size: 20px;font-weight: 600;font-family: system-ui;margin-left: 3%;">General English</span>
        <a style="font-size: 17px;font-weight: 600;font-family: system-ui;color: #23a6f0 !important;cursor: pointer;"
          (click)="productsListkat()">See all <i class="fa fa-arrow-right" (click)="productsListkat()"
            style="font-size: 16px !important;transform: translate(0px, -2px);"></i></a>
      </div>
      <div
        style="display: grid; grid-template-columns: repeat(2, 1fr);margin-left: 2%;margin-right: 2%;margin-top: 10px;">

        <div style="margin-left: 6%; margin-right: 6%; margin-top: 20px; box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);"
          *ngFor="let product of newArrivalKatMobile; let i = index">

          <div>


            <div class="baby-newcollection">
              <div class="product-list-description-baby">
                <div class="product-centering-baby">
                  <div>
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                      class="newcollection-image-baby" style="width: 60%;" />
                  </div>
                  <div class="d-flex Kat_newprodname">

                    <div style="width: 100%;margin-bottom: 15px;">
                      <div style="display: flex;justify-content: center;" class="justify-center-kat"
                        (click)="productDetails(product.id)">
                        <p class="kat-newcol-sku"> {{product.sku}}
                        </p>
                      </div>
                      <div style="display: flex;justify-content: center;" class="justify-center-kat"
                        (click)="productDetails(product.id)">
                        <p class="kat-newcol-name"> {{product.name}}
                        </p>
                      </div>
                      <div style="display: flex;justify-content: center;" class="justify-center-kat kat_martop-col">

                        <p class="kat-newcol-price"> ₹{{product.pricing.raw.price}}.00
                          <span
                            style="font-size: 11px !important;margin-left: 5px !important;text-decoration: line-through;color: #fa6464d9 !important;">₹{{
                            product.pricing.raw.msrp}}.00</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex;justify-content: center;margin-bottom: 10px;">
                    <button class="btn_kat_home" (click)="productDetails(product.id)">Choose Book</button>
                  </div>
                </div>
              </div>
            </div>


          </div>

        </div>
      </div>
    </div>
    <div class="mobile-only" style="margin-bottom: 30px;">
      <div class="kat_home_title">
        <span style="font-size: 20px;font-weight: 600;font-family: system-ui;margin-left: 3%;">Mathematics</span>
        <a style="font-size: 17px;font-weight: 600;font-family: system-ui;color: #23a6f0 !important;cursor: pointer;"
          (click)="productsListkat()">See all <i class="fa fa-arrow-right" (click)="productsListkat()"
            style="font-size: 16px !important;transform: translate(0px, -2px);"></i></a>
      </div>
      <div
        style="display: grid; grid-template-columns: repeat(2, 1fr);margin-left: 2%;margin-right: 2%;margin-top: 10px;">

        <div style="margin-left: 6%; margin-right: 6%; margin-top: 20px; box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);"
          *ngFor="let product of newArrivalKatMobile; let i = index">

          <div>


            <div class="baby-newcollection">
              <div class="product-list-description-baby">
                <div class="product-centering-baby">
                  <div>
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                      class="newcollection-image-baby" style="width: 60%;" />
                  </div>
                  <div class="d-flex Kat_newprodname">

                    <div style="width: 100%;margin-bottom: 15px;">
                      <div style="display: flex;justify-content: center;" class="justify-center-kat"
                        (click)="productDetails(product.id)">
                        <p class="kat-newcol-sku"> {{product.sku}}
                        </p>
                      </div>
                      <div style="display: flex;justify-content: center;" class="justify-center-kat"
                        (click)="productDetails(product.id)">
                        <p class="kat-newcol-name"> {{product.name}}
                        </p>
                      </div>
                      <div style="display: flex;justify-content: center;" class="justify-center-kat kat_martop-col">

                        <p class="kat-newcol-price"> ₹{{product.pricing.raw.price}}.00
                          <span
                            style="font-size: 11px !important;margin-left: 5px !important;text-decoration: line-through;color: #fa6464d9 !important;">₹{{
                            product.pricing.raw.msrp}}.00</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex;justify-content: center;margin-bottom: 10px;">
                    <button class="btn_kat_home" (click)="productDetails(product.id)">Choose Book</button>
                  </div>
                </div>
              </div>
            </div>


          </div>

        </div>
      </div>
    </div>






    <div style="margin-top: 40px;margin-bottom: 100px;" class="desktop-only">
      <div class="kat_home_title">
        <span style="font-size: 30px;font-weight: 600;font-family: system-ui;margin-left: 3%;">New Arrivals</span>
        <a style="font-size: 26px;font-weight: 600;font-family: system-ui;color: #23a6f0 !important;cursor: pointer;"
          (click)="productsListNewarrival()">See all <i class="fa fa-arrow-right"
            style="font-size: 16px !important;transform: translate(0px, -2px);"></i></a>
      </div>
      <div style="display: grid; grid-template-columns: repeat(5, 1fr);margin-left: 5%;margin-right: 5%;">

        <div class="desktop-only card shadow-lg p-4 bg-body rounded kbookcrd"
          style="margin-left: 6%; margin-right: 6%; margin-bottom: 10px; box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);"
          *ngFor="let product of newArrivalKat; let i = index">

          <div class="container">


            <div class="row">
              <div class="col">
                <div class="container container_kbook">
                  <div>
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                      class="newcollection-image-baby"
                      style="object-fit: contain;max-width: 100%; max-height: 100%;position: absolute;  top: 0;left: 0; right: 0;  bottom: 0; margin: auto;" />
                  </div>

                </div>
              </div>
            </div>


          </div>
          <div class="card-body">
            <div class="d-flex ">

              <div style="width: 100%;margin-bottom: 15px;">
                <div style="display: flex;" class="justify-center-kat" (click)="productDetails(product.id)">
                  <p class="kat-newcol-sku" style="text-transform: uppercase;"> {{product.name}}
                  </p>
                </div>
                <div style="display: flex;" class="justify-center-kat" (click)="productDetails(product.id)">
                  <p *ngIf="product.attributes[0]" class="kat-newcol-name" style="color: #a12a2a;margin-top:5px">
                    {{product.attributes[0].section_title}}
                  </p>
                </div>
                <div style="display: flex;" class="justify-center-kat ">

                  <p *ngIf="product.categorynames" class="kat-newcol-price" style="color: #23a6f0;margin-top:5px">
                    {{product.categorynames[0].name}}
                    <!-- <span style="font-size: 11px !important;margin-left: 5px !important;text-decoration: line-through;color: #fa6464d9 !important;">₹{{ product.pricing.raw.msrp}}.00</span> -->
                  </p>
                </div>
              </div>
            </div>
            <div style="display: flex;justify-content: center;margin-bottom: 10px;">
              <button class="btn_kat_home" (click)="productDetails(product.id)" style="width: 100%;">Choose
                Book</button>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div style="margin-top: 40px;margin-bottom: 100px;" class="desktop-only">
      <div class="kat_home_title">
        <span style="font-size: 30px;font-weight: 600;font-family: system-ui;margin-left: 3%;">General English</span>
        <a style="font-size: 26px;font-weight: 600;font-family: system-ui;color: #23a6f0 !important;cursor: pointer;"
          (click)="navigateToSubject()">See all <i class="fa fa-arrow-right"
            style="font-size: 16px !important;transform: translate(0px, -2px);"></i></a>
      </div>
      <div style="display: grid; grid-template-columns: repeat(5, 1fr);margin-left: 5%;margin-right: 5%;">

        <div class="desktop-only card shadow-lg p-4 bg-body rounded kbookcrd"
          style="margin-left: 6%; margin-right: 6%; margin-bottom: 10px; box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);"
          *ngFor="let product of englishBook; let i = index">

          <div class="container">


            <div class="row">
              <div class="col">
                <div class="container container_kbook">
                  <div>
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                      class="newcollection-image-baby"
                      style="object-fit: contain;max-width: 100%; max-height: 100%;position: absolute;  top: 0;left: 0; right: 0;  bottom: 0; margin: auto;" />
                  </div>

                </div>
              </div>
            </div>


          </div>
          <div class="card-body">
            <div class="d-flex ">

              <div style="width: 100%;margin-bottom: 15px;">
                <div style="display: flex;" class="justify-center-kat" (click)="productDetails(product.id)">
                  <p class="kat-newcol-sku" style="text-transform: uppercase;"> {{product.name}}
                  </p>
                </div>
                <div style="display: flex;" class="justify-center-kat" (click)="productDetails(product.id)">
                  <p *ngIf="product.attributes[0]" class="kat-newcol-name" style="color: #a12a2a;margin-top:5px">
                    {{product.attributes[0].section_title}}
                  </p>
                </div>
                <div style="display: flex;" class="justify-center-kat ">

                  <p *ngIf="product.categorynames" class="kat-newcol-price" style="color: #23a6f0;margin-top:5px">
                    {{product.categorynames[0].name}}
                    <!-- <span style="font-size: 11px !important;margin-left: 5px !important;text-decoration: line-through;color: #fa6464d9 !important;">₹{{ product.pricing.raw.msrp}}.00</span> -->
                  </p>
                </div>
              </div>
            </div>
            <div style="display: flex;justify-content: center;margin-bottom: 10px;">
              <button class="btn_kat_home" (click)="productDetails(product.id)" style="width: 100%;">Choose
                Book</button>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div style="margin-top: 40px;margin-bottom: 100px;" class="desktop-only">
      <div class="kat_home_title">
        <span style="font-size: 30px;font-weight: 600;font-family: system-ui;margin-left: 3%;">Mathematics</span>
        <a style="font-size: 26px;font-weight: 600;font-family: system-ui;color: #23a6f0 !important;cursor: pointer;"
          (click)="navigateToMaths()">See all <i class="fa fa-arrow-right"
            style="font-size: 16px !important;transform: translate(0px, -2px);"></i></a>
      </div>
      <div style="display: grid; grid-template-columns: repeat(5, 1fr);margin-left: 5%;margin-right: 5%;">

        <div class="desktop-only card shadow-lg p-4 bg-body rounded kbookcrd"
          style="margin-left: 6%; margin-right: 6%; margin-bottom: 10px; box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.2);"
          *ngFor="let product of mathsBook; let i = index">

          <div class="container">


            <div class="row">
              <div class="col">
                <div class="container container_kbook">
                  <div>
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                      class="newcollection-image-baby"
                      style="object-fit: contain;max-width: 100%; max-height: 100%;position: absolute;  top: 0;left: 0; right: 0;  bottom: 0; margin: auto;" />
                  </div>

                </div>
              </div>
            </div>


          </div>
          <div class="card-body">
            <div class="d-flex ">

              <div style="width: 100%;margin-bottom: 15px;">
                <div style="display: flex;" class="justify-center-kat" (click)="productDetails(product.id)">
                  <p class="kat-newcol-sku" style="text-transform: uppercase;"> {{product.name}}
                  </p>
                </div>
                <div style="display: flex;" class="justify-center-kat" (click)="productDetails(product.id)">
                  <p *ngIf="product.attributes[0]" class="kat-newcol-name" style="color: #a12a2a;margin-top:5px">
                    {{product.attributes[0].section_title}}
                  </p>
                </div>
                <div style="display: flex;" class="justify-center-kat ">

                  <p *ngIf="product.categorynames" class="kat-newcol-price" style="color: #23a6f0;margin-top:5px">
                    {{product.categorynames[0].name}}
                    <!-- <span style="font-size: 11px !important;margin-left: 5px !important;text-decoration: line-through;color: #fa6464d9 !important;">₹{{ product.pricing.raw.msrp}}.00</span> -->
                  </p>
                </div>
              </div>
            </div>
            <div style="display: flex;justify-content: center;margin-bottom: 10px;">
              <button class="btn_kat_home" (click)="productDetails(product.id)" style="width: 100%;">Choose
                Book</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
  <section *ngIf="config.title === 'BombayHardware'"
    style="margin-bottom: 30px; background-color: #ededed;width: 99%;margin: 0;">
    <div>
      <!-- <img  class="supreme_img" src="../../../../assets/images/bombayhardware/supremelogo.png"> -->
      <h2 class="center-title content-title title-box title main-title"
        style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #1e1e73; margin-top: -25px;">
        SUPREME
      </h2>

    </div>
    <div>
      <!-- <div class="col-1"></div> -->
      <div class="container">
        <div *ngFor="let cate of allCategories ;let i = index" style="background-color: #ededed">
          <div *ngIf="cate.name=='Supreme Pipes and Fittings'" class="home-container"
            style="background-color: #ededed;grid-column-gap: 1px;position: relative;bottom: 25px;">
            <div *ngFor="let sub of cate.subcategories" style="transition: none !important;cursor: pointer;"
              class="isempty">
              <div>
                <div class="home-card" (click)="productsListTazTest1(sub.name)"
                  style="border-right: 3px solid #e6e6e6;padding: 1px;">
                  <div class="" style="height: 200px">

                    <div style="width:100%">
                      <img style="height: 148px; object-fit: contain;width:100% !important;background-color: white;"
                        [src]="sub.category_icon">
                    </div>
                    <div class="card-heading">
                      {{sub.name | titlecase }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="cursor: pointer;">
              <div class="home-card" style="padding: 1px;" (click)="productsListTazTest()">
                <div class=" " style="height: 200px">
                  <div style="width:100%">
                    <img style="height: 148px;width:100% !important"
                      src="assets\images\bombayhardware\all-products.jpg">
                  </div>
                  <div class="card-heading">
                    All Categories
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- <div class="col-1"></div> -->
    </div>

  </section>

  <div class="container" *ngIf="config.title=='BombayHardware'">
    <section class="tab-product featured-collections m-0">

      <div class="row">
        <div class="col-sm-12 col-lg-12 our_featured-products">
          <section *ngIf="config.title === 'BombayHardware'">
            <div class="channe_partners mt-3 pt-3">
              <h2 class="text-center"
                style="color:#392f81;padding:0 0 40px 0; font-family: 'proxima-regular','sans-serif'!important;">CHANNEL
                PARTNERS</h2>
              <div class="row" style="    display: flex;    justify-content: center;">
                <div class="partner_grid">
                  <div>
                    <div class="partners_img">
                      <img style="width:100%; height:auto"
                        src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/BombayHardware/StoreGallery/BH-CP-logo-1.jpg">
                    </div>
                  </div>
                  <div>
                    <div class="partners_img">
                      <img style="width:100%; height:auto ;"
                        src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/BombayHardware/StoreGallery/BH-CP-logo-2.jpg">
                    </div>
                  </div>
                  <div>
                    <div class="partners_img">
                      <img style="width:100%; height:auto"
                        src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/BombayHardware/StoreGallery/BH-CP-logo-3.jpg">
                    </div>
                  </div>
                  <div>
                    <div class="partners_img">
                      <img style="width:100%; height:auto"
                        src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/BombayHardware/StoreGallery/BH-CP-logo-4.jpg">
                    </div>
                  </div>
                  <div>
                    <div class="partners_img">
                      <img style="width:100%; height:auto"
                        src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/BombayHardware/StoreGallery/BH-CP-logo-5.jpg">

                    </div>
                  </div>
                  <div>
                    <div class="partners_img">
                      <img style="width:100%; height:auto;"
                        src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/BombayHardware/StoreGallery/BH-CP-logo-6.jpg">

                    </div>
                  </div>
                  <div>
                    <div class="partners_img">
                      <img style="width:100%; height:auto;"
                        src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/BombayHardware/StoreGallery/BH-CP-logo-7.jpg">

                    </div>
                  </div>
                  <div>
                    <div class="partners_img">
                      <img style="width:100%; height:auto;"
                        src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/BombayHardware/StoreGallery/BH-CP-logo-8.jpg">

                    </div>
                  </div>
                  <!-- <div class="d-none d-lg-block col-6 col-lg-3"></div> -->
                  <div>
                    <div class="partners_img">
                      <img style="width:100%; height:auto ;"
                        src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/BombayHardware/StoreGallery/BH-CP-logo-9.jpg">

                    </div>
                  </div>
                  <div>
                    <div class="partners_img">
                      <img class="jgogas_img" style="width:100%; height:auto ; "
                        src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/BombayHardware/StoreGallery/BH-CP-logo-10.jpg">

                    </div>
                  </div>
                  <div>
                    <div class="partners_img">
                      <img style="width:100%; height:auto ;"
                        src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/BombayHardware/StoreGallery/BH-CP-logo-11.jpg">

                    </div>
                  </div>

                </div>

                <!-- <div class="d-none d-lg-block col-6 col-lg-3"></div> -->
                <!-- <div class="col-3">
                    <div class="partners_img">
                    <img style="width:100%; height:auto" src="assets\images\bombayhardware\partners\Tata-Steel-removebg-preview.png">
                    
                    </div>
                    </div>  -->
                <!-- <div class="col-6 col-lg-2" style="margin-left: -30px;">
                    <div class="partners_img">
                    <img  class="tatasteel_img"  style="width:100%; height:auto;" src="assets\images\bombayhardware\partners\Tata-Steel-removebg-preview.jpg">
                    
                    </div>
                    </div> -->
              </div>
            </div>

          </section>
        </div>
      </div>

    </section>
  </div>
  <!-- <section>
        <div style="background-image: url('https://html.sammy-codes.com/images/background.jpg');
        background-size: cover; height:480px; padding-top: 80px; text-align: center;">
        <img src="https://html.sammy-codes.com/images/small-profile.jpeg" style="height:150px; border-radius: 50%; border: 10px solid #FEDE00;">
        <h1 style="font-size:100px; color:white; margin:10px;">Sammy the Shark</h1><p style="font-size:30px; color: white;"><em>Senior Selachimorpha at DigitalOcean</em></p><p style="font-size: 20px; color:#1F9AFE;"></p></div>
      </section> -->
  <section *ngIf="config.title === 'Babys Pride'">


    <div style="padding-top: 20px;background-color: #bb086c;padding-bottom: 100px; " class="scift-left-best">
      <div style="display: flex;justify-content: center;margin-bottom: 30px;">
        <img src="../../../../assets/images/babyspride/arrowkey.png" alt="" style="width: 50px;">
      </div>
      <div style="display: flex;justify-content: center;">
        <h2
          style="letter-spacing: 7px;font-family: sans-serif;line-height: 1.25em;font-size: 18px;font-weight: 550; color: white;"
          class="schift-leftsell">SHOP BY AGE</h2>

      </div>
      <div style="display: flex;justify-content: center;margin-top: 10px;">
        <p
          style="letter-spacing: 4px;font-family: sans-serif;line-height: 1.25em;font-size: 12px;font-weight: 450; color: white;">
          WE HAVE PRODUCTS FOR ALL AGES</p>
      </div>

      <div class="baby-age">
        <div class="product-list-description-baby">
          <div class="product-center-baby22" (click)="routeToListbaby('INFANTS')">
            <div>
              <img src="../../../../assets/images/babyspride/BP-Category-Icon-3.png" id="img-list"
                class="product-list-image-baby" />
            </div>
            <div class="d-flex avon_prodname">

              <div style="width: 100%;">
                <div style="display: flex; justify-content: center;">
                  <p class="baby-age-list"> INFANT 0 TO 24 MONTHS
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="product-list-description-baby">
          <div class="product-center-baby22" (click)="routeToListbaby('GIRLS')">
            <div>
              <img src="../../../../assets/images/babyspride/BP-Category-Icon-2.png" id="img-list"
                class="product-list-image-baby" />
            </div>
            <div class="d-flex avon_prodname">

              <div style="width: 100%;">
                <div style="display: flex; justify-content: center;">
                  <p class="baby-age-list"> GIRLS 1 TO 6 YEARS
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="product-list-description-baby">
          <div class="product-center-baby22" (click)="routeToListbaby('BOYS')">
            <div>
              <img src="../../../../assets/images/babyspride/BP-Category-Icon-1.png" id="img-list"
                class="product-list-image-baby">
            </div>
            <div class="d-flex avon_prodname">

              <div style="width: 100%;">
                <div style="display: flex; justify-content: center;">
                  <p class="baby-age-list"> BOYS 1 TO 6 YEARS
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div style="padding-top: 75px;background-color: #80c340; " class="scift-left-best babys_padding1">
      <div style="display: flex;justify-content: center;">
        <h2 style="font-family: sans-serif;line-height: 1.25em;font-size: 35px;font-weight: 550; color: white;"
          class="schift-leftsell">NEW COLLECTION</h2>

      </div>
      <div style="display: flex;justify-content: center;margin-top: 10px;" class="head-tail-baby">
        <p style="font-family: sans-serif;line-height: 1.25em;font-size: 12px;font-weight: 450; color: white;"
          class="head-tail1-baby">Customer's favorite products this week. What's so special?
          <a (click)="productList()"
            style="font-weight: 600;cursor: pointer; color: white !important;font-family: sans-serif;line-height: 1.25em;font-size: 13px;">Check
            it out!!!</a>
        </p>
      </div>
      <div class="mobile-only">
        <owl-carousel-o [options]="ProductSliderConfig6" class="slider2" style="width: 92%;">

          <ng-container class="revinfo" *ngFor="let product of newArrival; let i = index">
            <ng-template carouselSlide>
              <!-- <div class="baby-age1"> -->
              <div>
                <div>

                  <div class="baby-newcollection">
                    <div class="product-list-description-baby22">
                      <div class="product-centering-baby">
                        <div>
                          <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';"
                            alt="{{ product.name }}" class="newcollection-image-baby" />
                        </div>
                        <div class="d-flex baby_newprodname">

                          <div style="width: 100%;">
                            <div style="display: flex;" class="justify-center-baby"
                              (click)="productDetails(product.id)">
                              <p class="baby-newcol-name"> {{product.name}}
                              </p>
                            </div>
                            <div style="display: flex;">
                              <span
                                style="font-size: 11px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{
                                product.variant.option_values[0].pricing.raw.msrp }}</span>
                              <p class="baby-newcol-price"> ₹ {{product.variant.option_values[0].pricing.raw.price}}.00
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </ng-template>
          </ng-container>

        </owl-carousel-o>
      </div>
      <div class="desktop-only" style="margin-left: 11%; margin-right: 11%; margin-top: 20px;">
        <owl-carousel-o [options]="ProductSliderConfig5" class="slider2 rounder-corner-nav" style="width: 92%;">

          <ng-container class="revinfo" *ngFor="let product of newArrival; let i = index">
            <ng-template carouselSlide>
              <div style="margin-bottom: 30px;width: 90%;">


                <div class="baby-newcollection">
                  <div class="product-list-description-baby">
                    <div class="product-centering-baby">
                      <div>
                        <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                          onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';"
                          alt="{{ product.name }}" class="newcollection-image-baby" />
                      </div>
                      <div class="d-flex baby_newprodname">

                        <div style="width: 100%;margin-bottom: 25px;">
                          <div style="display: flex;" class="justify-center-baby" (click)="productDetails(product.id)">
                            <p class="baby-newcol-name"> {{product.name}}
                            </p>
                          </div>
                          <div style="display: flex;" class="justify-center-baby">
                            <span
                              style="font-size: 11px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{
                              product.variant.option_values[0].pricing.raw.msrp }}</span>
                            <p class="baby-newcol-price"> ₹ {{product.variant.option_values[0].pricing.raw.price}}.00
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </ng-template>
          </ng-container>

        </owl-carousel-o>
      </div>
    </div>
    <div class="scift-left-best2">
      <div style="display: flex;justify-content: center;">
        <h2
          style="letter-spacing: 7px;font-family: sans-serif;line-height: 1.25em;font-size: 18px;font-weight: 550; color: black;"
          class="schift-leftsell">FEATURED PRODUCTS</h2>

      </div>
      <!-- <div class="filter_body">
  <button class="filter_button">FILTER-ALL</button>
  <button class="filter_button">BOYS</button>
  <button class="filter_button">BOYS SET</button>
  <button class="filter_button">BOYS T SHIRT</button>
  <button class="filter_button">BOYS TOP</button>
  <button class="filter_button">GIRLS</button>
  <button class="filter_button">GIRLS SET</button>
  <button class="filter_button">GIRLS TOP</button>
  <button class="filter_button">INFANTS</button>
  <button class="filter_button">KIDS TOP</button>
  <button class="filter_button">PYJAMA</button>
</div> -->
      <div class="baby-display">
        <div class="baby-width1">
          <div style="display: grid;grid-template-columns: repeat(2,1fr);">
            <img src="../../../../assets/images/babyspride/Dress-baby4.jpg" alt="" class="img-baby-height"
              (click)="productDetails(542)" style="cursor: pointer;">
            <img src="../../../../assets/images/babyspride/Babysprideimgh1.jpg" alt="" class="img-baby-height"
              (click)="productDetails(163)" style="cursor: pointer;">
            <img src="../../../../assets/images/babyspride/Babysprideimgh2.jpg" alt="" class="img-baby-height"
              (click)="productDetails(171)" style="cursor: pointer;">
            <img src="../../../../assets/images/babyspride/Dress-baby2.jpg" alt="" class="img-baby-height"
              (click)="productDetails(70)" style="cursor: pointer;">

          </div>
        </div>
        <div class="baby-width">
          <div class="flex-baby-flex">
            <img src="../../../../assets/images/babyspride/Dress-bby5.jpg" alt="" class="image-88baby"
              (click)="productDetails(467)" style="cursor: pointer;">
          </div>
        </div>
      </div>
      <hr style="border-top: 2px dotted rgb(69, 216, 49);margin-top: 50px;">
    </div>

    <div style="margin-top: 35px; margin-left: 2%;margin-right: 2%;" class="mobile-only">
      <div>
        <div style="width: 100%;height: 600px;margin-bottom: 50px;">
          <img src="../../../../assets/images/babyspride/BP-Ad-Image-1.jpg" style="width: 100%;object-fit: contain;">
          <div style=" transform: translate(32px, -140px);">
            <div style="width: 82%;">
              <div style="display: flex;justify-content: center;">
                <button class="sale-btn" (click)="routeToCategory('BOYS')">SHOP NOW</button>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%;margin-right: 30px; margin-bottom: 25px;">
          <img src="../../../../assets/images/babyspride/BP-Ad-Image-3.png" style="width: 100%;">
          <div style="margin-top: 20px;height: 45%;background-color: #f1f1f1!important; ">
            <!-- <img src="../../../../assets/images/babyspride/BP-Ad-Image-4.jpg" style="width: 100%;"> -->
            <span style="width: 100%;" class="baby_height_gender1">
              <h1
                style="font-size: 25px;text-align: center;padding-top: 3%;color: #bb086c;text-shadow: none; font-family: 'proxima-regular','sans-serif'!important;">
                Kids Clothes | Kids Dresses | Kids Wear | Baby Clothes</h1>
              <h1
                style="font-size: 15px;text-align: center;margin-top: 2%;text-shadow: none; font-family: 'proxima-regular','sans-serif'!important;padding: 2px;">
                Our kids' clothes collection features a variety of fashionable and functional pieces for boys and girls.
                Each item is thoughtfully designed with vibrant colours, fun patterns, and comfortable fits that allow
                your kids to express their unique personalities while staying active and comfortable.</h1>
            </span>
          </div>
        </div>
        <div style="width: 100%;height: 600px;">
          <img src="../../../../assets/images/babyspride/BP-Ad-Image-2.jpg" style="width: 100%;object-fit: contain;">
          <div style=" transform: translate(32px, -140px);">
            <div style="width: 82%;">
              <div style="display: flex;justify-content: center;">
                <button class="sale-btn" (click)="routeToCategory('GIRLS')">SHOP NOW</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 35px; margin-bottom: 30px; margin-left: 1%; padding-bottom: 40px;" class="desktop-only">
      <div style="display: flex;justify-content: center;">
        <div style="width: 25%;margin-right: 30px;" class="baby_height_gender">
          <img src="../../../../assets/images/babyspride/BP-Ad-Image-1.jpg" style="width: 100%;object-fit: contain;"
            class="baby_height_gender">
          <div style=" transform: translate(10px, -115px);">
            <div style="width: 93%;">
              <div style="display: flex;justify-content: center;">
                <button class="sale-btn" (click)="routeToCategory('BOYS')">SHOP NOW</button>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 25%;margin-right: 30px;" class="baby_height_gender1">
          <img src="../../../../assets/images/babyspride/BP-Ad-Image-3.png" style="width: 100%;object-fit: contain;"
            class="baby_height_gender1">
          <div style="margin-top: 10px;height: 45%;background-color: #f1f1f1!important;">
            <!-- <img src="../../../../assets/images/babyspride/BP-Ad-Image-4.jpg" style="width: 100%;object-fit: contain;" class="baby_height_gender1"> -->
            <span style="width: 100%;" class="baby_height_gender1">
              <h1
                style="font-size: 25px;text-align: center;padding-top: 4%;color: #bb086c;text-shadow: none; font-family: 'proxima-regular','sans-serif'!important;">
                Kids Clothes | Kids Dresses | Kids Wear | Baby Clothes</h1>
              <h1
                style="font-size: 18px;text-align: center;margin-top: 5%;text-shadow: none; font-family: 'proxima-regular','sans-serif'!important;padding: 2px;">
                Our kids' clothes collection features a variety of fashionable and functional pieces for boys and girls.
                Each item is thoughtfully designed with vibrant colours, fun patterns, and comfortable fits that allow
                your kids to express their unique personalities while staying active and comfortable.</h1>
            </span>
          </div>
        </div>
        <div style="width: 25%;" class="baby_height_gender1">
          <img src="../../../../assets/images/babyspride/BP-Ad-Image-2.jpg" style="width: 100%;object-fit: contain;"
            class="baby_height_gender">
          <div style=" transform: translate(10px, -115px);">
            <div style="width: 93%;">
              <div style="display: flex;justify-content: center;">
                <button class="sale-btn" (click)="routeToCategory('GIRLS')">SHOP NOW</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 100px;background-color: #bb086c;">
    </div>
    <div style="margin-top: 25px; margin-right: 10px;width: 87%;" class="mobile-only">
      <owl-carousel-o [options]="ProductSliderConfig3" class="slider2 rounder-corner-nav" style="    margin-left: 7%;
        display: inline-flex;
        width: 99%;
        margin-right: 16%;">

        <ng-container class="revinfo" *ngFor="let product of products;let i =index">
          <ng-template carouselSlide>


            <div class="star">

              <div class="review" style="display: flex; justify-content: center;">
                <div class="inf1" style="width: 100%;">
                  <p
                    style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; text-align: center;">
                    Very nice dress with this low price. It is thick and fits the size. Same as shown in the picture.
                    Bright colour and super quality.</p>
                  <br>
                  <h4 class="rev" style="font-size: 16px;text-align: center;">Vineeth Chakravarthy</h4>
                </div>
              </div>
            </div>


          </ng-template>
          <ng-template carouselSlide>
            <div class="star">

              <div class="review" style="display: flex; justify-content: center;">
                <div class="inf1" style="width: 90%;">
                  <p
                    style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; text-align: center;">
                    I bought these dress for my kids in many different colors and design...they all are amazing...most
                    importantly my kids were comfortable... thank you.</p>
                  <br>
                  <h4 class="rev" style="font-size: 18px;text-align: center;">Ganesh Arumugam</h4>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="star">

              <div class="review" style="display: flex; justify-content: center;">
                <div class="inf1" style="width: 90%;">
                  <p
                    style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; text-align: center;">
                    Very Goood quality for the price. The color does not bleed nor the print comes off. The sets are
                    reallyy nice and cute. overall reallyyy nice quality for the price. Perfect gift for meeting babies
                    for first time</p>
                  <br>
                  <h4 class="rev" style="font-size: 18px;text-align: center;">Saravanavadivel</h4>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="star">

              <div class="review" style="display: flex; justify-content: center;">
                <div class="inf1" style="width: 90%;">
                  <p
                    style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; text-align: center;">
                    The fit is perfect. Very nice dress for a low price. Promt delivery. Super quality and soft fabric.
                  </p>
                  <br>
                  <h4 class="rev" style="font-size: 18px;text-align: center;">Ramya Manohar</h4>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

      </owl-carousel-o>

    </div>
    <div style="margin-top: 50px;" class="desktop-only">
      <owl-carousel-o [options]="ProductSliderConfig6" class="slider2 rounder-corner-nav" style="margin-left: 11%;
        display: inline-flex;
        width: 78%;
        margin-right: 11%;">

        <ng-container class="revinfo" *ngFor="let product of products;let i =index">
          <ng-template carouselSlide>


            <div class="star">

              <div class="review" style="display: flex; justify-content: center;">
                <div class="inf1" style="width: 85%;">
                  <p
                    style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; text-align: center;">
                    Very nice dress with this low price. It is thick and fits the size. Same as shown in the picture.
                    Bright colour and super quality.</p>
                  <br>
                  <h4 class="rev" style="font-size: 16px;text-align: center;">Vineeth Chakravarthy</h4>
                </div>
              </div>
            </div>


          </ng-template>
          <ng-template carouselSlide>
            <div class="star">

              <div class="review" style="display: flex; justify-content: center;">
                <div class="inf1" style="width: 85%;">
                  <p
                    style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; text-align: center;">
                    I bought these dress for my kids in many different colors and design...they all are amazing...most
                    importantly my kids were comfortable... thank you.</p>
                  <br>
                  <h4 class="rev" style="font-size: 18px;text-align: center;">Ganesh Arumugam</h4>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="star">

              <div class="review" style="display: flex; justify-content: center;">
                <div class="inf1" style="width: 85%;">
                  <p
                    style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; text-align: center;">
                    Very Goood quality for the price. The color does not bleed nor the print comes off. The sets are
                    reallyy nice and cute. overall reallyyy nice quality for the price. Perfect gift for meeting babies
                    for first time</p>
                  <br>
                  <h4 class="rev" style="font-size: 18px;text-align: center;">Saravanavadivel</h4>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template carouselSlide>
            <div class="star">

              <div class="review" style="display: flex; justify-content: center;">
                <div class="inf1" style="width: 85%;">
                  <p
                    style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; text-align: center;">
                    The fit is perfect. Very nice dress for a low price. Promt delivery. Super quality and soft fabric.
                  </p>
                  <br>
                  <h4 class="rev" style="font-size: 16px;text-align: center;">Ramya Manohar</h4>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

      </owl-carousel-o>

    </div>
    <div style="background-color: #62b1d2;" class="scift-left-best babys_padding baby_mar_top">
      <div class="baby-trasform-bestseller">
        <div style="display: flex;justify-content: center;">
          <img src="../../../../assets/images/babyspride/smalllogo-removebg-preview.png" alt="" style="width: 8%;">
        </div>
        <div style="display: flex;justify-content: center;">
          <h2
            style="letter-spacing: 7px;font-family: sans-serif;line-height: 1.25em;font-size: 18px;font-weight: 550; color: white;"
            class="schift-leftsell">BEST SELLERS</h2>

        </div>
        <div style="display: flex;justify-content: center;margin-top: 10px;">
          <p
            style="letter-spacing: 4px;font-family: sans-serif;line-height: 1.25em;font-size: 12px;font-weight: 450; color: white;">
            BROWSE THOUGH OUT BEST SELLERS</p>
        </div>
        <div class="mobile-only">
          <div>
            <div class="container">
              <owl-carousel-o [options]="ProductSliderConfig" class="slider rounder-corner-nav"
                style="margin-top: 28px;position: relative;">
                <ng-container *ngFor="let product of recommededProducts; let i = index">
                  <ng-template carouselSlide>
                    <app-product-box-one [product]="product" [index]="i"
                      style="display:block;width: 90%;margin-left: 5%;"></app-product-box-one>
                  </ng-template>
                </ng-container>
              </owl-carousel-o>

            </div>
          </div>
        </div>
        <div class="desktop-only" style="margin-left: 11%; margin-right: 11%; margin-top: 20px;">
          <owl-carousel-o [options]="ProductSliderConfig5" class="slider2 rounder-corner-nav" style="width: 92%;">

            <ng-container class="revinfo" *ngFor="let product of recommededProducts; let i = index">
              <ng-template carouselSlide>
                <div style="margin-bottom: 30px;width: 90%;">


                  <div class="baby-newcollection">
                    <div class="product-list-description-baby">
                      <div class="product-centering-baby">
                        <div>
                          <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                            onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';"
                            alt="{{ product.name }}" class="newcollection-image-baby" />
                        </div>
                        <div class="d-flex baby_newprodname">

                          <div style="width: 100%;margin-bottom: 25px;">
                            <div style="display: flex;" class="justify-center-baby"
                              (click)="productDetails(product.id)">
                              <p class="baby-newcol-name"> {{product.name}}
                              </p>
                            </div>
                            <div style="display: flex;" class="justify-center-baby">
                              <span
                                style="font-size: 11px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{
                                product.variant.option_values[0].pricing.raw.msrp }}</span>
                              <p class="baby-newcol-price"> ₹ {{product.variant.option_values[0].pricing.raw.price}}.00
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </ng-template>
            </ng-container>

          </owl-carousel-o>
        </div>
      </div>
    </div>
    <div style="margin-top: 10px;">
      <img src="../../../../assets/images/babyspride/before footer.png" alt="" class="baby_beforefooter">
    </div>
  </section>


  <div style="background-color: #1b52a4;" class="taz-left-best" *ngIf="config.title === 'Taazah'">
    <h1 style="display: none;">Supermarket & Pharmacy in chennai, Convenience store, Grocery store | Taazah</h1> 
    <div style="display: flex;justify-content: center;">
      <h2 style="font-family: sans-serif;line-height: 1.25em;font-size: 19px;font-weight: 550; color: white;"
        class="schift-leftsell">Shop by Categories</h2>

    </div>
    <div class="baby-age">
      <div class="product-list-description_taz">
        <div class="product-center-taz" (click)="productsListTazTest1('Fruits & Vegetables')">
          <div>
            <img src="../../../../assets/images/taazah/image 8.png" alt="Fruits & Vegetables" title="Fruits & Vegetables" id="img-list" class="product-list-image-taz" />
          </div>
          <div class="d-flex taz_prodname" style="justify-content: center;">

            <div style="width: 70%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Vegetables & Fruits
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="product-list-description_taz">
        <div class="product-center-taz" (click)="productsListTazTest1('Groceries')">
          <div>
            <img src="../../../../assets/images/taazah/image 7.png" alt="Groceries" title="Groceries" id="img-list" class="product-list-image-taz" />
          </div>
          <div class="d-flex taz_prodname" style="justify-content: center;">

            <div style="width: 70%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Grocery & Staples
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="product-list-description_taz">
        <div class="product-center-taz" (click)="productsListTazTest1('Dairy Products')">
          <div>
            <img src="../../../../assets/images/taazah/image 6.png" alt="Dairy Products" title="Dairy Products" id="img-list" class="product-list-image-taz" />
          </div>
          <div class="d-flex taz_prodname" style="justify-content: center;">

            <div style="width: 70%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Dairy Products
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="product-list-description_taz">
        <div class="product-center-taz" (click)="productsListTazTest1('Carbonated Drink')">
          <div>
            <img src="../../../../assets/images/taazah/image 5.png" alt="Carbonated Drink" title="Carbonated Drink" id="img-list" class="product-list-image-taz" />
          </div>
          <div class="d-flex taz_prodname" style="justify-content: center;">

            <div style="width: 70%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Carbonated Drinks
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="product-list-description_taz">
        <div class="product-center-taz" (click)="productsListTazTest1('Biscuits')">
          <div>
            <img src="../../../../assets/images/taazah/image 4.png" alt="Biscuits" title="Biscuits" id="img-list" class="product-list-image-taz" />
          </div>
          <div class="d-flex taz_prodname" style="justify-content: center;">

            <div style="width: 70%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Biscuits
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="product-list-description_taz">
        <div class="product-center-taz" (click)="productsListTazTest1('Pooja Items')">
          <div>
            <img src="../../../../assets/images/taazah/image 9.png" alt="Pooja Items" title="Pooja Items" id="img-list" class="product-list-image-taz" />
          </div>
          <div class="d-flex taz_prodname" style="justify-content: center;">

            <div style="width: 70%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Home Care
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="product-list-description_taz">
        <div class="product-center-taz" (click)="productsListTazTest1('Ready to Eat')">
          <div>
            <img src="../../../../assets/images/taazah/image 10.png" alt="Ready to Eat" title="Ready to Eat" id="img-list" class="product-list-image-taz" />
          </div>
          <div class="d-flex taz_prodname" style="justify-content: center;">

            <div style="width: 70%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Noodles & Sauces
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="product-list-description_taz">
        <div class="product-center-taz" (click)="productsListTazTest1('Shampoo')">
          <div>
            <img src="../../../../assets/images/taazah/image 11.png" alt="Shampoo" title="Shampoo" id="img-list" class="product-list-image-taz" />
          </div>
          <div class="d-flex taz_prodname" style="justify-content: center;">

            <div style="width: 70%;">
              <div style="display: flex; justify-content: center;">
                <p class="baby-age-list"> Personal Care
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div style="padding-top: 35px;padding-left: 8%;padding-right: 8%;background-color: #f7f7f7;"
    *ngIf="config.title === 'Taazah'">
    <div>
      <span style="font-size: 20px;font-weight: 700;font-family: system-ui;">Top Featured Products</span>
    </div>
    <div class="desktop-only" style=" margin-top: 20px;margin-bottom: 25px;">
      <owl-carousel-o [options]="ProductSliderConfig7" class="slider2 rounder-corner-nav" style="width: 92%;">

        <ng-container class="revinfo" *ngFor="let product of newArrival; let i = index">
          <ng-template carouselSlide>
            <div style="">


              <div class="baby-newcollection">
                <div class="product-list-description-baby">
                  <div class="product-centering-baby">
                    <div>
                      <img [src]="product.assets[0].image_source" id="img-list"
                        (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}" title="{{product.name}}"
                        class="newcollection-image-baby" />
                    </div>
                    <div class="d-flex baby_newprodname">

                      <div style="width: 100%;margin-bottom: 25px;">
                        <div style="display: flex;text-align: center;justify-content: center;"
                          *ngIf="product.stock_status == 'Available'">
                          <p style="font-size: 11px;color: gray;">{{product.stock_status}} (In Stock)</p>
                        </div>
                        <div style="display: flex;text-align: center;justify-content: center;"
                          class="justify-center-baby"
                          (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                          <p class="taz-newcol-name"> {{product.name}}
                          </p>
                        </div>
                        <div style="display: flex;justify-content: center;" class="justify-center-baby">
                          <p class="taz-newcol-price"> ₹ {{product.pricing.raw.price}}.00
                          </p>
                          <span
                            style="font-size: 15px !important;font-weight: 600; margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{
                            product.pricing.raw.msrp }}</span>
                        </div>
                        <div style="display: flex;justify-content: space-between;">
                          <div style="margin-top: 10px;width: 65%;">
                            <button
                              *ngIf="(appService.productIdinCart.indexOf(product.id) == -1 && product.product_type!='Variable') && (appService.productIdinCart.indexOf(product.id) == -1 && product.type!='Variable')"
                              class="btn btn-primary shubhcards-btn"
                              style="height: 35px;width: 100%;background-color: #1b52a4!important;border-radius: 5px !important;font-size: 12px;"
                              (click)="addToCart(product)">Add to Cart</button>
                            <div *ngFor="let cart of appService.cartProducts.results;let i = index">
                              <div class="btn btn-secondary inq-btn-st viewCart"
                                style="height: 35px;display: flex;justify-content: space-between;width: 100%;background-color: white!important; border-radius: 5px !important;padding: 0px !important;"
                                *ngIf="cart.product_id === product.id || cart.product_id === product.checkVariantInCart">
                                <button
                                  style="width: 35%;background-color: #1b52a4;display: flex;justify-content: center;height: 35px;border: none;border-top-left-radius: 5px;border-bottom-left-radius: 5px;">
                                  <i class="fa fa-minus" (click)="decreaseItem(i)"
                                    style="font-size: 12px; cursor: pointer; color: white; margin-top: 11px;"></i>
                                </button>
                                <div>
                                  <span
                                    style="color: black; font-size: 12px; width: 30px; display: inline-block; text-align: center;">
                                    {{ cart.quantity }}
                                  </span>
                                </div>
                                <button
                                  style="width: 35%;background-color: #1b52a4;display: flex;justify-content: center;height: 35px;border: none;border-top-right-radius: 5px;border-bottom-right-radius: 5px;">
                                  <i class="fa fa-plus" (click)="increaseItem(i)"
                                    style="font-size: 12px; cursor: pointer; color: white;margin-top: 11px;"></i>
                                </button>

                                <!-- <span style="font-size: 12px;">
                                <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                  style="font-size:12px;cursor:pointer;"></i></span>
                              <span class="inq-sp-2" style="color: white;font-size: 12px;">{{cart.quantity}}</span>
                              <span style="font-size: 12px;">
                                <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                  style="font-size:12px;cursor:pointer;"></i></span> -->
                              </div>
                            </div>
                          </div>
                          <div>
                            <i class="fa fa-shopping-cart"
                              style="color: transparent!important;-webkit-text-stroke: .5px rgb(174, 174, 174);margin-top: 20px;cursor: pointer;"
                              (click)="buyNow(product)"></i>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>


            </div>
          </ng-template>
        </ng-container>

      </owl-carousel-o>
    </div>
    <div class="mobile-only nav_arrow_taz">
      <div>
        <div class="container">
          <owl-carousel-o [options]="ProductSliderConfig" class="slider rounder-corner-nav"
            style="margin-top: 28px;position: relative;">
            <ng-container *ngFor="let product of newArrival; let i = index">
              <ng-template carouselSlide>
                <app-product-box-one [product]="product" [index]="i" style="display:block;width: 97%;"
                  class="taz_left_nav"></app-product-box-one>
              </ng-template>
            </ng-container>
          </owl-carousel-o>

        </div>
      </div>
    </div>
    <div class="taz_spec_ban">
      <div style="width: 100%;cursor: pointer;" class="taz_spe_mb taz_spe_mr me_dds">
        <div class="taz_transform_down">
          <p class="font_taz_ban">CARBONATED DRINKS</p>
        </div>
        <img src="../../../../assets/images/taazah/Taaza 1.png" (click)="productsListTazTest1('Carbonated Drink')" alt="CARBONATED DRINKS"
        title="CARBONATED DRINKS"  style="width: 100%;">
        <!-- <div class="home_transform_taz_carb">
  <button class="off_taz" (click)="productsListTaz('Carbonated Drink')">SHOP NOW</button>
</div> -->
      </div>
      <div style="width: 100%;cursor: pointer;" class="taz_spe_mr taz_spe_mb">
        <div class="taz_transform_down">
          <p class="font_taz_ban">FRUITS & VEGETABLES</p>
        </div>
        <img src="../../../../assets/images/taazah/taazahgreen.png" alt="FRUITS & VEGETABLES" title="FRUITS & VEGETABLES" class=""
          (click)="productsListTazTest1('Fruits & Vegetables')" style="width: 100%;border-radius: 7px;height:98%;">
        <div class="home_transform_taz">
          <!-- <button class="off_taz" (click)="productsListTaz('Fruits & Vegetables')">SHOP NOW</button> -->
        </div>
      </div>
      <div style="width: 100%;cursor: pointer;" class="taz_spe_mb">
        <div class="taz_transform_down_cosmetics">
          <p class="font_taz_ban">COSMETICS</p>
        </div>
        <img src="../../../../assets/images/taazah/Tazza Banner New 3.png" title="COSMETICS" alt="COSMETICS" (click)="productsListTazTest1('Shampoo')"
          style="width: 100%;border-radius: 7px;height: 98%;">
        <div class="home_transform_taz">
          <!-- <button class="off_taz" (click)="productsListTaz('Fruits & Vegetables')">SHOP NOW</button> -->
        </div>
      </div>
    </div>
    <div>
      <span style="font-size: 20px;font-weight: 700;font-family: system-ui;">Groceries</span>
    </div>
    <div class="desktop-only" style=" margin-top: 20px;margin-bottom: 25px;">
      <owl-carousel-o [options]="ProductSliderConfig7" class="slider2 rounder-corner-nav" style="width: 92%;">

        <ng-container class="revinfo" *ngFor="let product of tazgroceries; let i = index">
          <ng-template carouselSlide>
            <div style="">


              <div class="baby-newcollection">
                <div class="product-list-description-baby">
                  <div class="product-centering-baby">
                    <div>
                      <img [src]="product.assets[0].image_source" id="img-list"
                        (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{product.name}}"
                       title="{{product.name}}" class="newcollection-image-baby" />
                    </div>
                    <div class="d-flex baby_newprodname">

                      <div style="width: 100%;margin-bottom: 25px;">
                        <div style="display: flex;text-align: center;justify-content: center;"
                          *ngIf="product.stock_status == 'Available'">
                          <p style="font-size: 11px;color: gray;">{{product.stock_status}} (In Stock)</p>
                        </div>
                        <div style="display: flex;text-align: center;justify-content: center;"
                          class="justify-center-baby"
                          (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                          <p class="taz-newcol-name"> {{product.name}}
                          </p>
                        </div>
                        <div style="display: flex;justify-content: center;" class="justify-center-baby">
                          <p class="taz-newcol-price"> ₹ {{product.pricing.raw.price}}.00
                          </p>
                          <span
                            style="font-size: 15px !important;font-weight: 600; margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{
                            product.pricing.raw.msrp }}</span>
                        </div>
                        <div style="display: flex;justify-content: space-between;">
                          <div style="margin-top: 10px;width: 65%;">
                            <button
                              *ngIf="(appService.productIdinCart.indexOf(product.id) == -1 && product.product_type!='Variable') && (appService.productIdinCart.indexOf(product.id) == -1 && product.type!='Variable')"
                              class="btn btn-primary shubhcards-btn"
                              style="height: 35px;width: 100%;background-color: #1b52a4!important;border-radius: 5px !important;font-size: 12px;"
                              (click)="addToCart(product)">Add to Cart</button>
                            <div *ngFor="let cart of appService.cartProducts.results;let i = index">
                              <div class="btn btn-secondary inq-btn-st viewCart"
                                style="height: 35px;display: flex;justify-content: space-between;width: 100%;background-color: white!important; border-radius: 5px !important;padding: 0px !important;"
                                *ngIf="cart.product_id === product.id || cart.product_id === product.checkVariantInCart">
                                <button
                                  style="width: 35%;background-color: #1b52a4;display: flex;justify-content: center;height: 35px;border: none;border-top-left-radius: 5px;border-bottom-left-radius: 5px;">
                                  <i class="fa fa-minus" (click)="decreaseItem(i)"
                                    style="font-size: 12px; cursor: pointer; color: white; margin-top: 11px;"></i>
                                </button>
                                <div>
                                  <span
                                    style="color: black; font-size: 12px; width: 30px; display: inline-block; text-align: center;">
                                    {{ cart.quantity }}
                                  </span>
                                </div>
                                <button
                                  style="width: 35%;background-color: #1b52a4;display: flex;justify-content: center;height: 35px;border: none;border-top-right-radius: 5px;border-bottom-right-radius: 5px;">
                                  <i class="fa fa-plus" (click)="increaseItem(i)"
                                    style="font-size: 12px; cursor: pointer; color: white;margin-top: 11px;"></i>
                                </button>

                                <!-- <span style="font-size: 12px;">
                                  <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                    style="font-size:12px;cursor:pointer;"></i></span>
                                <span class="inq-sp-2" style="color: white;font-size: 12px;">{{cart.quantity}}</span>
                                <span style="font-size: 12px;">
                                  <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                    style="font-size:12px;cursor:pointer;"></i></span> -->
                              </div>
                            </div>
                          </div>
                          <div>
                            <i class="fa fa-shopping-cart"
                              style="color: transparent!important;-webkit-text-stroke: .5px rgb(174, 174, 174);margin-top: 20px;cursor: pointer;"
                              (click)="buyNow(product)"></i>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>


            </div>
          </ng-template>
        </ng-container>

      </owl-carousel-o>
    </div>
    <div class="mobile-only nav_arrow_taz">
      <div>
        <div class="container">
          <owl-carousel-o [options]="ProductSliderConfig" class="slider rounder-corner-nav"
            style="margin-top: 28px;position: relative;">
            <ng-container *ngFor="let product of tazgroceries; let i = index">
              <ng-template carouselSlide>
                <app-product-box-one [product]="product" [index]="i" style="display:block;width: 97%;"
                  class="taz_left_nav"></app-product-box-one>
              </ng-template>
            </ng-container>
          </owl-carousel-o>

        </div>
      </div>
    </div>
    <div class="mobile-only cashback_container_taz">
      <div class="code_number_taz">
        <p class="taz_offcod">A supermarket is not just where you shop; it’s where convenience meets choice, and every
          aisle offers the possibility of discovery.

        </p>
      </div>
      <div class="cashback_img_taz">
        <img src="../../../../assets/images/taazah/taz2mob.jpg" alt="Advert Banner" title="Advert Banner">
      </div>
    </div>
    <div class="desktop-only cashback_container_taz">
      <div class="code_number_taz">
        <h2 style="font-size: 24px!important;letter-spacing: 3px;">A supermarket is not just where you shop; it’s where
          convenience meets choice, and every aisle offers the possibility of discovery.

        </h2>
      </div>
      <div class="cashback_img_taz">
        <img src="../../../../assets/images/taazah/taz2.jpg" alt="Advert Banner" title="Advert Banner">
      </div>
    </div>
    <div style="margin-top: 15px;">
      <span style="font-size: 20px;font-weight: 700;font-family: system-ui;margin-top: 15px;">Dairy Products</span>
    </div>
    <div class="desktop-only" style=" margin-top: 20px;margin-bottom: 20px;">
      <owl-carousel-o [options]="ProductSliderConfig7" class="slider2 rounder-corner-nav" style="width: 92%;">

        <ng-container class="revinfo" *ngFor="let product of tazDairy; let i = index">
          <ng-template carouselSlide>
            <div style="">


              <div class="baby-newcollection">
                <div class="product-list-description-baby">
                  <div class="product-centering-baby">
                    <div>
                      <img [src]="product.assets[0].image_source" id="img-list"
                        (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{product.name}}" title="{{product.name}}"
                        class="newcollection-image-baby" />
                    </div>
                    <div class="d-flex baby_newprodname">

                      <div style="width: 100%;margin-bottom: 25px;">
                        <div style="display: flex;text-align: center;justify-content: center;"
                          *ngIf="product.stock_status == 'Available'">
                          <p style="font-size: 11px;color: gray;">{{product.stock_status}} (In Stock)</p>
                        </div>
                        <div style="display: flex;text-align: center;justify-content: center;"
                          class="justify-center-baby"
                          (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                          <p class="taz-newcol-name"> {{product.name}}
                          </p>
                        </div>
                        <div style="display: flex;justify-content: center;" class="justify-center-baby">
                          <p class="taz-newcol-price"> ₹ {{product.pricing.raw.price}}.00
                          </p>
                          <span
                            style="font-size: 15px !important;font-weight: 600; margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{
                            product.pricing.raw.msrp }}</span>
                        </div>
                        <div style="display: flex;justify-content: space-between;">
                          <div style="margin-top: 10px;width: 65%;">
                            <button
                              *ngIf="(appService.productIdinCart.indexOf(product.id) == -1 && product.product_type!='Variable') && (appService.productIdinCart.indexOf(product.id) == -1 && product.type!='Variable')"
                              class="btn btn-primary shubhcards-btn"
                              style="height: 35px;width: 100%;background-color: #1b52a4!important;border-radius: 5px !important;font-size: 12px;"
                              (click)="addToCart(product)">Add to Cart</button>
                            <div *ngFor="let cart of appService.cartProducts.results;let i = index">
                              <div class="btn btn-secondary inq-btn-st viewCart"
                                style="height: 35px;display: flex;justify-content: space-between;width: 100%;background-color: white!important; border-radius: 5px !important;padding: 0px !important;"
                                *ngIf="cart.product_id === product.id || cart.product_id === product.checkVariantInCart">
                                <button
                                  style="width: 35%;background-color: #1b52a4;display: flex;justify-content: center;height: 35px;border: none;border-top-left-radius: 5px;border-bottom-left-radius: 5px;">
                                  <i class="fa fa-minus" (click)="decreaseItem(i)"
                                    style="font-size: 12px; cursor: pointer; color: white; margin-top: 11px;"></i>
                                </button>
                                <div>
                                  <span
                                    style="color: black; font-size: 12px; width: 30px; display: inline-block; text-align: center;">
                                    {{ cart.quantity }}
                                  </span>
                                </div>
                                <button
                                  style="width: 35%;background-color: #1b52a4;display: flex;justify-content: center;height: 35px;border: none;border-top-right-radius: 5px;border-bottom-right-radius: 5px;">
                                  <i class="fa fa-plus" (click)="increaseItem(i)"
                                    style="font-size: 12px; cursor: pointer; color: white;margin-top: 11px;"></i>
                                </button>

                                <!-- <span style="font-size: 12px;">
                                <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                  style="font-size:12px;cursor:pointer;"></i></span>
                              <span class="inq-sp-2" style="color: white;font-size: 12px;">{{cart.quantity}}</span>
                              <span style="font-size: 12px;">
                                <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                  style="font-size:12px;cursor:pointer;"></i></span> -->
                              </div>
                            </div>
                          </div>
                          <div>
                            <i class="fa fa-shopping-cart"
                              style="color: transparent!important;-webkit-text-stroke: .5px rgb(174, 174, 174);margin-top: 20px;cursor: pointer;"
                              (click)="buyNow(product)"></i>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>


            </div>
          </ng-template>
        </ng-container>

      </owl-carousel-o>
    </div>
    <div class="mobile-only nav_arrow_taz">
      <div>
        <div class="container">
          <owl-carousel-o [options]="ProductSliderConfig" class="slider rounder-corner-nav"
            style="margin-top: 28px;position: relative;">
            <ng-container *ngFor="let product of tazDairy; let i = index">
              <ng-template carouselSlide>
                <app-product-box-one [product]="product" [index]="i" style="display:block;width: 97%;"
                  class="taz_left_nav"></app-product-box-one>
              </ng-template>
            </ng-container>
          </owl-carousel-o>

        </div>
      </div>
    </div>
    <div class="last_products_image_taz desktop-only">
      <img src="../../../../assets/images/taazah/taz1.png" alt="Compile Banner" title="Compile Banner" style="width: 100%;">
    </div>
    <div class=" mobile-only">
      <img class="last_products_image_taz" alt="Compile Banner" title="Compile Banner" src="../../../../assets/images/taazah/taz1mob.png">
    </div>
  </div>

  <section *ngIf="config.title === 'Schift Cosmetics'"
    style="margin-bottom: 30px; padding-top: 50px; background-color: #ffffff;">
    <h1 style="display: none;" *ngIf="config.title === 'Schift Cosmetics'">Best Skin care products for men & women |
      Schift</h1>
    <div class="elementor-container elementor-column-gap-no schift-leftsell1 desktop-only">
      <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-bd786cb"
        data-id="bd786cb" data-element_type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-bdcdc69 elementor-widget elementor-widget-heading"
            data-id="bdcdc69" data-element_type="widget" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <p class="elementor-heading-title elementor-size-default schift-1">Welcome to Schift—your destination for
                skin that's as vibrant as you are!
                Who doesn't want that enviable, radiant glow? Schift brings you a collection of skincare solutions
                designed to make clear, even skin tone achievable for everyone. Whether you're from Tokyo or Timbuktu,
                whether you're olive-toned or porcelain, Schift has got your back.
                Powered by cutting-edge research and development, our products are the brainchild of dermatologists who
                know their stuff. You can trust that each one is not only safe but also seriously effective. From the
                basics to the bespoke, Schift's got your skin covered.
                So why settle for anything less than glowing? Say hello to confidence and hello to Schift. Dive into our
                lineup today and let's make radiant skin a reality—for every face, every place, and every pace of life.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="schift_1_container">
        <div style="width: 100%;" data-id="8588fa9" data-element_type="column">
          <div style="width: 100%;" class="elementor-widget-wrap elementor-element-populated">
            <section
              class="elementor-section elementor-inner-section elementor-element elementor-element-f095ed9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="f095ed9" data-element_type="section">
              <div class="elementor-container12 elementor-column-gap-no" style="justify-content: space-between;">
                <div
                  class="elementor-column1 elementor-col-25 elementor-inner-column elementor-element elementor-element-f4d2f78"
                  data-id="f4d2f78" data-element_type="column">
                  <div class="elementor-widget-wrap elementor-element-populated">
                    <div
                      class="elementor-element elementor-element-fa03635 elementor-position-top elementor-widget elementor-widget-image-box"
                      data-id="fa03635" data-element_type="widget" data-widget_type="image-box.default">
                      <div class="elementor-widget-container">
                        <div class="elementor-image-box-wrapper">
                          <figure class="elementor-image-box-img"><a tabindex="-1"><img decoding="async" width="100"
                                height="100" src="../../../../assets/images/schift/schift 1.png"
                                class="attachment-full size-full wp-image-44" alt=""></a></figure>
                          <div class="elementor-image-box-content">
                            <h6 class="elementor-image-box-title"><a class="schift_home-1_title">Dermologist
                                Formulated</a></h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column1 elementor-col-25 elementor-inner-column elementor-element elementor-element-7592b11"
                  data-id="7592b11" data-element_type="column">
                  <div class="elementor-widget-wrap elementor-element-populated">
                    <div
                      class="elementor-element elementor-element-fdd13e2 elementor-position-top elementor-widget elementor-widget-image-box"
                      data-id="fdd13e2" data-element_type="widget" data-widget_type="image-box.default">
                      <div class="elementor-widget-container">
                        <div class="elementor-image-box-wrapper">
                          <figure class="elementor-image-box-img"><a tabindex="-1"><img decoding="async" width="100"
                                height="100" src="../../../../assets/images/schift/Schift 2_.png"
                                class="attachment-full size-full wp-image-45" alt=""></a></figure>
                          <div class="elementor-image-box-content">
                            <h6 class="elementor-image-box-title"><a class="schift_home-1_title">Safe and efficacious
                              </a></h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column1 elementor-col-25 elementor-inner-column elementor-element elementor-element-27ed11c"
                  data-id="27ed11c" data-element_type="column">
                  <div class="elementor-widget-wrap elementor-element-populated">
                    <div
                      class="elementor-element elementor-element-64b9dcd elementor-position-top elementor-widget elementor-widget-image-box"
                      data-id="64b9dcd" data-element_type="widget" data-widget_type="image-box.default">
                      <div class="elementor-widget-container">
                        <div class="elementor-image-box-wrapper">
                          <figure class="elementor-image-box-img"><a tabindex="-1"><img decoding="async" width="90"
                                height="100" src="../../../../assets/images/schift/Schift-icon-1.png"
                                class="attachment-full size-full wp-image-46" alt=""></a></figure>
                          <div class="elementor-image-box-content">
                            <h6 class="elementor-image-box-title"><a class="schift_home-1_title"> Key ingredients
                                naturally derived</a></h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column1 elementor-col-25 elementor-inner-column elementor-element elementor-element-0396511"
                  data-id="0396511" data-element_type="column">
                  <div class="elementor-widget-wrap elementor-element-populated">
                    <div
                      class="elementor-element elementor-element-eccddb2 elementor-position-top elementor-widget elementor-widget-image-box"
                      data-id="eccddb2" data-element_type="widget" data-widget_type="image-box.default">
                      <div class="elementor-widget-container">
                        <div class="elementor-image-box-wrapper">
                          <figure class="elementor-image-box-img"><a tabindex="-1"><img loading="lazy" decoding="async"
                                width="100" height="100" src="../../../../assets/images/schift/Schift-icon-2.png"
                                class="attachment-full size-full wp-image-47" alt=""></a></figure>
                          <div class="elementor-image-box-content">
                            <h6 class="elementor-image-box-title"><a class="schift_home-1_title">Cruelty free</a></h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div class="elementor-container elementor-column-gap-no schift-leftsell1 mobile-only">
      <div class="schift_1_container">
        <div style="width: 100%;" data-id="8588fa9" data-element_type="column">
          <div style="width: 100%;" class="elementor-widget-wrap elementor-element-populated">
            <section
              class="elementor-section elementor-inner-section elementor-element elementor-element-f095ed9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="f095ed9" data-element_type="section">
              <div class="elementor-container12 elementor-column-gap-no" style="justify-content: space-between;">
                <div
                  class="elementor-column1 elementor-col-25 elementor-inner-column elementor-element elementor-element-f4d2f78"
                  data-id="f4d2f78" data-element_type="column">
                  <div class="elementor-widget-wrap elementor-element-populated">
                    <div
                      class="elementor-element elementor-element-fa03635 elementor-position-top elementor-widget elementor-widget-image-box"
                      data-id="fa03635" data-element_type="widget" data-widget_type="image-box.default">
                      <div class="elementor-widget-container">
                        <div class="elementor-image-box-wrapper">
                          <figure class="elementor-image-box-img"><a tabindex="-1"><img decoding="async" width="100"
                                height="100" src="../../../../assets/images/schift/schift 1.png"
                                class="attachment-full size-full wp-image-44" alt=""></a></figure>
                          <div class="elementor-image-box-content">
                            <h6 class="elementor-image-box-title"><a class="schift_home-1_title">Dermologist
                                Formulated</a></h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column1 elementor-col-25 elementor-inner-column elementor-element elementor-element-7592b11"
                  data-id="7592b11" data-element_type="column">
                  <div class="elementor-widget-wrap elementor-element-populated">
                    <div
                      class="elementor-element elementor-element-fdd13e2 elementor-position-top elementor-widget elementor-widget-image-box"
                      data-id="fdd13e2" data-element_type="widget" data-widget_type="image-box.default">
                      <div class="elementor-widget-container">
                        <div class="elementor-image-box-wrapper">
                          <figure class="elementor-image-box-img"><a tabindex="-1"><img decoding="async" width="100"
                                height="100" src="../../../../assets/images/schift/Schift 2_.png"
                                class="attachment-full size-full wp-image-45" alt=""></a></figure>
                          <div class="elementor-image-box-content">
                            <h6 class="elementor-image-box-title"><a class="schift_home-1_title">Safe and efficacious
                              </a></h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column1 elementor-col-25 elementor-inner-column elementor-element elementor-element-27ed11c"
                  data-id="27ed11c" data-element_type="column">
                  <div class="elementor-widget-wrap elementor-element-populated">
                    <div
                      class="elementor-element elementor-element-64b9dcd elementor-position-top elementor-widget elementor-widget-image-box"
                      data-id="64b9dcd" data-element_type="widget" data-widget_type="image-box.default">
                      <div class="elementor-widget-container">
                        <div class="elementor-image-box-wrapper">
                          <figure class="elementor-image-box-img"><a tabindex="-1"><img decoding="async" width="90"
                                height="100" src="../../../../assets/images/schift/Schift-icon-1.png"
                                class="attachment-full size-full wp-image-46" alt=""></a></figure>
                          <div class="elementor-image-box-content">
                            <h6 class="elementor-image-box-title"><a class="schift_home-1_title"> Key ingredients
                                naturally derived</a></h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="elementor-column1 elementor-col-25 elementor-inner-column elementor-element elementor-element-0396511"
                  data-id="0396511" data-element_type="column">
                  <div class="elementor-widget-wrap elementor-element-populated">
                    <div
                      class="elementor-element elementor-element-eccddb2 elementor-position-top elementor-widget elementor-widget-image-box"
                      data-id="eccddb2" data-element_type="widget" data-widget_type="image-box.default">
                      <div class="elementor-widget-container">
                        <div class="elementor-image-box-wrapper">
                          <figure class="elementor-image-box-img"><a tabindex="-1"><img loading="lazy" decoding="async"
                                width="100" height="100" src="../../../../assets/images/schift/Schift-icon-2.png"
                                class="attachment-full size-full wp-image-47" alt=""></a></figure>
                          <div class="elementor-image-box-content">
                            <h6 class="elementor-image-box-title"><a class="schift_home-1_title">Cruelty free</a></h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-bd786cb"
        data-id="bd786cb" data-element_type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-bdcdc69 elementor-widget elementor-widget-heading"
            data-id="bdcdc69" data-element_type="widget" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <p class="elementor-heading-title elementor-size-default schift-1">Welcome to Schift—your destination for
                skin that's as vibrant as you are!
                Who doesn't want that enviable, radiant glow? Schift brings you a collection of skincare solutions
                designed to make clear, even skin tone achievable for everyone. Whether you're from Tokyo or Timbuktu,
                whether you're olive-toned or porcelain, Schift has got your back.
                Powered by cutting-edge research and development, our products are the brainchild of dermatologists who
                know their stuff. You can trust that each one is not only safe but also seriously effective. From the
                basics to the bespoke, Schift's got your skin covered.
                So why settle for anything less than glowing? Say hello to confidence and hello to Schift. Dive into our
                lineup today and let's make radiant skin a reality—for every face, every place, and every pace of life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="schift_line-1">

    <div style="margin-top: 35px;" class="scift-left-best">
      <h2 style="line-height: 1.25em;
font-size: 40px;
font-weight: 600;
font-family: Trebuchet MS, sans-serif; margin-bottom: 35px;" class="schift-leftsell">Bestsellers</h2>

      <div class="shift-2">
        <div class="shift-3">
          <div *ngFor="let product of recommededProductsBestSch; let i = index">
            <div style="color: lightgray">
              <div class="avon1-img">
                <div class="listing_Card_Promo">
                  <span *ngFor="let product1 of product.discounts_text"
                    class="product_offer_card product-card_off_left">
                    <span class="schift_key_offer" [innerHTML]="product1.product_card_view_promotion"></span>
                  </span>
                </div>
                <img [src]="product.assets[0].image_source" id="img-list"
                  (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                  class="product-list-image-avonseals" />
              </div>
              <div class="product-list-description-deera">
                <div style="margin-left: -3%;">
                  <div class="d-flex avon_prodname">

                    <div>
                      <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                        class="product-list-tile-avon1">{{product.name}}
                      </p>
                      <!-- <p (click)="productDetails(product.id)" class="product-list-price-schift">₹ {{product.pricing.raw.price}}
              </p> -->
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="shift-4">
          <div class="scift-single-prod">
            <div class="schiftimg-h1">
              <img src="../../../../assets/images/schift/Schift-model-images-1.png" class="shift-big-img">
              <div class="schift-imgcont">
                <p class="schift-imgcont1">Made with best ingredients</p>
                <p class="schift-imgcont2">Our products transparent ingredient lists allow you to know what’s going on
                  your skin. Literally.</p>
              </div>
            </div>
            <!-- <div>
    <p class="product-list-tile-avon1 schift-spec-text">Smooth skin super booster
    </p>
    <p class="product-list-price-schift schift-spec-text">₹ 885
    </p>
  </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="shift-5">
      <div class="shift-6">
        <div class="shift-7">
          <div
            style="background-image: url(../../../../assets/images/schift/Schift-model-images-2.png);background-repeat: no-repeat;background-size: cover;">
            <div style="padding-top: 80px; display: flex;justify-content: center;">
              <p style="color: white;font-size: 18px;font-weight: 500;">Skin Care Products</p>
            </div>
            <div style="margin-top: 12px; display: flex;justify-content: center;">
              <p style="color: white;font-size: 40px;font-weight: 600;">Skin Care</p>
            </div>
            <div style="margin-top: 20px;padding-bottom: 80px; display: flex;justify-content: center;">
              <button class="schift_home_button-1" (click)="productsListTazTest1('Skin Care')">Shop Now</button>
            </div>
          </div>
        </div>

        <div class="shift-7">
          <div
            style="background-image: url(../../../../assets/images/schift/TravelBan.jpg);background-size: cover;background-repeat: no-repeat;">
            <div style="padding-top: 80px; display: flex;justify-content: center;">
              <p style="color: white;font-size: 18px;font-weight: 500;">Travel Products</p>
            </div>
            <div style="margin-top: 12px; display: flex;justify-content: center;">
              <p style="color: white;font-size: 40px;font-weight: 600;">Travel Care</p>
            </div>
            <div style="margin-top: 20px;padding-bottom: 80px; display: flex;justify-content: center;">
              <button class="schift_home_button-1" (click)="productsListTazTest1('Travel Care')">Shop Now</button>
            </div>
          </div>
        </div>
        <div class="shift-7">
          <div
            style="background-image: url(../../../../assets/images/schift/Schift-model-images-3.png);background-size: cover;background-repeat: no-repeat;">
            <div style="padding-top: 80px; display: flex;justify-content: center;">
              <p style="color: white;font-size: 18px;font-weight: 500;">Hair Care Products</p>
            </div>
            <div style="margin-top: 12px; display: flex;justify-content: center;">
              <p style="color: white;font-size: 40px;font-weight: 600;">Hair Care</p>
            </div>
            <div style="margin-top: 20px;padding-bottom: 80px; display: flex;justify-content: center;">
              <!-- <button class="schift_home_button-1" (click)="productsListSchift('Hair Care')">Shop Now</button> -->
              <button class="schift_home_button-1">Launching Soon..</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 65px;">
      <div class="schift-6">
        <div class="schift-8 schift-leftsell1">
          <h3 class="schift-text-key1">You deserve a little gift that says "love"</h3>
          <!-- <p class="schift-text-key2">Our products include rich ingredients that make skin soft, smooth, and supple. Our high-quality product nourishes hair from the inside out, leaving it silky & strong.</p> -->
          <!-- <button class="schift_home_button-2">Choose Your Product</button> -->
        </div>
        <div class="schift-9">
          <img src="../../../../assets/images/schift/Schift-product-images-6.png" class="schift-10">
        </div>
      </div>
    </div>
    <div style="margin-top: 40px; margin-left: 1%;">
      <div class="schift_complogo">
        <div class="just_center_log">
          <img src="../../../../assets/images/schift/logo1-removebg-preview.png" class="schift_log_img">
        </div>
        <div class="just_center_log">
          <img src="../../../../assets/images/schift/logo2-removebg-preview.png" class="schift_log_img">
        </div>
        <div class="just_center_log">
          <img src="../../../../assets/images/schift/logo3-removebg-preview.png" class="schift_log_img">
        </div>
      </div>
    </div>
    <div class="desktop-only" style="margin-top: 40px; margin-left: 1%;">
      <div data-id="3071dbe" data-element_type="column" class="schift-footer">
        <div class="schift-11">
          <div data-id="e8b1f7c" data-element_type="widget" data-widget_type="heading.default"
            class="margin-left10 margin-bottom15">
            <div>
              <h2 class="schift_founder1">Meet the Founder</h2>
            </div>
          </div>
          <div data-id="a062b67" data-element_type="widget" data-widget_type="heading.default"
            class="margin-left10 margin-bottom35">
            <div>
              <h3 class="schift_founder">Dr. Priya Ramanathan</h3>
            </div>
            <div>
              <h3 class="schift_founder2">Dermatologist</h3>
            </div>
          </div>
          <div data-id="5591530" data-element_type="widget" data-widget_type="text-editor.default"
            class="margin-left10">
            <div>
              <p class="schift-eddes">Introducing Dr. Priya Ramanathan, the powerhouse behind Schift—a game-changer in
                the world of dermatology and aesthetic medicine.
                With over 17 years of experience, Dr. Priya isn't your average dermatologist. As the mastermind behind
                MOHB Growell Private Limited, she's on a mission to redefine skincare as we know it.
                Dr. Priya's accolades speak volumes about her commitment to excellence. She has been a speaker at
                various state, national and international forums. From winning the fourth prize in poster presentation
                at the International Congress of Dermatology to being a featured speaker at prestigious events like
                IMCAS Asia, she's a force to be reckoned with.
                But, her impact extends far beyond the conference halls. Dr. Priya's dedication to public education is
                evident in her annual skin and hair camps, where she spreads awareness and knowledge to communities far
                and wide. She's also a familiar face on radio and TV, using her platform to advocate for skincare
                literacy and empowerment.A proud member of esteemed medical societies like the Indian Association of
                Dermatologists, Venereologists and Leprologists (IADVL) and the Association of Cutaneous Surgeons of
                India (ACSI), Dr. Priya is the epitome of #BossGoals.
                With Schift, Dr. Priya brings her infectious energy and expertise to the table, helping you unleash your
                inner glow and slay every day. Join her squad of radiant skin warriors and let's take the skincare world
                by storm!
              </p>
            </div>
          </div>
          <div data-id="9beb90d" data-element_type="widget" data-widget_type="image.default">
            <div>
              <img loading="lazy" decoding="async" width="253" height="163" class="schift_sign_img"
                src="../../../../assets/images/schift/sign.png" alt="">
            </div>
          </div>
          <!-- <div data-id="ab5106c" data-element_type="widget" data-widget_type="button.default" class="margin-left10 schift_readmore">
          <div style="width: 85%;">
          <div style="display: flex;
          justify-content: end;">
          <a class="elementor-button elementor-button-link elementor-size-sm" href="#/about-us">
          <span class="schift-eddes2">
          <span class="schift-eddes1">Read More</span>
          </span>
          </a>
          </div>
          </div>
          </div> -->
        </div>
        <div style="width: 49%;">
          <div>
            <img src="../../../../assets/images/schift/Priya.png" alt="" style="width: 100%;">
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-only" style="margin-top: 65px; margin-left: 1%;">
      <div data-id="3071dbe" data-element_type="column" class="schift-footer">
        <div>
          <div>
            <img src="../../../../assets/images/schift/Priya.png" alt="" style="width: 100%;">
          </div>
        </div>
        <div class="schift-11">
          <div data-id="e8b1f7c" data-element_type="widget" data-widget_type="heading.default"
            class="margin-left10 margin-bottom15">
            <div>
              <h2 class="schift_founder1">Meet the Founder</h2>
            </div>
          </div>
          <div data-id="a062b67" data-element_type="widget" data-widget_type="heading.default"
            class="margin-left10 margin-bottom35">
            <div>
              <h3 class="schift_founder">Dr. Priya Ramanathan</h3>
            </div>
            <div>
              <h3 class="schift_founder2">Dermatologist</h3>
            </div>
          </div>
          <div data-id="5591530" data-element_type="widget" data-widget_type="text-editor.default"
            class="margin-left10">
            <div>
              <p class="schift-eddes">Introducing Dr. Priya Ramanathan, the powerhouse behind Schift—a game-changer in
                the world of dermatology and aesthetic medicine.
                With over 17 years of experience, Dr. Priya isn't your average dermatologist. As the mastermind behind
                MOHB Growell Private Limited, she's on a mission to redefine skincare as we know it.
                Dr. Priya's accolades speak volumes about her commitment to excellence. She has been a speaker at
                various state, national and international forums. From winning the fourth prize in poster presentation
                at the International Congress of Dermatology to being a featured speaker at prestigious events like
                IMCAS Asia, she's a force to be reckoned with.
                But, her impact extends far beyond the conference halls. Dr. Priya's dedication to public education is
                evident in her annual skin and hair camps, where she spreads awareness and knowledge to communities far
                and wide. She's also a familiar face on radio and TV, using her platform to advocate for skincare
                literacy and empowerment.A proud member of esteemed medical societies like the Indian Association of
                Dermatologists, Venereologists and Leprologists (IADVL) and the Association of Cutaneous Surgeons of
                India (ACSI), Dr. Priya is the epitome of #BossGoals.
                With Schift, Dr. Priya brings her infectious energy and expertise to the table, helping you unleash your
                inner glow and slay every day. Join her squad of radiant skin warriors and let's take the skincare world
                by storm!
              </p>
            </div>
          </div>
          <div data-id="9beb90d" data-element_type="widget" data-widget_type="image.default">
            <div>
              <img loading="lazy" decoding="async" width="253" height="163" class="schift_sign_img"
                src="../../../../assets/images/schift/sign.png" alt="">
            </div>
          </div>
          <div data-id="ab5106c" data-element_type="widget" data-widget_type="button.default"
            class="margin-left10 schift_readmore">
            <div>
              <div>
                <a class="elementor-button elementor-button-link elementor-size-sm" href="#/about-us">
                  <span class="schift-eddes2">
                    <!-- <span class="schift-eddes1">Read More</span> -->
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div style="margin-top: 35px; padding-bottom: 40px;">
      <div style="display: flex; justify-content: center;">
        <h3 class="schift_fav1">FOUNDER'S CHOICE</h3>
      </div>
      <div class="schift-footer1 schift-leftsell1">
        <div *ngFor="let product of recommededProductsSchift; let i = index" class="product-list-description-schift">
          <div>
            <div>
              <img [src]="product.assets[0].image_source" id="img-list"
                (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                class="product-list-image-schift" />
            </div>
            <div class="d-flex avon_prodname">

              <div style="width: 100%;">
                <div style="display: flex; justify-content: center;width: 100%;" class="schift-12">
                  <div style="width: 70%;">
                    <p (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                      class="product-list-tile-schift21">{{product.name}}
                    </p>
                  </div>
                </div>
                <div style="display: flex; justify-content: center;">
                  <!-- <p (click)="productDetails(product.id)" class="product-list-price-schift1">₹ {{product.pricing.raw.price}}
                  </p> -->
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 35px; padding-bottom: 40px;">
      <div style="display: flex; justify-content: center;">
        <h3 class="schift_fav1">OUR CATEGORIES</h3>
      </div>
      <div class="home-container7">
        <div *ngFor="let pro of featuredSchiftProductsCollection ;let i = index">
          <div style="transition: none !important;cursor: pointer;" class="isempty schift-height1">
            <div>
              <div class="home-card schift-height1" style="padding: 10px;">
                <div class="schift-height1">

                  <div style="width:100%">
                    <img style=" object-fit: contain;width:100% !important" [src]="pro.image" class="schift-height2"
                      (click)="productsListTazTest1(pro.title)">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- AVONSEALS -->
  <section class="review-title" *ngIf="config.title === 'AvonSeals'"
    style="background-size: cover;background-position: center;object-fit: cover;margin-bottom: 10px; background-image: url('../../../../assets/images/avonseals/pexels-nick-collins-1293120.jpg');">
    <div class="text-center mb-2" style="margin-top:20px">
      <br>
      <!-- <h3 class="text-primary"><strong style="color: rgb(245 236 236)!important; font-size: 12px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;"> TESTIMONIAL</strong></h3> -->
    </div>
    <div class="text-center">
      <h4 class="head-text"><strong
          style="font-size: 22px;color: rgb(245 236 236)!important;;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">OUR
          HAPPY CUSTOMERS</strong></h4>
      <h4
        style="font-size: 15px;color: rgb(245 236 236)!important;;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">
        Our Customers Review</h4>
      <br>
    </div>
    <br>
    <owl-carousel-o [options]="ProductSliderConfig" class="slider2 rounder-corner-nav">

      <ng-container class="revinfo" *ngFor="let product of products;let i =index">
        <!-- <div class="slide-button"> <div class="review-carousel">
      <a class="carousel-control-prev " href="#inqCaro" role="button" data-slide="prev">
          <span style="background-color: #E48C8C; border-radius: 50%; padding: 10px 15px; opacity: 1 !important;"><img src="../../assets/images/vendor/previous.png"></span>
          <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#inqCaro" role="button" data-slide="next">  
          <span style="background-color: #E48C8C; border-radius: 50%; padding: 10px 15px; opacity: 1 !important;"><img src="../../assets/images/vendor/next.png"></span>
          <span class="sr-only">Next</span>
      </a>
  </div></div> -->
        <ng-template carouselSlide>


          <div class="star">

            <div class="review" style="display: flex; background-color: aliceblue">
              <img src="../../../../assets/images/avonseals/user_318-159711.avif" alt="Avatar" style="border-radius: 50%; width:30%; height: 20%; margin-right: 5px;top: 35px;
            position: sticky;">
              <div class="inf1">
                <div class="inner-star-icon review-mob pd-1" style="align-items: center;
              justify-content: center;margin-top:10px;">
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                </div>
                <p *ngIf="config.title == 'AvonSeals'"
                  style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">Avon
                  Seals Pvt. Ltd. is one of the largest Indian manufacturer of Mechanical Seals for Agricultural,
                  Domestic and Automotive Water Pump. The company pioneered the introduction of seals, which are immune
                  to dry running of pumps, in India. </p>
                <p *ngIf="config.title !== 'AvonSeals'"
                  style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">I
                  would like to add that I have been with delighted with the results since using your products and I
                  have seen a big improvement in my skin and This face cream actually just melts into my dry sensitive
                  face.. Love love this.</p>
                <br>
                <h4 class="rev" style="font-size: 18px;">Customer name</h4>
                <h4 class="date-review" style="font-size: 12px; opacity: 0.5;">Monday May 15 2023</h4>
              </div>
            </div>
          </div>


        </ng-template>
        <ng-template carouselSlide>
          <div class="star">

            <div class="review" style="display: flex; background-color: aliceblue">
              <img src="../../../../assets/images/avonseals/user_318-159711.avif" alt="Avatar" style="border-radius: 50%; width:30%; height: 20%; margin-right: 5px;top: 35px;
            position: sticky;">
              <div class="inf2">
                <div class="inner-star-icon review-mob pd-1" style="align-items: center;
            justify-content: center;margin-top: 10px;">
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                </div>
                <p *ngIf="config.title === 'AvonSeals'"
                  style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">Avon
                  Seals Pvt. Ltd. is one of the largest Indian manufacturer of Mechanical Seals for Agricultural,
                  Domestic and Automotive Water Pump. The company pioneered the introduction of seals, which are immune
                  to dry running of pumps, in India. </p>
                <p *ngIf="config.title !== 'AvonSeals'"
                  style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">'I’m
                  very keen on these amazing products by Conscious Skincare. They not only smell divine, feel gorgeous
                  but have the ingredients that I dream of! No nasties, just pure, thought out, conscious ingredients.
                </p>
                <br>
                <h4 class="categories" style="font-size: 18px;">Customer name</h4>
                <h4 class="date-review" style="font-size: 12px; opacity: 0.5;">Thursday May 4 2023</h4>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="star">

            <div class="review" style="display: flex; background-color: aliceblue">
              <img src="../../../../assets/images/avonseals/user_318-159711.avif" alt="Avatar" style="border-radius: 50%; width:30%; height: 20%; margin-right: 5px;top: 35px;
            position: sticky;">
              <div class="inf3">
                <div class="inner-star-icon review-mob pd-1" style="align-items: center;
              justify-content: center;margin-top: 10px;">
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                </div>
                <p *ngIf="config.title == 'AvonSeals'"
                  style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">Avon
                  Seals Pvt. Ltd. is one of the largest Indian manufacturer of Mechanical Seals for Agricultural,
                  Domestic and Automotive Water Pump. The company pioneered the introduction of seals, which are immune
                  to dry running of pumps, in India. </p>
                <p *ngIf="config.title !== 'AvonSeals'"
                  style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">
                  'Amazing as always. I have been using Conscious Skincare for over a year now (my mom as well!) and all
                  of the products are incredibly good to my skin. Highly recommended!' all of the products are
                  incredibly good to my skin. Highly recommended!' </p>
                <br>
                <h4 class="customer-name" style="font-size: 18px;">Customer name</h4>
                <h4 class="date-review" style="font-size: 12px; opacity: 0.5;">Thursday May 11 2023</h4>
              </div>
            </div>
          </div>

          <!-- <p style="margin-left:10px;font-family: 'proxima-regular','sans-serif'!important;color: rgb(229, 200, 200)!important;">{{review.comment}}</p>
        <p style="margin-left:10px;font-family: 'proxima-regular','sans-serif'!important;color: rgb(229, 200, 200)!important;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>--{{review.user}}</b></p> -->
        </ng-template>
      </ng-container>

    </owl-carousel-o>

  </section>


  <div
    *ngIf="recommededProducts.length != 0 && config.title!=='Vimpro' && config.title!=='Vistas' && config.title!=='LinenRaj' && config.title!=='Babys Pride' && config.title !== 'LushNGreen' && config.title!=='Schift Cosmetics' && config.title!=='KatbookStore' && config.title!=='ShubhCards' && config.title!=='Taazah'  && config.title !== 'Deera' && config.title!=='SriSenbaga' && config.title!=='HOB' && config.title!=='PaulCaroline' && config.title!=='Srimaware' && config.title!=='UrbanBox'">
    <div class="container" *ngIf="config.title !== 'Deera'">
      <section class="featured-recommendations pb-50"
        *ngIf="config.title !== 'AvonSeals' && config.title !== 'SpecialWires' && config.title !== 'Deera'">
        <div class="row">
          <div class="col-sm-12 col-lg-12 our_featured-products">
            <div class="content-title" *ngIf="config.title !== 'BestGifts '&& config.title !== 'Beaubelle'">
              <div class="title-box">
                <h2 class="title main-title"
                  *ngIf="config.title !== 'LuckMe'&&config.title !== 'Karupattiraja' && config.title !== 'ShubhCards' && config.title !== 'Deera' && config.title !== 'BestGifts'&& config.title !== 'Kubendran' && config.title !== 'Aiema' && config.title !== 'Cle' && config.title !== 'Beaubelle' && config.title !== 'BombayHardware' && config.title !== 'AvonSeals' && config.title !== 'SpecialWires' && config.title !== 'Schift Cosmetics'">
                  Our Collections & Featured Design</h2>
                <h2 class="title main-title" *ngIf="config.title === 'Aiema'"
                  style="text-shadow: none !important;font-family: 'proxima-regular','sans-serif'!important;">Popular
                  Listings</h2>
                <!-- <h2 class="title main-title" *ngIf="config.title === 'Cle'" style="text-shadow: none !important;font-family: 'proxima-regular','sans-serif'!important;">Popular Listings</h2> -->
                <!-- <h2 class="title main-title" *ngIf="config.title === 'Beaubelle' " style="text-shadow: none !important;font-family: 'proxima-regular','sans-serif'!important;">Popular Listings</h2> -->
                <h2 class="title main-title" *ngIf="config.title === 'BombayHardware'"
                  style="text-shadow: none !important;font-family: 'proxima-regular','sans-serif'!important;color: #AD342A!important">
                  Popular Listings</h2>
                <h2 class="title main-title" *ngIf="config.title == 'LuckMe'||config.title == 'Karupattiraja'">Our
                  Featured Products</h2>

                <h4 class="sub-title submain-title"
                  *ngIf="config.title != 'LuckMe'&&config.title != 'Karupattiraja' && config.title !== 'ShubhCards' && config.title !== 'Deera' && config.title !== 'BestGifts'&& config.title !== 'Kubendran' && config.title !== 'Aiema' && config.title !== 'Cle'  && config.title !== 'Beaubelle' && config.title !== 'BombayHardware' && config.title !== 'AvonSeals' && config.title !== 'Schift Cosmetics' && config.title !== 'SpecialWires'">
                  Passion for Designing
                </h4>
              </div>
              <!-- <div *ngIf="config.title == 'ShubhCards'" class="text-center mb-5">
                <h3 class="text-primary" style="font-family: Helvetica;"> Our Featured Cards</h3>
            </div> -->


              <!-- <div *ngIf="config.title == 'Deera'" class="text-center deera-m-b-5 deera-featured-products" >
              <h3 class="text-primary"> Our Featured Products</h3>
          </div> -->
            </div>
            <div *ngIf="config.title === 'Kubendran'" style="background-image: url('assets/images/Kubendran/background_review.jpg');background-size: 100% 100%;
          background-repeat: no-repeat;">
              <owl-carousel-o [options]="ProductSliderConfig3" class="slider rounder-corner-nav">
                <ng-container>
                  <ng-template carouselSlide>
                    <div id="bombayhardwarecards1" style="margin-bottom: 42px;">
                      <div class="kubendran1">
                        <div class="img-holder1">
                          <div class="bombayhardware1-img text-center">
                            <img style="object-fit: contain !important;" height="100px"
                              src="assets/images/Kubendran/dev1.jpg">
                            <b style="font-size: 18px;">Raghul</b>
                            <p style="font-weight: 900;">Developer</p>
                            <p>“We've recently updated our entire product portfolio to give customers and
                              partners the best products with the newest technology. Come see our expanded award-winning
                              product line.”</p>
                          </div>
                        </div>

                      </div>
                    </div>
                  </ng-template>
                  <ng-template carouselSlide>
                    <div id="bombayhardwarecards1" style="margin-bottom: 42px;">
                      <div class="kubendran1">
                        <div class="img-holder1">
                          <div class="bombayhardware1-img text-center">
                            <img style="object-fit: contain !important;" src="assets/images/Kubendran/dev2.jpg"
                              height="100px">
                            <b style="font-size: 18px;">Arul</b>
                            <p style="font-weight: 900;">Developer</p>
                            “We've recently updated our entire product portfolio to give customers and
                            partners the best products with the newest technology. Come see our expanded award-winning
                            product line.”
                          </div>
                        </div>

                      </div>
                    </div>
                  </ng-template>
                </ng-container>
              </owl-carousel-o>
            </div>
            <div *ngIf="config.title === 'Kubendran'" class="text-center mb-5" style="margin-top: 28px;">
              <h3 class="text-primary" style="color: #2a7d2e!important;"> Our Featured Products</h3>
            </div>
            <div *ngIf="config.title == 'BestGifts'" class="text-center mb-5">
              <h3 class="text-primary" style="color: #2661a0!important;"> Our Featured Products</h3>
            </div>
            <div *ngIf="config.title == 'Beaubelle'" class="text-center mb-5">
              <h3 class="text-primary" style="color: #e7762d!important;margin-top: -10px;"> Our Featured Products</h3>
            </div>
            <owl-carousel-o *ngIf="config.title!='Vimpro'&&config.title!='Karupattiraja' &&config.title!='Deera'"
              [options]="ProductSliderConfig" class="slider rounder-corner-nav"
              style="margin-top: 28px;position: relative;">
              <ng-container *ngFor="let product of recommededProducts; let i = index">
                <ng-template carouselSlide>
                  <app-product-box-one [product]="product" [index]="i"
                    style="display:block;width: 98%;margin-left: 1%;"></app-product-box-one>
                </ng-template>
              </ng-container>
            </owl-carousel-o>
            <owl-carousel-o *ngIf="config.title=='Karupattiraja'" [options]="ProductSliderConfig"
              class="slider5 rounder-corner-nav" style="margin-top: 28px;position: relative;">
              <ng-container *ngFor="let product of recommededProducts; let i = index">
                <!-- <ng-template carouselSlide>
                    <app-product-box-one [product]="product" [index]="i" style="display:block;width: 98%;margin-left: 1%;"></app-product-box-one>              
                </ng-template>  -->
                <ng-template carouselSlide>
                  <app-product-box-one class="kpr-frproduct" [product]="product" [index]="i"></app-product-box-one>
                </ng-template>
              </ng-container>
            </owl-carousel-o>
          </div>
        </div>
      </section>
    </div>
  </div>
  <!-- <div *ngIf="config.title === 'Deera'" class="text-center deera-m-b-5" style="margin-bottom: 35px; background-image: url('../../../../assets/images/deera/Untitled\ design\(8\).png');">
    <h3 class="text-primary" style="color: #1e4edc !important;"> PANDURANGA ENTERPRISES(DEERA)</h3>
    <div style="display: grid;">
    <span><span style="color: #1e4edc;;">Click Here for</span>
    <a href="https://www.google.com/search?q=panduranga+enterprises+bangalore&oq=pan&gs_lcrp=EgZjaHJvbWUqDwgAECMYJxjjAhiABBiKBTIPCAAQIxgnGOMCGIAEGIoFMhIIARAuGCcYrwEYxwEYgAQYigUyDAgCEEUYORixAxiABDINCAMQABiDARixAxiABDINCAQQABiDARixAxiABDINCAUQABiDARixAxiABDIHCAYQLhiABDIKCAcQABixAxiABDIHCAgQABiABDINCAkQABixAxiABBiKBTIHCAoQLhiABDIHCAsQLhiABDIHCAwQABiABDINCA0QABiDARixAxiABDIHCA4QABiABNIBCDI0NjdqMGo0qAIAsAIA&client=ms-android-vivo-rvo3&sourceid=chrome-mobile&ie=UTF-8" target="_blank"><span style="text-decoration: underline;" class="deera_link"> Our Google Reviews</span></a>
  </span>
  <div style="display: flex; justify-content: center; margin-top: 10px;">
  <span [class]="'fa fa-star'"
  style="font-size: 30px !important;color: orange !important;"></span>
<span [class]="'fa fa-star'"
  style="font-size: 30px !important;color: orange !important;"></span>
<span [class]="'fa fa-star'"
  style="font-size: 30px !important;color: orange !important;"></span>
<span [class]="'fa fa-star'"
  style="font-size: 30px !important;color: orange !important;"></span>
<span [class]="'fa fa-star'"
  style="font-size: 30px !important;color: orange !important;"></span>
  <span></span>
</div>
<div style="display: flex; justify-content: center;">
  <span style="font-size: 35px; font-weight: 900;color: #1e4edc;">4.9</span><span style="font-size: 15px; font-weight: 400;margin-top: 20px;color: #1e4edc;">/5</span>
</div>
</div>
  </div> -->
  <section *ngIf="config.title === 'SriSenbaga'" style="background-color:#fafaf8">

    <div class="additional-features">
      <div class="feature-shenbaga">
        <img src="../../../../assets/images/shenbaga/imgs1.png">
        <p class="feature-shenbaga-p">Free Standard Delivery</p>
      </div>
      <div class="feature-shenbaga">
        <img src="../../../../assets/images/shenbaga/imgs2.png">
        <p style="margin-top:6px;" class="feature-shenbaga-p">Free Easy Returns</p>
      </div>
      <div class="feature-shenbaga">
        <img src="../../../../assets/images/shenbaga/imgs3.png">
        <p class="feature-shenbaga-p">6 Million Books Available</p>
      </div>
      <div class="feature-shenbaga">
        <img src="../../../../assets/images/shenbaga/imgs4.png">
        <p class="feature-shenbaga-p">Special Discounts</p>
      </div>
    </div>

    <div class="Best-sellers-shenbaga">
      <div class="book-festivel_1 book-festivel desktop-only" style="background-color: #f8ee12;">
        <div style="display:flex;">
          <div class="text-overlay">
            <h4 class="text-overlay-h4_1">NEW COLLECTIONS</h4>
            <h2 class="text-overlay-h2_1">Book Festival</h2>
            <!-- <p class="text-overlay-p_1">All Books are flat 50% Off</p> -->
            <button class="text-overlay-button1" (click)="productsListTazTest()">SHOP NOW</button>
          </div>
          <div style="position:relative;left:76%">
            <img src="../../../../assets/images/shenbaga/yellow.png" alt="Book Festival" class="book-festivel-img1">

          </div>

        </div>


      </div>
      <div class="mobile-only">
        <div class="book-festivel_1 book-festivel" style="background-color: #f8ee12;">
          <div style="display:flex;">
            <div class="text-overlay-1">
              <h4 class="text-overlay-h4_1">NEW COLLECTIONS</h4>
              <h2 class="text-overlay-h2_1">Book Festival</h2>
              <!-- <p class="text-overlay-p_1">All Books are flat 50% Off</p> -->
              <button class="text-overlay-button1" (click)="productsListTazTest()">SHOP NOW</button>
            </div>
            <div style="position:relative;">
              <img src="../../../../assets/images/shenbaga/images -new .jpg" alt="Book Festival"
                class="book-festivel-img1">

            </div>

          </div>


        </div>
      </div>
      <div class="book-festivel_2 book-festivel">
        <img src="../../../../assets/images/shenbaga/dark-blue-bg.png" alt="Popular Books" class="book-festivel-img2">
        <div class="text-overlay">
          <h4 class="text-overlay-h4_2">BEST SELLERS</h4>
          <h2 class="text-overlay-h2_2">Popular Books</h2>
          <!-- <p class="text-overlay-p_2">All Books are flat 20% Off</p> -->
          <button class="text-overlay-button2" (click)="goToSection()">SHOP NOW</button>
        </div>
      </div>
    </div>




    <div class="deals-shenbaga-title">
      <span style="font-size: 32px;font-family: ui-monospace;">Deals of the week</span>
    </div>
    <div class="desktop-only" style=" margin-top: 20px;margin-left:2%;margin-right:2%">
      <owl-carousel-o [options]="ProductSliderConfig7" class="slider2 rounder-corner-nav" style="width: 92%;">

        <ng-container class="revinfo" *ngFor="let product of newArrival; let i = index">
          <ng-template carouselSlide>
            <div style="margin-bottom: 30px;">


              <div class="baby-newcollection shenbaga-collection">
                <div class="product-list-description-baby">
                  <div class="product-centering-baby shenbaga-list-bg">
                    <div>
                      <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                        class="newcollection-image-baby shenbaga-img-collection" />
                    </div>
                    <div class="d-flex baby_newprodname shenbaga-det-bg">

                      <div style="width: 100%;margin-bottom: 25px;">
                        <!-- <div style="display: flex;text-align: center;justify-content: center;" *ngIf="product.stock_status == 'Available'">
                      <p style="font-size: 11px;color: gray;">{{product.stock_status}} (In Stock)</p>
                  </div> -->
                        <div style="display: flex;text-align: center;justify-content: center;"
                          class="justify-center-baby" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                          <p class="taz-newcol-name" style="color:black !important;height:41px !important">
                            {{product.name}}
                          </p>
                        </div>
                        <div style="display: flex;justify-content: center;" class="justify-center-baby">
                          <p class="shenbaga-newcol-price"> ₹ {{product.pricing.raw.price}}.00
                          </p>
                          <!-- <span style="font-size: 15px !important;font-weight: 600; margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
                        </div>
                        <!-- <div style="display: flex;justify-content: space-between;">
                  <div style="margin-top: 10px;">
                  <button  *ngIf="(appService.productIdinCart.indexOf(product.id) == -1 && product.product_type!='Variable') && (appService.productIdinCart.indexOf(product.id) == -1 && product.type!='Variable')" class="btn btn-primary shubhcards-btn" style="background-color: #1b52a4!important;min-width: max-content;border-radius: 5px !important;font-size: 12px;" (click)="addToCart(product)">Add to Cart</button>
                  <div *ngFor="let cart of appService.cartProducts.results;let i = index"> 
                    <div class="btn btn-secondary inq-btn-st viewCart" style="background-color: #1b52a4!important;min-width:max-content;padding: 4px 15px !important; border-radius: 5px !important;"  *ngIf="cart.product_id === product.id || cart.product_id === product.checkVariantInCart" >
         
            
                        <span style="font-size: 12px;">
                            <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                style="font-size:12px;cursor:pointer;"></i></span>
                        <span class="inq-sp-2"
                            style="color: white;font-size: 12px;">{{cart.quantity}}</span>
                        <span style="font-size: 12px;">
                            <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                style="font-size:12px;cursor:pointer;"></i></span>
                   </div>
                   </div>
                  </div>
                  <div>
                    <i class="fa fa-shopping-cart" style="color: rgb(174, 174, 174);margin-top: 15px;cursor: pointer;"></i>
                  </div>
                </div> -->
                      </div>

                    </div>
                  </div>
                </div>
              </div>


            </div>
          </ng-template>
        </ng-container>

      </owl-carousel-o>
    </div>

    <div class="mobile-only" style="margin-left: -10px;">
      <div>
        <div class="container">
          <owl-carousel-o [options]="ProductSliderConfig" class="slider rounder-corner-nav"
            style="margin-top: 28px;position: relative;margin-left: 7px;">
            <ng-container *ngFor="let product of newArrival; let i = index">
              <ng-template carouselSlide>
                <app-product-box-one [product]="product" [index]="i"
                  style="display:block;width: 97%;margin-left: 5%;"></app-product-box-one>
              </ng-template>
            </ng-container>
          </owl-carousel-o>

        </div>
      </div>
    </div>

    <div class="Genres-books-container">
      <div class="genres-header">
        <h2 class="genres_head" style="color:#ffffff;">Genres Books</h2>
        <button *ngIf="getallcatsri" class="view-all-cat-shenbaga" (click)="getAllCatSri()">VIEW ALL</button>
      </div>
      <div class="Genres-books-list">
        <div class="genre-book-item" *ngFor="let category of allCategoriesSri; let i = index">
          <img [src]="category.image" alt="Category" class="genre-book-item-img"
            (click)="productsListTazTest1(category.name)">
        </div>
      </div>
      <div *ngIf="showAll" class="view-less-container">
        <button class="view-less-cat-shenbaga" (click)="viewLessSri()">VIEW LESS</button>
      </div>
    </div>




    <div class="Best-Sellers-shenabaga-title" id="bestSellerSri" name="bestSellerSri">
      <span style="font-size: 30px;font-family: ui-monospace;text-align:center;">Best Sellers/Featured Products</span>
    </div>
    <div class="desktop-only" style=" margin-top: 20px;margin-left:2%;margin-right:2%">
      <owl-carousel-o [options]="ProductSliderConfig7" class="slider2 rounder-corner-nav" style="width: 92%;">

        <ng-container class="revinfo" *ngFor="let product of recommededProducts; let i = index">
          <ng-template carouselSlide>
            <div style="margin-bottom: 30px;">


              <div class="baby-newcollection shenbaga-collection">
                <div class="product-list-description-baby">
                  <div class="product-centering-baby shenbaga-list-bg">
                    <div>
                      <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null"
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                        class="newcollection-image-baby shenbaga-img-collection" />
                    </div>
                    <div class="d-flex baby_newprodname shenbaga-det-bg">

                      <div style="width: 100%;margin-bottom: 25px;">
                        <!-- <div style="display: flex;text-align: center;justify-content: center;" *ngIf="product.stock_status == 'Available'">
                            <p style="font-size: 11px;color: gray;">{{product.stock_status}} (In Stock)</p>
                        </div> -->
                        <div style="display: flex;text-align: center;justify-content: center;"
                          class="justify-center-baby" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
                          <p class="taz-newcol-name" style="color:black !important;"> {{product.name}}
                          </p>
                        </div>
                        <div style="display: flex;justify-content: center;" class="justify-center-baby">
                          <p class="shenbaga-newcol-price"> ₹ {{product.pricing.raw.price}}.00
                          </p>
                          <!-- <span style="font-size: 15px !important;font-weight: 600; margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
                        </div>
                        <!-- <div style="display: flex;justify-content: space-between;">
                        <div style="margin-top: 10px;">
                        <button  *ngIf="(appService.productIdinCart.indexOf(product.id) == -1 && product.product_type!='Variable') && (appService.productIdinCart.indexOf(product.id) == -1 && product.type!='Variable')" class="btn btn-primary shubhcards-btn" style="background-color: #1b52a4!important;min-width: max-content;border-radius: 5px !important;font-size: 12px;" (click)="addToCart(product)">Add to Cart</button>
                        <div *ngFor="let cart of appService.cartProducts.results;let i = index"> 
                          <div class="btn btn-secondary inq-btn-st viewCart" style="background-color: #1b52a4!important;min-width:max-content;padding: 4px 15px !important; border-radius: 5px !important;"  *ngIf="cart.product_id === product.id || cart.product_id === product.checkVariantInCart" >
               
                  
                              <span style="font-size: 12px;">
                                  <i class="fa fa-minus mr-3" (click)="decreaseItem(i)"
                                      style="font-size:12px;cursor:pointer;"></i></span>
                              <span class="inq-sp-2"
                                  style="color: white;font-size: 12px;">{{cart.quantity}}</span>
                              <span style="font-size: 12px;">
                                  <i class="fa fa-plus ml-3" (click)="increaseItem(i)"
                                      style="font-size:12px;cursor:pointer;"></i></span>
                         </div>
                         </div>
                        </div>
                        <div>
                          <i class="fa fa-shopping-cart" style="color: rgb(174, 174, 174);margin-top: 15px;cursor: pointer;"></i>
                        </div>
                      </div> -->
                      </div>

                    </div>
                  </div>
                </div>
              </div>


            </div>
          </ng-template>
        </ng-container>

      </owl-carousel-o>
    </div>



    <div class="mobile-only" style="margin-left: -10px;">
      <div>
        <div class="container">
          <owl-carousel-o [options]="ProductSliderConfig" class="slider rounder-corner-nav"
            style="margin-top: 28px;position: relative;margin-left: 7px;">
            <ng-container *ngFor="let product of recommededProducts; let i = index">
              <ng-template carouselSlide>
                <app-product-box-one [product]="product" [index]="i"
                  style="display:block;width: 97%;margin-left: 5%;"></app-product-box-one>
              </ng-template>
            </ng-container>
          </owl-carousel-o>

        </div>
      </div>
    </div>


    <div class="Mail-section-shenbaga">
      <h5 class="Mail-section-shenbaga-h5">LATEST NEWSLETTER</h5>
      <!-- <h3 class="Mail-section-shenbaga-h3">Get a 20% discount on your <br> first order</h3> -->
      <div class="input-container-mail-section">
        <input type="email" placeholder="Enter your email...">
        <button type="button" class="subscribe-button-shenbaga">
          <i class="fa fa-envelope"></i> <span style="font-family:sans-serif;color:#1e1e73;">Subscribe</span>
        </button>
      </div>
    </div>

    <h2 class="readers-feedback-heading">Readers Feedback</h2>
    <div class="readers-feedback-container">
      <div class="feed-back-section">
        <div class="feed-back-img-container">
          <img src="../../../../assets/images/shenbaga/reader_1.png" alt="Reader 1" class="feed-back-section-img">
        </div>
        <div class="feed-back-txt-container">
          <p class="feed-back-txt-p">
            "This place has got awesome collection of Tamil novels and historical books. One of the best places to
            quench your book thirst for Tamil literature! Mr. Shanmugam, the founder of the publication, helps people in
            finding the right book to feed their soul.If you're really passionate about Tamil and books, you really
            gonna visit this place."
          </p>
          <h3 class="feed-back-txt-h3">Shenbagamuthu Shenbagaraman
          </h3>
          <h5 class="feed-back-txt-h5">Chennai</h5>
        </div>
      </div>

      <div class="feed-back-section">
        <div class="feed-back-img-container">
          <img src="../../../../assets/images/shenbaga/reader_2.png" alt="Reader 2" class="feed-back-section-img">
        </div>
        <div class="feed-back-txt-container">
          <p class="feed-back-txt-p">
            "This Company Published Novels & Stories Above 1000 Books. Excellent Collections, They have lot of Good
            Writers Books. Once you visit there you will definitely purchase atleast 50 Books surely."
          </p>
          <h3 class="feed-back-txt-h3">Shre Keerthana Flex Printing</h3>
          <h5 class="feed-back-txt-h5">Chennai</h5>
        </div>
      </div>
    </div>






  </section>
  <section *ngIf="config.title === 'Srimaware'">
    <div>
      <div class="desktop-only" style="display: flex;justify-content: center;">
        <div style="display: flex;margin-left: 10%;margin-right:10%;">
          <div style="width: 56%;margin-top: 7%;margin-right: 4%;text-align: justify;">
            <p style="font-size: 28px;color: #5e338f;font-weight: 500;font-family: system-ui;">Welcome <strong
                style="font-size: 28px;color: #5e338f;font-family: system-ui;">Srimaware</strong></p>
            <p style="font-family: system-ui;font-size: 13px;font-weight: 500;margin-top: 20px;">
              Srimaware is a trusted name in plastic ware manufacturing, committed to producing top-quality, durable,
              and innovative products. With cutting-edge technology and sustainable practices, we offer a diverse range
              of plastic solutions, including kitchenware, storage containers, and custom industrial components. Our
              focus on precision and rigorous quality control ensures that every product delivers on reliability and
              functionality.
            </p>
            <p style="font-family: system-ui;font-size: 13px;margin-top: 15px;font-weight: 500;">
              At Srimaware, we blend convenience, affordability, and eco-friendly solutions to meet the diverse needs of
              our customers.
            </p>
          </div>
          <div style="width: 40%;margin-top: 5%;">
            <img src="../../../../assets/images/srima/Image11.jpg" alt="" style="width: 100%;">
          </div>
        </div>
      </div>
      <div class="mobile-only" style="display: flex;justify-content: center; margin-left: 5%; margin-right: 5%;">
        <div>

          <div style="width: 100%;margin-top: 7%;text-align: justify;">
            <p style="font-size: 28px;color: #5e338f;font-weight: 500;font-family: system-ui;">Welcome <strong
                style="font-size: 28px;color: #5e338f;font-family: system-ui;">Srimaware</strong></p>
            <p style="font-family: system-ui;font-size: 13px;font-weight: 500;margin-top: 20px;">
              Srimaware is a trusted name in plastic ware manufacturing, committed to producing top-quality, durable,
              and innovative products. With cutting-edge technology and sustainable practices, we offer a diverse range
              of plastic solutions, including kitchenware, storage containers, and custom industrial components. Our
              focus on precision and rigorous quality control ensures that every product delivers on reliability and
              functionality.
            </p>
            <p style="font-family: system-ui;font-size: 13px;margin-top: 15px;font-weight: 500;">
              At Srimaware, we blend convenience, affordability, and eco-friendly solutions to meet the diverse needs of
              our customers.
            </p>
          </div>
          <div style="width: 100%;margin-top: 5%;">
            <img src="../../../../assets/images/srima/Image11.jpg" alt="" style="width: 100%;">
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="desktop-only" style="display: flex;justify-content: center;">
        <div style="margin-left: 10%;margin-right:10%;height: 160px;margin-top: 4%;">
          <img src="../../../../assets/images/srima/Srimaware-Banner-2-ver1.jpg" alt="" style="width: 100%;">
          <div>
            <div class="home_2btn_hob">
              <!-- <div style="display: flex;justify-content: center;margin-bottom: 20px;">
                <p
                  style="line-height: 50px;text-align: center;font-size: 40px;color: white;font-weight: 300;width:65%; font-family: sans-serif;">
                  Reliable<strong style="font-size: 40px;color: white;font-weight: 700;font-family: sans-serif;">
                    eco-friendly plasticware </strong>for everyday living.</p>
              </div> -->
              <div style="display: flex;justify-content: center;margin-top: 10%;">
                <button class="bann_but_hob1" (click)="productsListTazTest1('Table Mate')">
                  KNOW MORE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-only" style="    margin-top: 15px;">
        <div style="display: flex;justify-content: center;">
          <div style="width: 90%;height: 65px;margin-top: 4%;">
            <img src="../../../../assets/images/srima/Srimaware-Banner-2-ver1.jpg" alt="" style="width: 100%;height: 125px;">
            <div>
              <div class="home_2btn_hob">
                <!-- <div style="display: flex;justify-content: center;margin-bottom: 20px;">
                  <p
                    style="line-height: 30px;text-align: center;font-size: 19px;color: white;font-weight: 300;width:85%; font-family: sans-serif;">
                    Reliable<strong style="font-size: 21px;color: white;font-weight: 700;font-family: sans-serif;">
                      eco-friendly plasticware </strong>for everyday living.</p>
                </div> -->
                <div style="display: flex;justify-content: center;margin-top: 2%;">
                  <button class="bann_but_hob1" (click)="productsListTazTest1('Table Mate')">
                    KNOW MORE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex;justify-content: center;background-color: #bee7fb;" class="Srima_home_prod"
      id="aboutSrimaware" name="aboutSrimaware">
      <div class="desktop-only" style="margin-left: 10%;margin-right:10%;">
        <div>
          <p style="font-size: 28px;color: #5e338f;font-weight: 500;font-family: system-ui;" class="product_padding_srima">Products
          </p>
        </div>
        <div class="paul_gridalign" style="display: grid;margin-top: 3%;" *ngIf="changeactive">
          <div style="width: 95%;margin-bottom: 7%; background-color: white;"
            *ngFor="let product of newArrival.slice(0,8); let i = index">
            <div class="img_srima_prod" style="display: flex;justify-content: center;">
              <img [src]="product.assets[0].image_source" style="cursor: pointer;width: 95%;"
              (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
            </div>
            <p class="PaulHomeText1" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">{{product.name}}</p>
            <!-- <p class="PaulHomeText2" > ₹ {{product.pricing.raw.price}}.00</p> -->
          </div>
        </div>
      </div>
      <div class="mobile-only" style="width: 90%; margin-left: 3%;padding-bottom: 40px;">
        <div>
          <p style="font-size: 28px;color: #5e338f;font-weight: 500;font-family: sans-serif;padding-top: 26%;">Products
          </p>
        </div>
        <div class="paul_gridalign" style="display: grid;margin-top: 20px;" *ngIf="changeactive">
          <div style="width: 92%;margin-bottom: 16px; background-color: white;"
            *ngFor="let product of newArrival.slice(0,8); let i = index">
            <div class="img_srima_prod" style="display: flex;justify-content: center;">
              <img [src]="product.assets[0].image_source" style="cursor: pointer;width: 95%;"
              (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
            </div>
            <p class="PaulHomeText1" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">{{product.name}}</p>
            <!-- <p class="PaulHomeText2" > ₹ {{product.pricing.raw.price}}.00</p> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  <section *ngIf="config.title === 'PaulCaroline'">
    <div style="display: flex;" class="desktop-only">
      <div style="width: 70%;">
        <img src="../../../../assets/images/paulc/pc 2 Image.jpg" style="width: 200%;">
      </div>
      <div class="text_paul_pc">Paul Caroline is a UK premium clothing brand offering timeless, elegant designs crafted
        from high-quality fabrics. Known for its exceptional craftsmanship, the brand delivers modern yet classic
        apparel, perfect for those who value luxury and sophistication in their wardrobe.</div>
    </div>
    <div style="display: flex;" class="mobile-only">
      <div style="width: 100%;">
        <img src="../../../../assets/images/paulc/pc 2 Image.jpg" style="width: 200%;">
      </div>
      <div class="text_paul_pc">Paul Caroline is a UK premium clothing brand offering timeless, elegant designs crafted
        from high-quality fabrics. Known for its exceptional craftsmanship, the brand delivers modern yet classic
        apparel, perfect for those who value luxury and sophistication in their wardrobe.</div>
    </div>
    <div>
      <!-- <div>
        <img src="../../../../assets/images/paulc/pc 4 image.jpg" style="width: 100%;">
      </div> -->
      <div class="desktop-only">
        <!-- <div style="width: 100%;" *ngFor="let banner of homebanner2; let i=index;" > -->
        <img style="width: 100%;background-size: cover;color: white;object-fit: cover;"
          src="../../../../assets/images/paulc/pc 4 image.jpg" alt="">
        <!-- </div> -->
        <div class="home_2btn_hob">
          <div style="display: flex;justify-content: center;margin-bottom: 20px;">
            <p
              style="line-height: 50px;text-align: center;font-size: 60px;color: white;font-weight: 300;width:40%; font-family: sans-serif;">
              <strong
                style="font-size: 48px;color: white;font-weight: 950;font-family: system-ui;margin-right: 4px;">Where
                Luxury<br> Meets Timeless Style</strong>
            </p>
          </div>
          <div style="display: flex;justify-content: center;margin-bottom: 20px;">
            <p
              style="line-height: 50px;text-align: center;font-size: 32px;color: white;font-weight: 600;font-family: sans-serif;">
              Elegance in Every Stitch</p>
          </div>
          <div style="display: flex;justify-content: center;margin-top: 7%;">
            <button class="bann_but_hob1" (click)="productListingPaul('Men')">
              SHOP NOW
            </button>
          </div>
        </div>
      </div>
      <div class="mobile-only">
        <!-- <div style="width: 100%;" *ngFor="let banner of homebanner2; let i=index;" > -->
        <img style="width: 100%;background-size: cover;color: white;object-fit: cover;"
          src="../../../../assets/images/paulc/paulcpp.png" alt="">
        <!-- </div> -->
        <div class="home_2btn_hob">
          <div style="display: flex;justify-content: center;margin-bottom: 20px;">
            <p
              style="line-height: 35px;text-align: center;font-size: 60px;color: white;font-weight: 300;width:90%; font-family: sans-serif;">
              <strong
                style="font-size: 38px;color: white;font-weight: 950;font-family: system-ui;margin-right: 4px;">Where
                Luxury<br> Meets Timeless Style</strong>
            </p>
          </div>
          <div style="display: flex;justify-content: center;margin-bottom: 20px;">
            <p
              style="line-height: 50px;text-align: center;font-size: 28px;color: white;font-weight: 600;font-family: sans-serif;">
              Elegance in Every Stitch</p>
          </div>
          <div style="display: flex;justify-content: center;margin-top: 7%;">
            <button class="bann_but_hob1" (click)="productListingPaul('Men')">
              SHOP NOW
            </button>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 60px;">
      <!-- <div style="display: flex;justify-content: space-evenly;margin-left: 10%;margin-right: 13%;">
     <div> <p style="font-size: 40px;font-weight: 700;font-family: sans-serif;text-align: center;cursor: pointer;" (click)="getPaulround()">ROUND NECK</p> 
    </div>
    <div> <p style="font-size: 40px;font-weight: 700;font-family: sans-serif;text-align: center;cursor: pointer;" (click)="getPaulpolo()">POLOS</p> 
      </div>
    </div> -->

      <div class="cont-whole" style="justify-content: center;">

        <div class="nav-tabs-cle">
          <div class="tab-choise">
            <div class="tab-option click-true" *ngIf="changeactive==true" (click)="getPaulround()">
              ROUND NECK
            </div>
            <div class="tab-option click-false" *ngIf="changeactive==false" (click)="getPaulround()">
              ROUND NECK
            </div>
            <div class="tab-option click-true" *ngIf="changeactive1==true" (click)="getPaulpolo()">
              POLOS
            </div>
            <div class="tab-option click-false" *ngIf="changeactive1==false" (click)="getPaulpolo()">
              POLOS
            </div>
          </div>

        </div>
      </div>

    </div>
    <div class="paul_gridalign" style="display: grid;margin-left: 5%;margin-top: 50px;" *ngIf="changeactive">
      <div style="width: 95%;margin-bottom: 30px;"
        *ngFor="let product of ProductsbasedonCategory.slice(0,6); let i = index">
        <div>
          <img [src]="product.assets[0].image_source" style="cursor: pointer;" width="100%"
          (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">
        </div>
        <p class="PaulHomeText1" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].path,product.name+'-'+product.id) : null">{{product.name}}</p>
        <p class="PaulHomeText2">£ {{product.pricing.raw.price}}.00</p>
      </div>
    </div>
    <div class="paul_gridalign" style="display: grid;margin-left: 5%;margin-top: 50px;" *ngIf="changeactive1">
      <div style="width: 95%;margin-bottom: 30px;"
        *ngFor="let product of ProductsbasedonCategory.slice(0,6); let i = index">
        <div>
          <img [src]="product.assets[0].image_source" style="cursor: pointer;" width="100%"
            (click)="productDetailsPolo(product.id,poloid)">
        </div>
        <p class="PaulHomeText1" (click)="productDetails(product.id)">{{poloName}}{{product.type}}</p>
        <p class="PaulHomeText2">£ {{product.pricing.raw.price}}.00</p>
      </div>
    </div>
    <div id="sale_Paul" name="sale_Paul">
      <div style="display: flex;justify-content: center;margin-bottom: 5%;" class="desktop-only">
        <div style="display: flex;width: 90%;">
          <div style="width: 50%;">
            <img src="../../../../assets/images/paulc/Pc 3 image.jpg" alt="" style="width:100%">
          </div>
          <div style="width: 50%;background-color: #ee1c25;">
            <div style="display: flex;justify-content: center;margin-top: 10%;">
              <img src="../../../../assets/images/paulc/logoinsec.png" alt="" style="width: 37%;">
            </div>
            <div class="hob_right_flex">
              <p class="hob_right_cont1">EXTRA <strong class="hob_right_contbold">20% OFF *</strong></p>
              <p class="hob_right_cont2">YOUR FIRST PURCHASE</p>
              <p class="hob_right_cont3">* <span class="hob_right_cont4">C</span>onditions apply</p>
              <div style="display: flex;justify-content: center;margin-top: 7%;">
                <button class="bann_but_hob1 margin_hob_bottom" (click)="productListingPaul('Men')">
                  APPLY NOW
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content: center;margin-bottom: 5%;" class="mobile-only">
        <div style="width: 100%;">
          <div style="width: 100%;">
            <img src="../../../../assets/images/paulc/Pc 3 image.jpg" alt="" style="width:100%;">
          </div>
          <div style="width: 100%;background-color: #ee1c25;">
            <div style="display: flex;justify-content: center;">
              <img src="../../../../assets/images/paulc/logoinsec.png" alt="" style="width: 75%;margin-top: 25px;">
            </div>
            <div class="hob_right_flex">
              <p class="hob_right_cont1">EXTRA <strong class="hob_right_contbold">20% OFF *</strong></p>
              <p class="hob_right_cont2">YOUR FIRST PURCHASE</p>
              <p class="hob_right_cont3">* <span class="hob_right_cont4">C</span>onditions apply</p>
              <div style="display: flex;justify-content: center;margin-top: 7%;">
                <button class="bann_but_hob1 margin_hob_bottom" (click)="productListingPaul('Men')">
                  APPLY NOW
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section *ngIf="config.title === 'UrbanBox'" style="background-color: #e5e5e5;">
    <div>
      <p class="Urbanist_Bold our_product" style="padding-top: 35px;">Our Products</p>
    </div>
    <div class="urban_grid_home">
    <div *ngFor="let category of allCategories; let i = index">
    <div class="hexagon-container">
      <img [src]="category.image" alt="Hexagon Image">
  </div>
  <p class="Urbanist_Medium urban_cat_name">{{category.name}}</p>
</div>
</div>
<div class="info-section">
  <div class="info-box">
      <img class="info-box_img1" src="../../../../assets/images/urbanbox/truck.png" alt="Shipping">
      <div class="info-text">
          <h4 class="Urbanist_Bold urban_ti">SHIPPING & RETURN</h4>
          <p class="Urbanist_reg urban_li">Shipping across the nation T&C</p>
      </div>
  </div>
  <div class="divider"></div>
  <div class="info-box">
      <img class="info-box_img" src="../../../../assets/images/urbanbox/call.png" alt="Support">
      <div class="info-text">
          <h4 class="Urbanist_Bold urban_ti">ONLINE SUPPORT 24/7</h4>
          <p class="Urbanist_reg urban_li">We are happy to assist you!</p>
      </div>
  </div>
  <div class="divider"></div>
  <div class="info-box">
      <img class="info-box_img" src="../../../../assets/images/urbanbox/secure.png" alt="Security">
      <div class="info-text">
          <h4 class="Urbanist_Bold urban_ti">SECURITY POLICY</h4>
          <p class="Urbanist_reg urban_li">Shopping at Urban Box is safe.</p>
      </div>
  </div>
  <div class="divider"></div>
  <div class="info-box">
      <img class="info-box_img" src="../../../../assets/images/urbanbox/location.png" alt="Location">
      <div class="info-text">
          <h4 class="Urbanist_Bold urban_ti">LOCATION</h4>
          <p class="Urbanist_reg urban_li">Office & Store locator</p>
      </div>
  </div>
</div>
<div style="width: 100%;margin-top: 20px;">
  <img src="../../../../assets/images/urbanbox/paperbagban.png" style="width: 100%;">
  <div class="handlebag_word">
    <p class="Urbanist_Bold" style="font-size: 67px;color: #d9d9d9;text-align: center;width: 50%;letter-spacing: 1px;">Handle Bags</p>
    <p class="Urbanist_reg" style="font-size: 20px;color: #d9d9d9;width: 65%;letter-spacing: 2px;text-align: center;">Eco-friendly, durable paper handle bags for shopping, gifting, and packaging, offering a sustainable alternative.</p>
  </div>
</div>
<div style="height: 100px;">
  
</div>

<div style="width: 100%;margin-top: 20px;">
  <img src="../../../../assets/images/urbanbox/pouchban.png" style="width: 100%;">
  <div  class="pouch_word">
    <p class="Urbanist_Bold" style="font-size: 67px;color: white;text-align: center;letter-spacing: 1px;">Paper Pouch</p>
    <p class="Urbanist_reg" style="font-size: 20px;color: white;letter-spacing: 2px; text-align: center;">Eco-friendly paper pouches offer a sustainable packaging solution for snacks, gifts, and essentials. Lightweight, durable, and stylish, they provide a practical alternative to plastic, ensuring environmental responsibility without compromising quality or aesthetics.</p>
  </div>
</div>
<div style="height: 100px;">
  
</div>
<div>
  <p class="Urbanist_Bold our_product" style="padding-top: 35px;">New Arrival</p>
</div>
<div>
  <p class="Urbanist_Bold our_product" style="padding-top: 35px;">Clients</p>
  <img src="../../../../assets/images/urbanbox/Clienturban.png" style="width: 100%;">
  <div>
    <div>

    </div>
  </div>
</div>
  </section>
  <section *ngIf="config.title === 'HOB'">
    <div style="display: flex;margin-top: 40px;margin-bottom: 40px;" class="desktop-only">
      <div style="width: 50%;">
        <div style="display: flex;justify-content: center;margin-top: 5%;">
          <img src="../../../../assets/images/hob/mode.png" alt="" class="hobhome1_img" style="cursor: pointer;"
            (click)="productsListHOB('Men')">
        </div>
      </div>
      <div style="width: 50%;border-left: 1px solid #bbbbbb;height: 125px;">
        <div style="display: flex;justify-content: center;margin-top: 5%;">
          <img src="../../../../assets/images/hob/curve.png" alt="" class="hobhome1_img" style="cursor: pointer;"
            (click)="productsListHOB('Women')">
        </div>
      </div>
    </div>
    <div style="margin-top: 40px;margin-bottom: 20px;" class="mobile-only">
      <div style="height: 70px;border-bottom: 1px solid #bbbbbb">
        <div style="display: flex;justify-content: center;margin-top: 35px;">
          <img src="../../../../assets/images/hob/curve.png" alt="" class="hobhome1_img"
            (click)="productsListHOB('Women')">
        </div>
      </div>
      <div style="height: 70px;">
        <div style="display: flex;justify-content: center;margin-top: 35px;">
          <img src="../../../../assets/images/hob/mode.png" alt="" class="hobhome1_img"
            (click)="productsListHOB('Men')">
        </div>
      </div>
    </div>
    <div class="desktop-only">
      <div style="width: 100%;" *ngFor="let banner of homebanner1; let i=index;">
        <img style="width: 100%;background-size: cover;color: white;object-fit: cover;" src="{{banner.image_source}}"
          alt="{{banner.alt_text}}">
      </div>
      <div class="home_1btn_hob">
        <!-- <div style="display: flex;justify-content: center;margin-bottom: 20px;">
          <p
            style="line-height: 50px;text-align: center;font-size: 60px;color: white;font-weight: 300;font-family: sans-serif;">
            <strong
              style="font-size: 60px;color: white;font-weight: 950;font-family: system-ui;margin-right: 12px;">BOLD</strong>STORY
          </p>
        </div> -->
        <!-- <div style="display: flex;justify-content: center;">
          <div style="display: flex;justify-content: space-between;">
            <div>
              <button class="bann_but_hob" style="margin-right: 20px;" (click)="productsListHOB('Women')">
                WOMEN
              </button>
            </div>
            <div>
              <button class="bann_but_hob" (click)="productsListHOB('Men')">
                MEN
              </button>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="mobile-only">
      <div style="width: 100%;" *ngFor="let banner of mobilehomebanner1; let i=index;">
        <img style="width: 100%;background-size: cover;color: white;object-fit: cover;" src="{{banner.image_source}}"
          alt="{{banner.alt_text}}">
      </div>
      <!-- <div class="home_1btn_hob">
        <div style="display: flex;justify-content: center;margin-bottom: 20px;">
          <p style="text-align: center;font-size: 40px;color: white;font-weight: 300;font-family: sans-serif;"><strong
              style="font-size: 40px;color: white;font-weight: 950;font-family: system-ui;margin-right: 12px;">BOLD</strong>STORY
          </p>
        </div>
        <div style="display: flex;justify-content: center;">
          <div style="display: flex;justify-content: space-between;">
            <div>
              <button class="bann_but_hob" style="margin-right: 20px;" (click)="productsListHOB('Women')">
                WOMEN
              </button>
            </div>
            <div>
              <button class="bann_but_hob" (click)="productsListHOB('Men')">
                MEN
              </button>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div>
      <div class="hob_bot_padding" style="background-color: black;margin-top: 1px;">
        <div class="flex_hob" style="padding-top: 4%;">
          <div class="hob_wid_1">
            <p class="hob_collection_content"><strong class="hob_collection_contentbold">THE
                BOLD</strong><br>COLLECTIONS</p>
            <!-- <p class="hob_collection_content1">AUGUST 2024</p> -->
          </div>
          <div class="hob_wid_2">
            <p class="hob_collection_contentmain">Welcome to House of Bold, Our collections feature a curated blend of heritage classics 
              reimagined with contemporary twists. Each piece is crafted to enrich the everyday journey, whether it’s 
              navigating the bustling streets of the city or embarking on a global adventure.</p>
          </div>
        </div>
        <div style="margin-top: 85px;">
          <div class="hob_cat_ls">
            <div _ngcontent-jat-c101="" class="product-list-cards-baby2" style="margin-top: 15px; width: 100%;">
              <div _ngcontent-jat-c101="" class="deera-img button-overlay" style="width: 100%;">
                <img _ngcontent-jat-c101="" src="../../../../assets/images/hob/1 Picture.png"
                  class="hob-image-hpro">
              </div>
              <div _ngcontent-jat-c101="" class="product-list-description-HOB1" style="width: 100%;">
                <div _ngcontent-jat-c101="">
                  <div _ngcontent-jat-c101="" style="width: 85%;">
                    <p _ngcontent-jat-c101="" class="hob_title"> Details That Speak Boldly
                    </p>
                  </div>
                </div>
                <div class="hob_gend_btn">
                  <div>
                    <p class="home_cat_but_hob" >
                      Experience craftsmanship in every stitch-premium tape accents, signature buttons, and perfectly tailored pockets that redefine luxury
                  </p>
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-jat-c101="" class="product-list-cards-baby2" style="margin-top: 15px; width: 100%;">
              <div _ngcontent-jat-c101="" class="deera-img button-overlay" style="width: 100%;">
                <img _ngcontent-jat-c101="" src="../../../../assets/images/hob/2 Picture.png"
                  class="hob-image-hpro">
              </div>
              <div _ngcontent-jat-c101="" class="product-list-description-HOB1" style="width: 100%;">
                <div _ngcontent-jat-c101="">
                  <div _ngcontent-jat-c101="" style="width: 85%;">
                    <p _ngcontent-jat-c101="" class="hob_title"> Precision in Every Seam
                    </p>
                  </div>
                </div>
                <div class="hob_gend_btn">
                  <div>
                    <p class="home_cat_but_hob" >
                      Discover flawless stitching, refined pockets, and a contoured waistband designed for unparalleled fit and sophistication
                  </p>
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-jat-c101="" class="product-list-cards-baby2" style="margin-top: 15px; width: 100%;">
              <div _ngcontent-jat-c101="" class="deera-img button-overlay" style="width: 100%;">
                <img _ngcontent-jat-c101="" src="../../../../assets/images/hob/3 Picture.png"
                  class="hob-image-hpro">
              </div>
              <div _ngcontent-jat-c101="" class="product-list-description-HOB1" style="width: 100%;">
                <div _ngcontent-jat-c101="" >
                  <div _ngcontent-jat-c101="" style="width: 85%;">
                    <p _ngcontent-jat-c101="" class="hob_title"> Designed to Move
                    </p>
                  </div>
                </div>
                <div class="hob_gend_btn">
                  <div>
                    <p class="home_cat_but_hob" >
                      Seamless stitching and ergonomic thumb holes deliver style and comfort that keep up with your boldest moves
                  </p>
                  </div>
                </div>
              </div>
            </div>
            <div _ngcontent-jat-c101="" class="product-list-cards-baby2" style="margin-top: 15px; width: 100%;">
              <div _ngcontent-jat-c101="" class="deera-img button-overlay" style="width: 100%;">
                <img _ngcontent-jat-c101="" src="../../../../assets/images/hob/4 Picture.png"
                  class="hob-image-hpro">
              </div>
              <div _ngcontent-jat-c101="" class="product-list-description-HOB1" style="width: 100%;">
                <div _ngcontent-jat-c101="">
                  <div _ngcontent-jat-c101="" style="width: 85%;">
                    <p _ngcontent-jat-c101="" class="hob_title"> Tailored for Comfort
                    </p>
                  </div>
                </div>
                <div class="hob_gend_btn">
                  <div>
                    <p class="home_cat_but_hob" >
                      Sharp pleats, functional pockets, a structured waistband, and flexible back elastic combine elegance with ease
                  </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="newArrival_hob" name="newArrival_hob"
      style="line-height: 50px;text-align: center;font-size: 50px;color: rgb(0, 0, 0);font-weight: 600;font-family: sans-serif;margin-top: 50px;margin-bottom: 50px;">
      NEW ARRIVALS</div>
    <div class="desktop-only" style="margin-top: 20px;">
      <owl-carousel-o [options]="ProductSliderConfig5" class="slider2 rounder-corner-nav" style="width: 92%;">

        <ng-container class="revinfo" *ngFor="let product of newArrival; let i = index">
          <ng-template carouselSlide>
            <div style="margin-bottom: 30px;width: 98%;">


              <div class="baby-newcollection">
                <div class="product-list-description-baby">
                  <div class="product-centering-baby">
                    <div>
                      <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].categories,product.name+'-'+product.id) : null"
                        onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                        class="newcollection-image-baby" />
                    </div>
                    <div class="d-flex baby_newprodname">

                      <div style="width: 100%;margin-bottom: 25px;">
                        <div style="display: flex;cursor: pointer;justify-content: center; height: 50px;"
                        (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].categories,product.name+'-'+product.id) : null">
                          <p class="baby-newcol-name" style="font-family: sans-serif;text-align: center;">
                            {{product.name}}
                          </p>
                        </div>
                        <div style="display: flex;justify-content: center;" *ngIf="product.product_type === 'Variable'">
                          <!-- <span style="font-size: 11px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.variant.option_values[0].pricing.raw.msrp }}</span> -->
                          <p style="font-family: sans-serif;font-size: 14px;"> ₹ {{product.pricing.raw.price}}.00
                          </p>
                        </div>
                        <div style="display: flex;justify-content: center;" *ngIf="product.product_type === 'Simple'">
                          <!-- <span style="font-size: 11px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
                          <p style="font-family: sans-serif;font-size: 14px;"> ₹ {{product.pricing.raw.price}}.00
                          </p>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </ng-template>
        </ng-container>

      </owl-carousel-o>
    </div>
    <div class="mobile-only" style="margin-left: -10px;">
      <div>
        <div class="container">
          <owl-carousel-o [options]="ProductSliderConfig" class="slider hob_slide rounder-corner-nav"
            style="margin-top: 28px;position: relative;margin-left: 7px;">
            <ng-container *ngFor="let product of newArrival; let i = index">
              <ng-template carouselSlide>
                <app-product-box-one [product]="product" [index]="i"
                  style="display:block"></app-product-box-one>
              </ng-template>
            </ng-container>
          </owl-carousel-o>

        </div>
      </div>
    </div>
    <div>
      <div class="desktop-only">
        <div style="width: 100%;" *ngFor="let banner of homebanner2; let i=index;">
          <img style="width: 100%;background-size: cover;color: white;object-fit: cover;" src="{{banner.image_source}}"
            alt="{{banner.alt_text}}">
        </div>
        <div class="home_2btn_hob">
          <div style="display: flex;justify-content: center;margin-bottom: 20px;">
            <p
              style="line-height: 50px;text-align: center;font-size: 60px;color: white;font-weight: 300;font-family: sans-serif;">
              <strong
                style="font-size: 60px;color: white;font-weight: 950;font-family: system-ui;margin-right: 4px;">BOLD</strong>NESS
            </p>
          </div>
          <div style="display: flex;justify-content: center;">
            <button class="bann_but_hob" (click)="productsListHOB('Women')">
              SHOP NOW
            </button>
          </div>
        </div>
      </div>
      <div class="mobile-only">
        <div style="width: 100%;" *ngFor="let banner of mobilehomebanner2; let i=index;">
          <img style="width: 100%;background-size: cover;color: white;object-fit: cover;" src="{{banner.image_source}}"
            alt="{{banner.alt_text}}">
        </div>
        <div class="home_2btn_hob">
          <!-- <div style="display: flex;justify-content: center;margin-bottom: 20px;">
            <p class="hob_banner3_cont"><strong class="hob_banner3_contbold">BOLD</strong>NESS</p>
          </div> -->
          <div style="display: flex;justify-content: center;">
            <button class="bann_but_hob" (click)="productsListHOB('Women')">
              SHOP NOW
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="desktop-only" style="display: flex;justify-content: center;margin-bottom: 40px;background-color: #3b3b3b;padding-bottom: 30px;padding-top: 30px;">
      <p class="hob_cont_new">BE<strong class="hob_cont_new_bold">BOLD,</strong>BE BRAVE ENOUGH <br> TO BE YOUR TRUE
        SELF.</p>
    </div>
    <!-- <div style="background-color: black;" class="hob_flex" id="sale_HOB" name="sale_HOB">
      <div class="hob_left_flex">
        <img src="../../../../assets/images/hob/Image 12.jpg" alt="" style="width: 100%;">
      </div>
      <div class="hob_right_flex">
        <p class="hob_right_cont1">EXTRA <strong class="hob_right_contbold">20% OFF *</strong></p>
        <p class="hob_right_cont2">YOUR FIRST PURCHASE</p>
        <p class="hob_right_cont3">* <span class="hob_right_cont4">C</span>onditions apply</p>
        <div style="display: flex;justify-content: center;margin-top: 7%;">
          <button class="bann_but_hob margin_hob_bottom">
            APPLY NOW
          </button>
        </div>
      </div>
    </div> -->
    <div id="newArrival_hob" id="sale_HOB" name="sale_HOB"
    style="line-height: 50px;text-align: center;font-size: 50px;color: rgb(0, 0, 0);font-weight: 600;font-family: sans-serif;margin-top: 50px;margin-bottom: 50px;">
    BEST SELLERS</div>
  <div class="desktop-only" style="margin-top: 20px;">
    <owl-carousel-o [options]="ProductSliderConfig5" class="slider2 rounder-corner-nav" style="width: 92%;">

      <ng-container class="revinfo" *ngFor="let product of recommededProducts; let i = index">
        <ng-template carouselSlide>
          <div style="margin-bottom: 30px;width: 98%;">


            <div class="baby-newcollection">
              <div class="product-list-description-baby">
                <div class="product-centering-baby">
                  <div>
                    <div style="width: 40px;background-color: #23f444;margin-top: 2px;position: absolute;left: 10%;">
                      <p style="font-size: 13px !important;text-align: center; color: #000000 !important;font-weight: 400;font-family: math;">{{calculatePercentageIncrease(product.pricing.raw.msrp,product.pricing.raw.price)}}%</p>
                    </div>
                    <img [src]="product.assets[0].image_source" id="img-list" (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].categories,product.name+'-'+product.id) : null"
                      onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                      class="newcollection-image-baby" />
                  </div>
                  <div class="d-flex baby_newprodname">

                    <div style="width: 100%;margin-bottom: 25px;">
                      <div style="display: flex;cursor: pointer;justify-content: center; height: 50px;"
                      (click)="product.stock_status != 'Out of Stock' ? productDetails(product.id,product.categories[0].categories,product.name+'-'+product.id) : null">
                        <p class="baby-newcol-name" style="font-family: sans-serif;text-align: center;">
                          {{product.name}}
                        </p>
                      </div>
                      <div style="display: flex;justify-content: center;" *ngIf="product.product_type === 'Variable'">
                        <!-- <span style="font-size: 11px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.variant.option_values[0].pricing.raw.msrp }}</span> -->
                        <p style="font-family: sans-serif;font-size: 14px;"> ₹ {{product.pricing.raw.price}}.00
                        </p>
                        <p style="margin-left: 5px;font-family: sans-serif;font-size: 14px;color: rgb(157, 155, 155);text-decoration: line-through;"> ₹ {{product.pricing.raw.msrp}}.00
                        </p>
                      </div>
                      <div style="display: flex;justify-content: center;" *ngIf="product.product_type === 'Simple'">
                        <!-- <span style="font-size: 11px !important;margin-right: 5px !important;text-decoration: line-through;color: #8080806e !important;">₹{{ product.pricing.raw.msrp }}</span> -->
                        <p style="font-family: sans-serif;font-size: 14px;"> ₹ {{product.pricing.raw.price}}.00
                        </p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </ng-template>
      </ng-container>

    </owl-carousel-o>
  </div>
  <div class="mobile-only" style="margin-left: -10px;">
    <div>
      <div class="container">
        <owl-carousel-o [options]="ProductSliderConfig" class="slider hob_slide rounder-corner-nav"
          style="margin-top: 28px;position: relative;margin-left: 7px;">
          <ng-container *ngFor="let product of recommededProducts; let i = index">
            <ng-template carouselSlide>
              <app-product-box-one [product]="product" [index]="i"
                style="display:block"></app-product-box-one>
            </ng-template>
          </ng-container>
        </owl-carousel-o>

      </div>
    </div>
  </div>
  </section>
  <section *ngIf="config.title == 'Vistas'" class="vistas-homedesc">
    <div class="text-center mb-2 ">
      <h3 style="font-family: Helvetica; font-size: 20px; font-weight: 800;"> Fine Copy Papers</h3>
    </div>
    <div class="vistas-home-cell">
      <div class="vistas-prod">

        <div class="vistas-homeimg">
          <img class="" src="assets\images\vistas\double-A-70gsm 3.jpg" alt="First slide"
            style="width: 187px; margin-top: -37px;">
        </div>
        <h4 class="text-center">Double A paper</h4>

        <p class="text-center vistasaa" style="margin-left: 10%;">Double A Everyday is a low-grammage paper designed
          primarily for high-volume printing. This type of paper strikes the right balance between excellent quality and
          significantly reduced weight excellent for high quality printing</p>
      </div>

      <div class="vistas-prod">
        <div class="vistas-homeimg">
          <img class="" src="assets\images\vistas\IK copy.png" alt="First slide" style="width: 170px;">
        </div>
        <h4 class="text-center" style="margin-top: 20px;">IK Copier</h4>

        <p class="text-center" style="margin-left: 10%;margin-right: 10%;">Engineered from the best pulp selection with
          high thickness, whiteness, high smoothness, and brightness. High Opacity- Double Sided Copying. Jam Free
          Performance and Reliability</p>
      </div>
      <div class="vistas-prod">
        <!-- <div class="vistas-homeslide">
        <div id="myCarousel2" class="carousel slide vistas-homeslide1" data-ride="carousel">

          <ol class="carousel-indicators special-carousel">
            <li style="background-color: black;" data-target="#myCarousel2" data-slide-to="0" class="active"></li>
            <li style="background-color: black;" data-target="#myCarousel2" data-slide-to="1"></li>
          </ol>
          <div class="carousel-inner" style="width: 134px;">
            <div class="carousel-item active">
              <img class="d-block w-100" src="assets\images\vistas\paper one1.png" alt="First slide">
              
            </div>
            <div class="carousel-item" >
              <img class="d-block w-100" src="assets\images\vistas\Paper one.jpeg" alt="Second slide">
              
            </div>
          </div>

        </div>
        </div> -->
        <div class="vistas-homeimg">
          <img class="" src="assets\images\vistas\paper one1.png" alt="First slide"
            style="width: 189px; margin-top: -37px;">
        </div>
        <h4 class="text-center">Paper One</h4>

        <p class="text-center" style="margin-left: 10%;margin-right: 10%;">Engineered from the best pulp selection with
          high thickness, whiteness, high smoothness, and brightness. High Opacity- Double Sided Copying.Jam Free
          Performance and Reliability</p>
      </div>
    </div>
  </section>
  <section *ngIf="config.title == 'Karupattiraja'">
    <div class="karupatti_info_common">
      <div class="karupatti_info_div">
        <img class="karupatti_info_img" src="assets/images/vendor/home2.svg">
        <p style="text-align: center;font-weight: bold;">No Chemicals</p>
        <p style="text-align: center;
      padding: 10px;">Organic Products are grown in environmentally friendly ways without agricultural chemicals</p>
      </div>
      <div class="karupatti_info_div">
        <img class="karupatti_info_img" src="assets/images/vendor/home3.svg">
        <p style="text-align: center;font-weight: bold;">Stay healthier</p>
        <p style="text-align: center;
      padding: 10px;">Our organic products will help you and your families stay healthier</p>
      </div>
      <div class="karupatti_info_div_last">
        <img class="karupatti_info_img" src="assets/images/vendor/plate_spoon.png">
        <p style="text-align: center;font-weight: bold;">Quality Standards</p>
        <p style="text-align: center;
      padding: 10px;">We consider quality the highest of values,going beyond your expectations when buying our natural
          food products</p>
      </div>
    </div>
  </section>

  <!-- <section class="scale-9" *ngIf="config.title == 'ShubhCards'">
    <div class="text-center mb-2">
        <h3 class="text-primary"> WHAT DO OUR CUSTOMERS SAY</h3>
    </div>
    <owl-carousel-o [options]="ProductSliderConfig" class="slider rounder-corner-nav">
      <ng-container
        *ngFor="let review of reviews; let i = index">
        <ng-template carouselSlide>
          <p><i>{{review.comment}}</i></p>
          <p style="float:right; margin-right:10px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>--{{review.user}}</b></p>
        </ng-template>                 
      </ng-container>
    </owl-carousel-o>
</section> -->
  <!-- <div class="container-fluid best-products">
    <div class="container">
      <div class="title">
        <h1 class="main-title">Best Of Tyres</h1>
      </div>
      <app-best-products></app-best-products>
    </div>
  </div> -->
  <!----->


  <!-- <section class="test"     *ngIf="config.title == 'Beaubelle'" >
    <style>
      .test{
        height: fit-content;
        width: fit-content;
        
      }
      @media (max-width: 412px) {
        .test{
        height: fit-content;
        width: fit-content; 
       
        
      }
      
  }
  @media screen  and (max-width: 600px){
    .card-text{
      font-size: 12px;
    }
    img{
      max-height: 170px;
      width: 500px;

    } 
  }
    </style>
    <div class="text-center mb-2"> 
        <h3 class="text-primary" style="padding-bottom: 20px;position: relative;top: -30px;">WHAT DO OUR CUSTOMERS SAY</h3>    
    </div>
    <div class="card mb-3" style="height: 250px;border: none;">
      <div class="row g-0">
        <div class="col-1"></div>
        <div class="col-4">
          <img
            src="/assets/images/beaubelle/home page.png"
            alt="Trendy Products"
            class="img-thumbnail"  style="height: 250px; width:1000px"
          />
        </div>
        
        <div class="col-6">
          <div class="card-body">
            <h5 class="card-title">Card title</h5>
            <p class="card-text">
              This is a wider card with supporting text below as a natural lead-in to
              additional content. This content is a little bit longer.
            </p>
            <p class="card-text">
              <small class="text-muted">Last updated 3 mins ago</small>
            </p>
          </div>
        </div>
      </div>
    </div>



    <div class="card mb-3" style="height: 250px;border: none;">
      <div class="row g-0">
        <div class="col-1"></div>
        <div class="col-6">
          <div class="card-body">
            <h5 class="card-title">Card title</h5>
            <p class="card-text">
              This is a wider card with supporting text below as a natural lead-in to
              additional content. This content is a little bit longer.
            </p>
            <p class="card-text">
              <small class="text-muted">Last updated 3 mins ago</small>
            </p>
          </div>
        </div>
        <div class="col-4">
          <img
            src="/assets/images/beaubelle/home page.png"
            alt="Trendy Products"
            class="img-thumbnail"  style="height: 250px; width:1000px"/>
         
        </div>
       
      </div>
    </div>
</section> -->

  <section class="quote home-special-banner" *ngIf="config.title == 'SpecialWires'"
    style="background-image: url('../../../../assets/images/specialwires/blueback2.jpg');">
    <div style="display: flex;justify-content: center;">
      <div style="border-left: 6px solid black;
    height: 25px;margin-top: 30px;">
      </div>
    </div>
    <div class="title-div" style="display: grid; justify-content: center; margin-left: 45px;">
      <p class="content-title3 title-box title main-title">
        WELCOME TO THE WORLD OF WELDING SOLUTIONS
      </p>
    </div>
    <br><br>
    <div style="margin-left: 17%;">
      <p class="content-title title-box title main-title"
        style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -18px;font-size: 18px;width: 80%;">
        Special Wires is a retaining company of merger between Standard Wire products & Special Wire Products Pvt Ltd,
        manufacturer of MIG Wire, MS, Wire and carbon Steel wires, Cold forged parts & Seat Springs. It is a merger
        company with standard wire Products, established in the year of 1983.</p>
      <p class="content-title title-box title main-title"
        style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -18px;font-size: 18px;width: 80%;">
        Housing in 25000 sq.ft shop floor equipped with latest machines from TAIWAN, JAPAN alongside with best India
        machines.</p>
      <p class="content-title title-box title main-title"
        style="text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #373230;padding-top: 0px; margin-top: -18px;font-size: 18px;width: 80%;">
        Skill competent: High trained work force for producing same products for more than 3 decades with a production
        capacity of 18000 tons annually.</p>
    </div>
    <div *ngIf="totalLength > 0">
      <owl-carousel-o [options]="ProductSliderConfig" class="slider3 rounder-corner-nav">
        <ng-container class="prodinfo" *ngFor="let product of recommededProducts; let i = index">
          <ng-template carouselSlide>
            <br>
            <br>
            <div class="product-list-cards-specialwires1" style="color: lightgray">
              <div class="special-img">
                <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                  class="product-list-image-specialwires" />
                <!-- <img src="../../../../assets/images/specialwires/mig-final.jpg" style="margin-left: 10%;"class="product-list-image-specialwires"> -->
              </div>
              <div class="product-list-description-special1">
                <div>
                  <div class="d-flex special_home_prodname">

                    <div>
                      <p (click)="productDetails(product.id)" class="product-list-tile-special">{{product.name}}
                      </p>
                      <!-- <p class="product-list-tile-special">MIG Wire</p> -->
                    </div>
                  </div>
                </div>
                <div class="d-flex" style="margin-bottom: 10px; justify-content: center;">
                  <button class="special-atc" (click)="productDetails(product.id)">
                    BUY NOW
                    <span> <i class="fa fa-shopping-cart"></i></span>
                  </button>
                </div>
              </div>

            </div>

          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </section>
  <section class="quote" *ngIf="config.title == 'SpecialWires'" style="margin-top: 35px; ">
    <div class="row special-sec-banner">
      <div class="col-md-1"></div>
      <div class="col-md-10 special-homeslide">
        <div id="myCarousel" class="carousel slide" data-ride="carousel">
          <!-- Indicators -->
          <ol class="carousel-indicators special-carousel">
            <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
            <li data-target="#myCarousel" data-slide-to="1"></li>

          </ol>

          <!-- Slides -->
          <div class="carousel-inner"
            style="box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.5), -0.125rem -0.125rem 1rem rgba(13, 183, 202, 0.5), 1.125rem 0.125rem 1rem rgba(255, 255, 255, 0.5);">
            <div class="carousel-item active">
              <img class="d-block w-100" src="assets/images/specialwires/flux-cored.jpg" alt="First slide">

            </div>
            <div class="carousel-item">
              <img class="d-block w-100" src="assets/images/specialwires/electrode banner.jpg" alt="Second slide">

            </div>
          </div>

          <!-- Controls -->
          <!-- <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a> -->
        </div>
      </div>
      <div class="col-md-1"></div>
    </div>
    <br>

  </section>
  <main style=" margin-top: 35px; background-image: url('../../../../assets/images/specialwires/back2.jpg');"
    *ngIf="config.title === 'SpecialWires'">
    <section class="product-title">
      <br>
      <div style="display: flex;justify-content: center;">
        <div style="border-left: 6px solid black;
    height: 25px;">
        </div>
      </div>
      <h2 class="title1 main-title"
        style=" display: flex;justify-content: center; text-shadow: none;color: #373230; margin-bottom: 20px;">Our
        Featured Products</h2>
      <owl-carousel-o [options]="ProductSliderConfig" class="slider4 rounder-corner-nav">

        <ng-container class="prodinfo" *ngFor="let product of recommededProducts;let i =index">
          <ng-template carouselSlide>
            <div class="product-list-special" style="color: lightgray;">
              <div class="special-img2" style="background: #a2bfda;">
                <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                  class="product-list-image-avonseals1" />
              </div>
              <div class="product-list-description-special" style="background: #a2bfda">
                <div class="d-flex" style="width: 100%; margin-bottom: 17px; display: flex; justify-content: center;">
                  <p (click)="productDetails(product.id)" class="product-list-tile-special">{{product.name}}
                  </p>
                </div>
                <div class="row4" style="display: flex;justify-content: center;">
                  <div class="inner-star-icon review-mob2 pd-1">
                    <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star"
                        aria-hidden="true"></i></span>
                    <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star"
                        aria-hidden="true"></i></span>
                    <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star"
                        aria-hidden="true"></i></span>
                    <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star"
                        aria-hidden="true"></i></span>
                    <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star"
                        aria-hidden="true"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </section>
  </main>
  <section class="review-title" *ngIf="config.title === 'SpecialWires'"
    style="margin-top: 35px; background-size: cover;background-position: center;object-fit: cover;margin-bottom: 10px; background-image: url('../../../../assets/images/specialwires/sample.jpeg');">
    <div class="text-center mb-2">
      <br>
      <!-- <h3 class="text-primary"><strong style="color: rgb(245 236 236)!important; font-size: 12px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;"> TESTIMONIAL</strong></h3> -->
    </div>
    <div class="text-center">
      <h4 class="head-text"><strong
          style="font-size: 22px;color: rgb(245 236 236)!important;;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">OUR
          HAPPY CUSTOMERS</strong></h4>
      <br>
    </div>
    <br>
    <owl-carousel-o [options]="ProductSliderConfig" class="slider2 rounder-corner-nav">

      <ng-container class="revinfo" *ngFor="let product of products;let i =index">
        <ng-template carouselSlide>


          <div class="star">

            <div class="review" style="display: flex; background-color: aliceblue">
              <img src="../../../../assets/images/avonseals/user_318-159711.avif" alt="Avatar"
                style="border-radius: 50%; width:30%; height: 20%; margin-right: 5px;">
              <div class="inf1">
                <div class="inner-star-icon review-mob3 pd-1" style="align-items: center;
            justify-content: center;">
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                </div>
                <p style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">Very
                  easy to use, user friendly interface. Easy to explain to new hires. The way they condense information
                  on the homepage is easy to follow.</p>
                <br>
                <h4 class="rev" style="font-size: 18px;">Customer name</h4>
                <h4 class="date-review" style="font-size: 12px; opacity: 0.5;">Monday May 15 2023</h4>
              </div>
            </div>
          </div>


        </ng-template>
        <ng-template carouselSlide>
          <div class="star">

            <div class="review" style="display: flex; background-color: aliceblue">
              <img src="../../../../assets/images/avonseals/user_318-159711.avif" alt="Avatar"
                style="border-radius: 50%; width:30%; height: 20%; margin-right: 5px;">
              <div class="inf2">
                <div class="inner-star-icon review-mob3 pd-1" style="align-items: center;
          justify-content: center;">
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                </div>
                <p style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">The
                  Special Wire website is easy to navigate and there is a variety of distribution lists to choose from
                  to ensure you're hitting your target audience.</p>
                <br>
                <h4 class="categories" style="font-size: 18px;">Customer name</h4>
                <h4 class="date-review" style="font-size: 12px; opacity: 0.5;">Thursday May 4 2023</h4>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="star">

            <div class="review" style="display: flex; background-color: aliceblue">
              <img src="../../../../assets/images/avonseals/user_318-159711.avif" alt="Avatar"
                style="border-radius: 50%; width:30%; height: 20%; margin-right: 5px;">
              <div class="inf3">
                <div class="inner-star-icon review-mob3 pd-1" style="align-items: center;
            justify-content: center;">
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                </div>
                <p style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">
                  Their help and record groups are additionally inconceivably responsive and fast to assist with any
                  solicitations or issues raised.
                </p>
                <br>
                <h4 class="customer-name" style="font-size: 18px;">Customer name</h4>
                <h4 class="date-review" style="font-size: 12px; opacity: 0.5;">Thursday May 11 2023</h4>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="star">

            <div class="review" style="display: flex; background-color: aliceblue">
              <img src="../../../../assets/images/avonseals/user_318-159711.avif" alt="Avatar"
                style="border-radius: 50%; width:30%; height: 20%; margin-right: 5px;">
              <div class="inf3">
                <div class="inner-star-icon review-mob3 pd-1" style="align-items: center;
            justify-content: center;">
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                </div>
                <p style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;"> I
                  appreciate the help I've gotten from customer support who have given me recommendations for lists and
                  also help with the financial information.
                </p>
                <br>
                <h4 class="customer-name" style="font-size: 18px;">Customer name</h4>
                <h4 class="date-review" style="font-size: 12px; opacity: 0.5;">Tuesday June 6 2023</h4>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>

    </owl-carousel-o>

  </section>
  <section class="quote vistas-homebackground" *ngIf="config.title == 'Vistas'"
    style="background-image: url('../../../../assets/images/vistas/blue-3.png'); margin-top: 35px;">
    <div style="display: flex;justify-content: center;">
      <div style="border-left: 4px solid black;
    height: 36px;" class="vistas-welcomepaper">
      </div>
    </div>
    <div class="title-div" style="display: grid; justify-content: center; margin-left: 38px;text-align: center;">
      <p class="content-title3 title-box title main-title">
        WELCOME TO THE WORLD OF PAPERS
      </p>
    </div>
    <br><br>
    <div class="vistas-homehead">
      <owl-carousel-o [options]="ProductSliderConfig" class="slider3 rounder-corner-nav">

        <ng-container class="prodinfo" *ngFor="let product of products;let i =index">
          <ng-template carouselSlide>
            <div class="product-list-cards-specialwires1" style="color: lightgray;background-color: rgb(150 212 226);">
              <div class="special-img" style="background: rgb(150 212 226);">
                <img [src]="product.assets[0].image_source" id="img-list" (click)="productDetails(product.id)"
                  onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';" alt="{{ product.name }}"
                  class="product-list-image-specialwires" style="display: initial; max-height: 140px;" />
              </div>
              <div class="product-list-description-special1" style="background: rgb(150 212 226)">
                <div class="d-flex special_home_prodname"
                  style="width: 100%; margin-bottom: 17px; display: flex; justify-content: center;">
                  <p (click)="productDetails(product.id)" class="product-list-tile-vistas">{{product.name}}
                  </p>
                </div>
                <div class="row4" style="display: flex;justify-content: center;">
                  <div class="inner-star-icon review-mob2 pd-1">
                    <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star"
                        aria-hidden="true"></i></span>
                    <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star"
                        aria-hidden="true"></i></span>
                    <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star"
                        aria-hidden="true"></i></span>
                    <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star"
                        aria-hidden="true"></i></span>
                    <span style="font-size: 13px !important;color: black !important;"><i class="fa fa-star"
                        aria-hidden="true"></i></span>
                  </div>
                </div>
                <div class="d-flex vistas-button1" style="margin-bottom: 10px; justify-content: center;">
                  <button class="vistas-atc" (click)="productDetails(product.id)">
                    BUY NOW
                    <span> <i class="fa fa-shopping-cart"></i></span>
                  </button>
                </div>
              </div>

            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
    <!-- <div>
    <owl-carousel-o [options]="ProductSliderConfig" class="slider3 rounder-corner-nav" >
      <ng-container class="prodinfo">
        <ng-template carouselSlide>
    <br>
    <br>
      <div class="product-list-cards-specialwires1" style="color: lightgray;background-color: #008cad; ">
        <div class="special-img">
<img src="../../../../assets/images/vistas/Aa1.png" style="margin-left: 10%;"class="product-list-image-specialwires">
        </div>
        <div class="product-list-description-special1">
          <div>
            <div class="d-flex special_home_prodname">
              
              <div>
                <p class="product-list-tile-vistas">Double A paper 70 GSM</p>
              </div>
            </div>
          </div>
          <div class="d-flex" style="margin-bottom: 10px; justify-content: center;">
            <button class="vistas-atc">
                    BUY NOW
                    <span> <i class="fa fa-shopping-cart"></i></span>
                  </button>
                </div>
              </div>
            
          </div>

</ng-template>
<ng-template carouselSlide>
  <br>
  <br>
    <div class="product-list-cards-specialwires1" style="color: lightgray;background-color: #008cad;">
      <div class="special-img">
<img src="../../../../assets/images/vistas/Aa2.png" style="margin-left: 10%;"class="product-list-image-specialwires">
      </div>
      <div class="product-list-description-special1">
        <div>
          <div class="d-flex special_home_prodname">
            
            <div>
              <p class="product-list-tile-vistas">Aa2</p>
            </div>
          </div>
        </div>
        <div class="d-flex" style="margin-bottom: 10px; justify-content: center;">
          <button class="vistas-atc">
                  BUY NOW
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
              </div>
            </div>
          
        </div>

</ng-template>
<ng-template carouselSlide>
  <br>
  <br>
    <div class="product-list-cards-specialwires1" style="color: lightgray;background-color: #008cad;">
      <div class="special-img">
<img src="../../../../assets/images/vistas/paper one1.png" style="margin-left: 10%;"class="product-list-image-specialwires">
      </div>
      <div class="product-list-description-special1">
        <div>
          <div class="d-flex special_home_prodname">
            
            <div>
              <p class="product-list-tile-vistas">Paper one 70 GSM</p>
            </div>
          </div>
        </div>
        <div class="d-flex" style="margin-bottom: 10px; justify-content: center;">
          <button class="vistas-atc">
                  BUY NOW
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
              </div>
            </div>
          
        </div>

</ng-template>
<ng-template carouselSlide>
  <br>
  <br>
    <div class="product-list-cards-specialwires1" style="color: lightgray;background-color: #008cad;">
      <div class="special-img">
<img src="../../../../assets/images/vistas/IK Copy 70 GSM.png" style="margin-left: 10%;"class="product-list-image-specialwires">
      </div>
      <div class="product-list-description-special1">
        <div>
          <div class="d-flex special_home_prodname">
            
            <div>
              <p class="product-list-tile-vistas">IK Copy 70 GSM</p>
            </div>
          </div>
        </div>
        <div class="d-flex" style="margin-bottom: 10px; justify-content: center;">
          <button class="vistas-atc">
                  BUY NOW
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
              </div>
            </div>
          
        </div>

</ng-template>
<ng-template carouselSlide>
  <br>
  <br>
    <div class="product-list-cards-specialwires1" style="color: lightgray;background-color: #008cad;">
      <div class="special-img">
<img src="../../../../assets/images/vistas/IK copy for 80 GSM.png" style="margin-left: 10%;"class="product-list-image-specialwires">
      </div>
      <div class="product-list-description-special1">
        <div>
          <div class="d-flex special_home_prodname">
            
            <div>
              <p class="product-list-tile-vistas">IK Copy 80 GSM</p>
            </div>
          </div>
        </div>
        <div class="d-flex" style="margin-bottom: 10px; justify-content: center;">
          <button class="vistas-atc">
                  BUY NOW
                  <span> <i class="fa fa-shopping-cart"></i></span>
                </button>
              </div>
            </div>
          
        </div>

</ng-template>
</ng-container>
</owl-carousel-o>
  </div> -->
  </section>

  <section class="review-title" *ngIf="config.title === 'Vistas'"
    style="background-size: cover;background-position: center;object-fit: cover;margin-top: 35px; background-image: url('../../../../assets/images/vistas/blue-5.jpg')">
    <div class="text-center">
      <h4 class="head-text"><strong
          style="font-size: 22px;color: rgb(129 65 65)!important;;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">OUR
          HAPPY CUSTOMERS</strong></h4>
    </div>
    <br>
    <owl-carousel-o [options]="ProductSliderConfig" class="slider2 rounder-corner-nav">

      <ng-container class="revinfo" *ngFor="let product of products;let i =index">
        <ng-template carouselSlide>


          <div class="star">

            <div class="review" style="display: flex; background-color: aliceblue">
              <img src="../../../../assets/images/vistas/user_318-159711.avif" alt="Avatar"
                style="border-radius: 50%; width:30%; height: 20%; margin-right: 5px;">
              <div class="inf1">
                <div class="inner-star-icon review-mob3 pd-1" style="align-items: center;
            justify-content: center;">
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                </div>
                <p style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">
                  Vistas EXIM is a great deal to our company. We have been purchasing their papers for past 15years.
                </p>
                <br>
                <h4 class="rev" style="font-size: 18px;">Customer name</h4>
                <h4 class="date-review" style="font-size: 12px; opacity: 0.5;">Monday May 15 2023</h4>
              </div>
            </div>
          </div>


        </ng-template>
        <ng-template carouselSlide>
          <div class="star">

            <div class="review" style="display: flex; background-color: aliceblue">
              <img src="../../../../assets/images/vistas/user_318-159711.avif" alt="Avatar"
                style="border-radius: 50%; width:30%; height: 20%; margin-right: 5px;">
              <div class="inf1">
                <div class="inner-star-icon review-mob3 pd-1" style="align-items: center;
            justify-content: center;">
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                </div>
                <p style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">The
                  quality of paper that are deliver by Vistas EXIM is great and we hope to have strong ties with them
                  further. </p>
                <br>
                <h4 class="categories" style="font-size: 18px;">Customer name</h4>
                <h4 class="date-review" style="font-size: 12px; opacity: 0.5;">Thursday May 4 2023</h4>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template carouselSlide>
          <div class="star">

            <div class="review" style="display: flex; background-color: aliceblue">
              <img src="../../../../assets/images/vistas/user_318-159711.avif" alt="Avatar"
                style="border-radius: 50%; width:30%; height: 20%; margin-right: 5px;">
              <div class="inf1">
                <div class="inner-star-icon review-mob3 pd-1" style="align-items: center;
            justify-content: center;">
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 1? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 2? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 3? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 4? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <span
                    [class]="product && product.reviews && product.reviews.average >= 5? 'fa fa-star checked': 'fa fa-star-o'"
                    style="font-size: 13px !important;color: orange !important;"></span>
                  <!-- <a  routerLink="/product-review/{{product.id}}" style="color:#000000 !important;font-size: 11px !important; font-weight: 500 !important;"> {{product && product.reviews ? product.reviews.total_reviews : 0}} reviews</a> -->
                </div>
                <p style="font-size: 15px;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important;">
                  Deliver and the quality of the product is perfect and we appreciate the ownership taken by the
                  employees in mainatining the standard of the company</p>
                <br>
                <h4 class="customer-name" style="font-size: 18px;">Customer name</h4>
                <h4 class="date-review" style="font-size: 12px; opacity: 0.5;">Thursday May 11 2023</h4>
              </div>
            </div>
          </div>

          <!-- <p style="margin-left:10px;font-family: 'proxima-regular','sans-serif'!important;color: rgb(229, 200, 200)!important;">{{review.comment}}</p>
      <p style="margin-left:10px;font-family: 'proxima-regular','sans-serif'!important;color: rgb(229, 200, 200)!important;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>--{{review.user}}</b></p> -->
        </ng-template>
      </ng-container>

    </owl-carousel-o>

  </section>
  <section class="quote" *ngIf="config.title == 'Vistas'"
    style="margin-top: 35px;  background-image: url('../../../../assets/images/vistas/blue-2.png');height: 165px;">
    <br>
    <h2 style="color: #565600;text-align: center; margin-top: 10px;margin-bottom: 22px;">FOLLOW US!</h2>
    <ul class="social-icons2" style="width: -webkit-fill-available;
          height: 50px;
          display: flex;
          justify-content: center;">
      <li style="margin-right: 30px;cursor: pointer;">
        <a href="https://www.vistasexim.com/#/">
          <i style="color: #565600 !important; font-size: x-large;" class="fa fa-facebook"></i>
        </a>
      </li>
      <li style="margin-right: 30px;cursor: pointer;">
        <a href="https://www.vistasexim.com/#/">
          <i style="color: #565600 !important;font-size: x-large;" class="fa fa-twitter"></i>
        </a>
      </li>
      <li style="margin-right: 30px;cursor: pointer;">
        <a href="https://www.vistasexim.com/#/">
          <i style="color: #565600 !important;font-size: x-large;" class="fa fa-pinterest" aria-hidden="true"></i>
        </a>
      </li>
      <li style="margin-right: 30px;cursor: pointer;">
        <a href="https://www.vistasexim.com/#/">
          <i style="color: #565600 !important;font-size: x-large;" class="fa fa-instagram"></i>
        </a>
      </li>
      <li style="cursor: pointer;">
        <a href="https://www.vistasexim.com/#/">
          <i style="color:#565600 !important;font-size: x-large;" class="fa fa-linkedin"></i>
        </a>
      </li>
    </ul>
    <hr
      style="border: 2px solid #565600; width: 74px;margin-left: auto; margin-right: auto; margin-bottom: 40px; margin-top: -24px;">
  </section>
</div>
<section *ngIf="config.title==='Vimpro'" class="sec_top " style="margin-top: -65vh;">
  <div class="col-1"></div>
  <div class="col-10 exoffer" id="exoffer-margin">
    <div class="card mt-3" id="exoffer_12">
      <div class="row g-0">
        <div class="col-md-8 vimpro_imghome">
          <div class="container">
            <img src="assets/images/vimpro/Precise_Customization.png" class="img-fluid rounded-start img_shop"
              id="precise_size" alt="...">
          </div>

        </div>
        <div class="col-md-4 align_left_vimpro">
          <div class="card-body">
            <div class="container container1_vimpro container_home rep_c">
              <p class="card-text new_arr1">Precise and Exact Customization</p>
              <p class="card-text new_arr line_allign" id="Versatility_size">Versatility, accuracy and speed are among
                the key benefits offered by today's leading custom Vacuum Forming manufacturers</p>
              <button class="btn btn-primary btn_size1 vimpro_shop_btn" id="accuracy_button"
                (click)="vimproToCategory()">SHOP NOW</button>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>


</section>
<section *ngIf="config.title==='Vimpro'" id="gallery_sec" name="gallery_sec" class="g_sec_top gallery_top"
  style="margin-bottom: 10px;">
  <h4 class="text-primary"
    style="padding: 3%; width: 80%; margin-left: 10%; display: flex; justify-content: center;font-size: 30px;font-weight: 700;margin-top:50px;color: #341363!important;">
    Gallery</h4>
  <div class="row3 gallery_row">

    <div class="back1">
      <div class="col-3 back1">
        <img class="gallery_img" src="assets/images/vimpro/g1.JPG">
      </div>
    </div>
    <div class="back1">
      <div class="col-3 back1">
        <img class="gallery_img" src="assets/images/vimpro/IMG_5607.JPG">
      </div>
    </div>
    <div class="back1">
      <div class="col-3 back1">
        <img class="gallery_img" src="assets/images/vimpro/g3.JPG">
      </div>
    </div>
  </div>
  <div class="row3 gallery_row">

    <div class="back1">
      <div class="col-3 back1">
        <img class="gallery_img" src="assets/images/vimpro/IMG_5630.JPG">
      </div>
    </div>
    <div class="back1">
      <div class="col-3 back1">
        <img class="gallery_img" src="assets/images/vimpro/g5.JPG">
      </div>
    </div>
    <div class="back1">
      <div class="col-3 back1">
        <img class="gallery_img" src="assets/images/vimpro/g6.JPG">
      </div>
    </div>
  </div>
  <div class="row3 gallery_row">
    <div class="back1">
      <div class="col-3 back1">
        <img class="gallery_img" src="assets/images/vimpro/IMG_5614.JPG">
      </div>
    </div>
    <div class="back1">
      <div class="col-3 back1">
        <img class="gallery_img" src="assets/images/vimpro/gal2.JPG">
      </div>
    </div>
    <div class="back1">
      <div class="col-3 back1">
        <img class="gallery_img" src="assets/images/vimpro/gal3.JPG">
      </div>
    </div>
  </div>
</section>

<!-- <section class="review-title title_message3" *ngIf="config.title === 'Cle'" style="background-size: cover;background-position: center;object-fit: cover;margin-bottom: 10px;background-color: transparent;
background-image: linear-gradient(180deg,#e4e2e3 0%,#e0dcd8 100%);"> -->
<section *ngIf="config.title === 'Cle'">
  <div class="row" style="width: 100%;">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <div id="myCarousel2" class="carousel slide" data-ride="carousel">
        <!-- Indicators -->
        <ol class="carousel-indicators">
          <li data-target="#myCarousel2" data-slide-to="0" class="active"></li>
          <li data-target="#myCarousel2" data-slide-to="1"></li>

        </ol>

        <!-- Slides -->
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img class="d-block w-100" src="assets/images/cle/home_c.jpg" alt="First slide">

          </div>
          <div class="carousel-item">
            <img class="d-block w-100" src="assets/images/cle/home_c1.jpg" alt="Second slide">

          </div>
          <div class="carousel-caption" style="margin-left: 60%;top: 50%;width: 30%!important;
          height: 50%;">
            <h3 class="desktop-only" style="position: fixed;top: 80px;">Meticulously Crafted With Pride & Skill</h3>
            <p class="mobile-only" style="position: fixed;font-size: 10px;">Meticulously Crafted With Pride & Skill</p>
          </div>

        </div>

        <!-- Controls -->
        <a class="carousel-control-prev" href="#myCarousel2" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#myCarousel2" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      <!-- <img decoding="async" width="800" height="500" src="assets/images/cle/handicraft-full-section-left.jpg" alt="handicraft-full-section-left" loading="lazy" sizes="(max-width: 1774px) 100vw, 1774px"> -->
    </div>
    <div class="col-md-1"></div>
    <!-- <div class="col-md-5" style="padding-top: 10%;">
      <span>
        <span style="font-weight: 350 !important;
        text-transform: none;
        font-size: 2.5rem;
        line-height: 3.125rem !important;
        letter-spacing: -.029rem;
        color: #000a12;"> Lets modify your <br>interior looks
  
      </span>
      </span>
      <div>
        <span style="font-family: 'Josefin Sans';
        font-weight: 400 !important;
        text-transform: none;
        font-size: 1rem;
        line-height: 1.625rem !important;
        letter-spacing: .02rem;
        color: #666;">
         Base wheel zoom adoption open manage future-proof for.<br> Start what’s status cost food caught.
        </span>
      </div>
      <div   style="padding-top: 5%;"  >
        <a style="
        font-size: 16px;
        font-weight: 500;
        text-transform: capitalize;
        line-height: 26px;
        fill: #333;
        color: #333;
        background-color: #fff;
        border-radius: 0;
        padding: 11px 40px;cursor: pointer;">
            <span>
              Shop Now
            </span>
        </a>
    
      </div>
    </div> -->
  </div>
  <!-- <div class="desk-cle">Large Screen</div>
<div class="div-only-mobile-cle">Only Mobile</div>
<p>Demo Text.</p> -->
  <!-- <div class="row title_message">

</div> -->
  <br>

</section>



<section class="review-title title_message4" *ngIf="config.title === 'Cle'" style="background-size: cover;background-position: center;object-fit: cover;margin-bottom: 10px;background-color: transparent;margin-bottom: 0%;margin-top:4%;
">
  <div class="row" style="width: 100%;">
    <div class="col-md-7">
      <img style="z-index: 1;left: 325px;" class="imgclass" src="assets/images/cle/Photo from Kalangiam111.jpg">
      <img style="z-index: 3;top: 100px;" class="imgclass" src="assets/images/cle/Photo from Kalangiam222.jpg">
    </div>
    <div class="col-md-4" style="padding-top: 5%;">
      <span>
        <span style="font-weight: 350 !important;
        text-transform: none;
        font-size: 2.5rem;
        line-height: 3.125rem !important;
        letter-spacing: -.029rem;
        color: #000a12;">Showcasing India's Mastery <br>in Leather Exports With <br>Pride & Skill

        </span>
      </span>
      <div class="row" style="margin-top:8%;">
        <div class="col-md-6" (click)="routeToLists1('Finished Leather')">
          <span>
            <img src="assets/images/cle/Photo from Kalangiam(7).jpg" style="max-width: 235px;cursor: pointer;">
          </span>
          <div style="text-align: center;top: 4%;
          position: inherit;">
            <span style="
            font-weight: 500 !important;
            text-transform: none;
            font-size: 1.2rem;
            line-height: 1.9rem !important;cursor: pointer;
            letter-spacing: -.029rem;
            color: #000a12;">
              Finished Leather
            </span>
          </div>
        </div>
        <div class="col-md-6" (click)="routeToLists1('Leather & Synthetic Goods')">
          <span>
            <img src="assets/images/cle/Photo from Kalangiam(16).jpg" style="max-width: 235px;cursor: pointer;">
          </span>
          <div style="text-align: center;top: 4%;
          position: inherit;">
            <span style="
            font-weight: 500 !important;
            text-transform: none;cursor: pointer;
            font-size: 1.2rem;
            line-height: 1.9rem !important;
            letter-spacing: -.029rem;
            color: #000a12;">
              Leather & Synthetic Goods
            </span>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top:8%;width: 100%;" (click)="routeToLists1('Leather Footwear')">
        <div class="col-md-6">
          <span>
            <img src="assets/images/cle/Photo from Kalangiam(12).png" style="max-width: 235px;cursor: pointer;">
          </span>
          <div style="text-align: center;top: 4%;
          position: inherit;">
            <span style="
            font-weight: 500 !important;
            text-transform: none;
            font-size: 1.2rem;cursor: pointer;
            line-height: 1.9rem !important;
            letter-spacing: -.029rem;
            color: #000a12;">
              Leather Footwear
            </span>
          </div>
        </div>
        <div class="col-md-6" (click)="routeToLists1('Fur Products')">
          <span>
            <img src="assets/images/cle/Photo from Kalangiam.jpg" style="max-width: 235px;cursor: pointer;">
          </span>
          <div style="text-align: center;top: 4%;
          position: inherit;">
            <span style="
            font-weight: 500 !important;cursor: pointer;
            text-transform: none;
            font-size: 1.2rem;
            line-height: 1.9rem !important;
            letter-spacing: -.029rem;
            color: #000a12;">
              Fur Products
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>

</section>

<section class="review-title title_message2" *ngIf="config.title === 'Cle'" style="background-size: cover;background-position: center;object-fit: cover;margin-bottom: 10px;background-color: transparent;margin-bottom: 0%;margin-top:4%;
">
  <div class="row" style="width: 100%;">
    <div class="col-md-7">
      <img style="z-index: 1;left: 232px;" class="imgclass" src="assets/images/cle/Photo from Kalangiam111.jpg">
      <img style="z-index: 3;top: 100px;" class="imgclass" src="assets/images/cle/Photo from Kalangiam222.jpg">
    </div>
    <div class="col-md-5" style="padding-top: 5%;">
      <span>
        <span style="font-weight: 350 !important;
        text-transform: none;
        font-size: 2.5rem;
        line-height: 3.125rem !important;
        letter-spacing: -.029rem;
        color: #000a12;">Showcasing India's Mastery <br>in Leather Exports With <br>Pride & Skill

        </span>
      </span>
      <div class="row" style="margin-top:8%;width: 100%;">
        <div class="col-md-6" (click)="routeToLists1('Finished Leather')">
          <span>
            <img src="assets/images/cle/Photo from Kalangiam(7).jpg" style="max-width: 235px;cursor: pointer;">
          </span>
          <div style="text-align: center;top: 4%;
          position: inherit;">
            <span style="
            font-weight: 500 !important;cursor: pointer;
            text-transform: none;
            font-size: 1.2rem;
            line-height: 1.9rem !important;
            letter-spacing: -.029rem;
            color: #000a12;">
              Finished Leather
            </span>
          </div>
        </div>
        <div class="col-md-6" (click)="routeToLists1('Leather & Synthetic Goods')">
          <span>
            <img src="assets/images/cle/Photo from Kalangiam(16).jpg" style="max-width: 235px;cursor: pointer;">
          </span>
          <div style="text-align: center;top: 4%;
          position: inherit;">
            <span style="
            font-weight: 500 !important;
            text-transform: none;
            font-size: 1.2rem;cursor: pointer;
            line-height: 1.9rem !important;
            letter-spacing: -.029rem;
            color: #000a12;">
              Leather & Synthetic Goods
            </span>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top:8%;width: 100%;" (click)="routeToLists1('Leather Footwear')">
        <div class="col-md-6">
          <span>
            <img src="assets/images/cle/Photo from Kalangiam(12).png" style="max-width: 235px;cursor: pointer;">
          </span>
          <div style="text-align: center;top: 4%;
          position: inherit;">
            <span style="
            font-weight: 500 !important;
            text-transform: none;
            font-size: 1.2rem;
            line-height: 1.9rem !important;cursor: pointer;
            letter-spacing: -.029rem;
            color: #000a12;">
              Leather Footwear
            </span>
          </div>
        </div>
        <div class="col-md-6" (click)="routeToLists1('Fur Products')">
          <span>
            <img src="assets/images/cle/Photo from Kalangiam.jpg" style="max-width: 235px;cursor: pointer;">
          </span>
          <div style="text-align: center;top: 4%;
          position: inherit;">
            <span style="
            font-weight: 500 !important;
            text-transform: none;cursor: pointer;
            font-size: 1.2rem;
            line-height: 1.9rem !important;
            letter-spacing: -.029rem;
            color: #000a12;">
              Fur Products
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>

</section>

<section class="review-title title_message1" *ngIf="config.title === 'Cle'" style="background-size: cover;background-position: center;object-fit: cover;margin-bottom: 10px;background-color: transparent;margin-bottom: 0%;margin-top:4%;
">
  <div class="row" style="width: 100%;">
    <div class="col-md-12">
      <span style="display: flex;
    justify-content: center;margin-top: 5%;">
        <span style="font-weight: 350 !important;
      text-transform: none;
      font-size: 2.5rem;
      line-height: 3.125rem !important;
      letter-spacing: -.029rem;
      color: #000a12;">Showcasing India's<br> Mastery in Leather <br>Exports With <br>Pride & Skill

        </span>
      </span>
    </div>
  </div>

  <div class="container" style="margin-top:8%;">
    <div class="row mob_cle_align" style="width: 100%;">
      <div class="col" (click)="routeToLists1('Finished Leather')">
        <span>
          <img src="assets/images/cle/Photo from Kalangiam(7).jpg" style="max-width: 130px;cursor: pointer;">
        </span>
        <div style="top: 4%;cursor: pointer;">
          <p class="cle-deskprodtitle">Finished Leather</p>
        </div>
      </div>
      <div class="col" (click)="routeToLists1('Leather & Synthetic Goods')">
        <span>
          <img src="assets/images/cle/Photo from Kalangiam(16).jpg" style="max-width: 130px;cursor: pointer;">
        </span>
        <div style="top: 4%;cursor: pointer;">
          <p class="cle-deskprodtitle">Leather & Synthetic Goods</p>
        </div>
      </div>
    </div>
    <div class="row mob_cle_align" style="width: 100%;">
      <div class="col" (click)="routeToLists1('Leather Footwear')">
        <span>
          <img src="assets/images/cle/Photo from Kalangiam(12).png" style="max-width: 130px;cursor: pointer;">
        </span>
        <div style="top: 4%;cursor: pointer;">
          <p class="cle-deskprodtitle">Leather Footwear</p>
        </div>
      </div>
      <div class="col" (click)="routeToLists1('Fur Products')">
        <span>
          <img src="assets/images/cle/Photo from Kalangiam.jpg" style="max-width: 130px;cursor: pointer;">
        </span>
        <div style="top: 4%;cursor: pointer;">
          <p class="cle-deskprodtitle">Fur Products</p>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div class="row" style="width: 100%;">
    <div class="col-md-12 ">
      <img style="max-width: 310px;max-height: 410px;margin-left: 25px;margin-left: 60px!important;"
        src="assets/images/cle/Photo from Kalangiam111.jpg">

    </div>
  </div>
</section>
<hr
  *ngIf="config.title !== 'SpecialWires' && config.title !== 'Vimpro' && config.title !== 'Accel' && config.title !== 'BestGifts' && config.title !== 'Vistas' && config.title !== 'Carience' && config.title !== 'LinenRaj' && config.title !== 'Schift Cosmetics' && config.title !== 'Babys Pride' && config.title !== 'Deera' && config.title !== 'BombayHardware' && config.title !== 'LushNGreen' && config.title!=='KatbookStore' && config.title!=='Taazah' && config.title!=='SriSenbaga' && config.title!=='HOB'&& config.title!=='PaulCaroline' && config.title!=='Srimaware'"
  style="margin-top: 7rem;">
<hr style="margin-top: 4rem;border-top: none" *ngIf="config.title == 'BombayHardware'">
<hr *ngIf="config.title === 'SpecialWires'" style="margin-top: 1rem;">
<hr *ngIf="config.title === 'Vistas'" style="margin-top: 1rem;">
<!-- <hr *ngIf="config.title === 'Schift Cosmetics'"> -->
<hr *ngIf="config.title === 'BestGifts'" style="margin-top: 2rem;">
<section class="review-title title_message" *ngIf="config.title === 'Cle'" style="background-size: cover;background-position: center;object-fit: cover;margin-bottom: 10px;background-color: transparent;margin-bottom: 5%;margin-top:6%;
">
  <div class="row" style="width: 100%;margin-right: 0px;margin-left: 0px;">
    <div class="col-md-3">
      <div class="row" style="position: relative;top: 22px; width: 100%;">
        <div class="col-md-5" style="display: flex;justify-content: center;position: relative;top: -10px;left: 13%">
          <img src="assets/images/cle/verified assistance.png"
            style="width: 70px;position: relative;object-fit: contain;">
        </div>
        <div class="col-md-7" style="margin-top: -1%;">
          <span style="font-weight: 500 !important;
     text-transform: none;
     font-size: 1.2rem;
     line-height: 1.9rem !important;
     letter-spacing: -.029rem;
     color: #000a12;">
            Exclusive CLE members
          </span>
          <div>
            <span style="font-weight: 400 !important;
      text-transform: none;
      font-size: 1rem;
      line-height: 1.625rem !important;
      letter-spacing: .02rem;
      color: #666;">

            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="row" style="width: 100%;">
        <div class="col-md-5" style="display: flex;justify-content: center;margin-top:-7%">
          <img src="assets/images/cle/support.jpeg" style="width: 90px;height: 120px;object-fit: contain;">
        </div>
        <div class="col-md-7" style="margin-top: -3%;">
          <span style="font-weight: 500 !important;
       text-transform: none;
       font-size: 1.2rem;
       line-height: 1.9rem !important;
       letter-spacing: -.029rem;
       color: #000a12;position: relative;
    left: -42px;">
            Verification Assistants
          </span>
          <span style="font-weight: 500 !important;
       text-transform: none;
       font-size: 1.0rem;
       line-height: 1.9rem !important;
       letter-spacing: -.029rem;
       color: #000a12;position: relative;
    left: -42px;">
            Please write to: <br>ad-tp@cleindia.com
          </span>
          <div>
            <span style="
        font-weight: 400 !important;
        text-transform: none;
        font-size: 1rem;
        line-height: 1.625rem !important;
        letter-spacing: .02rem;
        color: #666;">

            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="row" style="width: 100%;">
        <div class="col-md-5" style="display: flex;justify-content: center;">
          <img src="assets/images/cle/connect1.jpg" style="width: 60px;height: 60px;object-fit: contain;">
        </div>
        <div class="col-md-7" style="top: -32px;left: -39px;max-width: 58%;flex: 0 0 58%;">
          <span style="font-weight: 500 !important;
       text-transform: none;
       font-size: 1.2rem;
       line-height: 1.9rem !important;
       letter-spacing: -.029rem;
       color: #000a12;">
            Easy Connect <br>
          </span>
          <span style="font-weight: 500 !important;
       text-transform: none;
       font-size: 1.0rem;
       line-height: 1.9rem !important;
       letter-spacing: -.029rem;
       color: #000a12;">
            For any queries, <br>
            Please write to <br>ad-tp@cleindia.com
          </span>
          <div>
            <span style="
        font-weight: 400 !important;
        text-transform: none;
        font-size: 1rem;
        line-height: 1.625rem !important;
        letter-spacing: .02rem;
        color: #666;">

            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-3" style="left: -30px;">
      <div class="row" style="width: 100%;">
        <div class="col-md-5" style="display: flex;justify-content: center;">
          <img src="assets/images/cle/Support (1).jpg" style="width: 50px;object-fit: contain;">
        </div>
        <div class="col-md-7" style="top: 0px;left: -41px;">
          <span style="font-weight: 500 !important;
       text-transform: none;
       font-size: 1.2rem;
       line-height: 1.9rem !important;
       letter-spacing: -.029rem;
       color: #000a12;">
            24/7 Support facilities for buyer
          </span>
          <div>
            <span style="
        font-weight: 400 !important;
        text-transform: none;
        font-size: 1rem;
        line-height: 1.625rem !important;
        letter-spacing: .02rem;
        color: #666;">

            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="review-title title_message1" *ngIf="config.title === 'Cle'" style="background-size: cover;background-position: center;object-fit: cover;margin-bottom: 10px;background-color: transparent;margin-bottom: 5%;margin-top:6%;
">
  <div class="row" style="width: 100%;">
    <div class="col-md-12">
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <img src="assets/images/cle/verified assistance.png" style="width: 50px;">
        </div>
      </div>
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <span style="font-weight: 500 !important;
        text-transform: none;
        font-size: 1.2rem;
        line-height: 1.9rem !important;
        letter-spacing: -.029rem;
        color: #000a12;">
            Exclusive CLE members
          </span>
        </div>
      </div>
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <span style="
        font-weight: 400 !important;
        text-transform: none;
        font-size: 1rem;
        line-height: 1.625rem !important;
        letter-spacing: .02rem;
        color: #666;">

          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="row" style="margin-top: 7%;width: 100%;">
    <div class="col-md-12">
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <img src="assets/images/cle/support.jpeg" style="width: 90px;height: 90px;">
        </div>
      </div>
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <span style="font-weight: 500 !important;
        text-transform: none;
        font-size: 1.2rem;
        line-height: 1.9rem !important;
        letter-spacing: -.029rem;
        color: #000a12;">
            Verification Assistants
          </span>
        </div>
        <div class="col-md-12" style="display: flex;justify-content: center;margin-left: 25px;">
          <span style="font-weight: 500 !important;
        text-transform: none;
        font-size: 1.0rem;
        line-height: 1.9rem !important;
        letter-spacing: -.029rem;
        color: #000a12;">
            Please write to <br>ad-tp@cleindia.com
          </span>

        </div>
      </div>
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <span style="
        font-weight: 500 !important;
        text-transform: none;
        font-size: 1rem;
        line-height: 1.625rem !important;
        letter-spacing: .02rem;
        color: #666;">

          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="row" style="margin-top: 7%;width: 100%;">
    <div class="col-md-12">
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <img src="assets/images/cle/connect1.jpg" style="width: 50px;">
        </div>
      </div>
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <span style="font-weight: 500 !important;
          text-transform: none;
          font-size: 1.2rem;
          line-height: 1.9rem !important;
          letter-spacing: -.029rem;
          color: #000a12;">
            Easy Connect<br>
          </span>
        </div>
        <div class="col-md-12" style="display: flex;justify-content: center;margin-left: 25px;">
          <span style="font-weight: 500 !important;
            text-transform: none;
            font-size: 1.0rem;
            line-height: 1.9rem !important;
            letter-spacing: -.029rem;
            color: #000a12;">
            For any queries, <br>
            Please write to <br>ad-tp@cleindia.com
          </span>

        </div>
      </div>
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <span style="
          font-weight: 400 !important;
          text-transform: none;
          font-size: 1rem;
          line-height: 1.625rem !important;
          letter-spacing: .02rem;
          color: #666;">

          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="row" style="margin-top: 7%;width: 100%;">
    <div class="col-md-12">
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <img src="assets/images/cle/Support (1).jpg" style="width: 50px;">
        </div>
      </div>
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <span style="font-weight: 500 !important;
            text-transform: none;
            font-size: 1.2rem;
            line-height: 1.9rem !important;
            letter-spacing: -.029rem;
            color: #000a12;">24/7 Support facilities for buyer

          </span>
        </div>
      </div>
      <div class="row" style="width: 100%;">
        <div class="col-md-12" style="display: flex;justify-content: center;">
          <span style="
            font-weight: 400 !important;
            text-transform: none;
            font-size: 1rem;
            line-height: 1.625rem !important;
            letter-spacing: .02rem;
            color: #666;">

          </span>
        </div>
      </div>
    </div>
  </div>
</section>
<section *ngIf="config.title==='Accel'" style="margin-top: 5%;margin-left: 5%;overflow: hidden;">

  <div class="home-vimpro1">
    <div class="home-vimpro-flex">
      <div class="vimpro-icon-out">
        <!-- <i class="fa fa-check-square-o" aria-hidden="true"></i> -->
        <i class="fa fa-tasks  vimpro-home-icon" aria-hidden="true"></i>



      </div>
      <div class="border_mobile">
        <p class="t1-vimpro">Affordable fees <br>with easy installments</p>
      </div>
    </div>
    <div class="home-vimpro-flex">
      <div class="vimpro-icon-out" style="margin-left:4%">
        <i class="fa fa-tasks  vimpro-home-icon" aria-hidden="true"></i>
        <!-- <i class="fa fa-check-square-o vimpro-home-icon" aria-hidden="true"></i> -->
        <!-- <img class="vimpro-home-icon" src="../../../../assets/images/vimpro/money-bag.png"> -->
      </div>
      <div class="border_mobile">
        <p class="t1-vimpro">Pursuit of excellence<br>through Quality</p>
      </div>
    </div>
    <div class="home-vimpro-flex">
      <div class="vimpro-icon-out" style="margin-left:4%">
        <i class="fa fa-tasks  vimpro-home-icon" aria-hidden="true"></i>
        <!-- <i class="fa fa-check-square-o vimpro-home-icon" aria-hidden="true"></i> -->
        <!-- <img class="vimpro-home-icon" src="../../../../assets/images/vimpro/insignia.png"> -->
      </div>
      <div class="border_mobile">
        <p class="t1-vimpro">Highest level<br>of Integrity</p>
      </div>
    </div>

    <div class="home-vimpro-flex">
      <div class="vimpro-icon-out" style="margin-left:4%">
        <i class="fa fa-tasks  vimpro-home-icon" aria-hidden="true"></i>
        <!-- <i class="fa fa-check-square-o vimpro-home-icon" aria-hidden="true"></i> -->

        <!-- <img class="vimpro-home-icon" src="../../../../assets/images/vimpro/packing11.png"> -->
      </div>
      <div style="width:71%">
        <p class="t1-vimpro">Customer care<br>and delight</p>
      </div>
    </div>
  </div>
</section>
<section *ngIf="config.title == 'Accel'" class="prd-sec" style="margin-top: 3%;overflow: hidden!important;">
  <div class="row" style="margin-left: 5%;">
    <div class="col-sm-1 col-md-1 col-lg-1">

    </div>

    <div class="col-sm-3 col-md-3 col-lg-3 resp_overlay_cont">
      <figure class="container_h"><img
          src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Accel/StoreGallery/MicrosoftTeams-image+(11).png"
          class="image_h" />
        <div class="overlay-left-slide">

        </div>
      </figure>

    </div>
    <div class="col-sm-3 col-md-3 col-lg-3 resp_overlay_cont">
      <figure class="container_h"><img
          src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Accel/StoreGallery/MicrosoftTeams-image+(12).png"
          class="image_h" />
        <div class="overlay-left-slide">

        </div>
      </figure>

    </div>
    <div class="col-sm-3 col-md-3 col-lg-3 resp_overlay_cont">
      <figure class="container_h"><img
          src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Accel/StoreGallery/MicrosoftTeams-image+(13).png"
          class="image_h" />
        <div class="overlay-left-slide">

        </div>
      </figure>

    </div>
    <div class="col-sm-1 col-md-1 col-lg-1">

    </div>






  </div>

</section>


<section *ngIf="config.title == 'Accel'" style="overflow: hidden;">
  <div class="row" style="width: 117%;">
    <!-- <div class="col-1"></div> -->
    <div class="col-10">
      <div class=" container container_home_product">
        <div class="mobile-only">
          <h4 style="margin-bottom: -10%;">Long Term Courses</h4>
        </div>

        <aside class="sidebar desktop-only">
          <!-- <div class="arrow-right">
           
          </div> -->
          <h3 class="accel_h3">Long Term Courses</h3>
          <!-- <div class="flag">
            
          </div> -->

          <ul>
            <li><a (click)="productDetails(13)" class="li_change pointer">Post Graduate Diploma in IT Infrastructure
                Management Services</a></li>
            <li><a (click)="productDetails(14)" class="li_change pointer ">Post Graduate Diploma in Cloud
                Engineering</a></li>
            <li><a (click)="productDetails(15)" class="li_change pointer">Post Graduate Diploma in Cyber Security</a>
            </li>
            <li><a (click)="productDetails(16)" class="li_change pointer">Diploma In Computer Hardware And
                Networking</a></li>
            <!-- <li><a href="#" class="li_change">Post Four</a></li>
                <li><a href="#" class="li_change">Post Five</a></li> -->
          </ul>
        </aside>

        <section class="main" style="width: 110%;margin-top: -21px;">

          <div class="row">

            <div class="column accel-col">

              <div class="card" style="height: 445px!important;">

                <img src="https://www.accelacademy.in/assets/img/course-full/1.jpg" alt="Avatar" style="width:100%"
                  class="pointer" (click)="productDetails(13)">

                <h4 class="desktop-only" style="height: 24%; line-height: 0.8;margin-top: 15px;text-align: left;"
                  class="pointer" (click)="productDetails(13)"><b>Post Graduate Diploma in IT Infrastructure Management
                    Services</b></h4>

                <p class="mobile-only"><b>Post Graduate Diploma in IT Infrastructure Management Services</b></p>



                <p style="line-height:1;text-align: left;font-size: 13px;margin-top: 2%;">Teach the creation of Software
                  Applications with the view of meeting certain requirements</p>

                <div style="display: flex;justify-content: center;">
                  <button type="button" class="btn btn-dark"
                    style="width: 58%;font-size: 13px;color: black; margin-top: 10%;height: 35px;background-color: #b1e8e8;"
                    (click)="productDetails(13)">View Details</button>
                </div>
                <!-- <div class="container"  style="display: flex;">

                  <i class="fa fa-clock-o" aria-hidden="true"></i>

                  <p style="margin-left: 10%;margin-top: -2%;">420 Hours</p>

                </div> -->

                <!-- <div class="container"  style="display: flex;">

                <i class="fa fa-star" aria-hidden="true"></i>

                  <p style="margin-left: 10%;margin-top: -2%;">CTC - 2LPA</p>

                </div> -->

              </div>

            </div>



            <div class="column accel-col" style="margin-left: 25px;">

              <div class="card" style="height: 445px!important;">

                <img class="pointer" src="https://www.accelacademy.in/assets/img/course-full/3.jpg" alt="Avatar"
                  style="width:100%" (click)="productDetails(14)">

                <h4 class="desktop-only pointer"
                  style="height: 24%; line-height: 0.8;margin-top: 15px;text-align: left;" (click)="productDetails(14)">
                  <b>Post Graduate Diploma in Cloud Engineering</b>
                </h4>

                <p class="mobile-only"><b>Post Graduate Diploma in Cloud Engineering</b></p>

                <p style="line-height:1;text-align: left;font-size: 13px;margin-top: 2%">Teach the creation of Software
                  Applications with the view of meeting certain requirements</p>

                <div style="display: flex;justify-content: center;">
                  <button type="button" class="btn btn-dark"
                    style="width: 58%;font-size: 13px;color: black; margin-top: 10%;height: 35px;background-color: #b1e8e8;"
                    (click)="productDetails(14)">View Details</button>
                </div>
              </div>

            </div>



            <div class="column accel-col" style="margin-left: 25px;">

              <div class="card" style="height: 445px!important;">

                <img class="pointer" src="https://www.accelacademy.in/assets/img/course-full/2.jpg" class="pointer"
                  alt="Avatar" style="width:100%" (click)="productDetails(15)">

                <h4 class="desktop-only pointer"
                  style="height: 24%; line-height: 0.8;margin-top: 15px;text-align: left;" (click)="productDetails(15)">
                  <b>Post Graduate Diploma in Cyber Security</b>
                </h4>

                <p class="mobile-only"><b>Post Graduate Diploma in Cyber Security</b></p>

                <p style="line-height:1;text-align: left;font-size: 13px;margin-top: 2%;">Teach the creation of Software
                  Applications with the view of meeting certain requirements</p>

                <div style="display: flex;justify-content: center;">
                  <button type="button" class="btn btn-dark"
                    style="width: 58%;font-size: 13px;color: black; margin-top: 10%;height: 35px;background-color: #b1e8e8;"
                    (click)="productDetails(15)">View Details</button>
                </div>
              </div>

            </div>





          </div>







        </section>

      </div>
    </div>
    <!-- <div class="col-1"></div> -->
  </div>








</section>


<section *ngIf="config.title == 'Accel'" style="overflow: hidden;">
  <div class="row" style="width: 117%;">
    <!-- <div class="col-1"></div> -->
    <div class="col-10">
      <div class=" container container_home_product align_top_course">
        <div class="mobile-only">
          <h4 style="margin-bottom: -10%;">Short Term Courses</h4>
        </div>

        <aside class="sidebar desktop-only">
          <!-- <div class="arrow-right1">
               
              </div> -->
          <h3 class="accel_h13">Short Term Courses</h3>
          <!-- <div class="flag">
                
              </div> -->

          <ul class="pointer">
            <li><a (click)="productDetails(18)" class="li_change">Certificate Program in AWS</a></li>
            <li><a (click)="productDetails(19)" class="li_change">Certificate Program in Linux Server Administration</a>
            </li>
            <li><a (click)="productDetails(21)" class="li_change">Certificate Program in Soft Skills</a></li>
            <li><a (click)="productDetails(20)" class="li_change">Certificate Program in Windows Server
                Administration</a></li>
            <!-- <li><a href="#" class="li_change">Post Four</a></li>
                    <li><a href="#" class="li_change">Post Five</a></li> -->
          </ul>
        </aside>

        <section class="main" style="width: 110%;margin-top: -21px;">
          <div class="row">
            <div class="column accel-col">
              <div class="card" style="height: 445px!important;">
                <img class="pointer" src="https://www.accelacademy.in/assets/img/course-full/4.jpg" alt="Avatar"
                  style="width:100%" (click)="productDetails(18)">
                <h4 class="desktop-only pointer"
                  style="height: 24%; line-height: 0.8;margin-top: 15px;text-align: left;" (click)="productDetails(18)">
                  <b>Certificate Program in AWS</b>
                </h4>
                <p class="mobile-only"><b>Certificate Program in AWS</b></p>
                <p style="line-height:1;text-align: left;font-size: 13px;margin-top: 2%;">Teach the creation of Software
                  Applications with the view of meeting certain requirements</p>

                <div style="display: flex;justify-content: center;">
                  <button type="button" class="btn btn-dark"
                    style="width: 58%;font-size: 13px;color: black; margin-top: 10%;height: 35px;background-color: #b1e8e8;"
                    (click)="productDetails(18)">View Details</button>
                </div>
              </div>
            </div>

            <div class="column accel-col" style="margin-left: 25px;">
              <div class="card" style="height: 445px!important;">
                <img class="pointer" src="https://www.accelacademy.in/assets/img/course-full/7.jpg" alt="Avatar"
                  style="width:100%" (click)="productDetails(19)">
                <h4 class="desktop-only pointer"
                  style="height: 24%; line-height: 0.8;margin-top: 15px;text-align: left;" (click)="productDetails(19)">
                  <b>Certificate Program in Linux Server Administration</b>
                </h4>
                <p class="mobile-only"><b>Certificate Program in Linux Server Administration</b></p>
                <p style="line-height:1;text-align: left;font-size: 13px;margin-top: 2%;">Teach the creation of Software
                  Applications with the view of meeting certain requirements</p>

                <div style="display: flex;justify-content: center;">
                  <button type="button" class="btn btn-dark"
                    style="width: 58%;font-size: 13px;color: black; margin-top: 10%;height: 35px;background-color: #b1e8e8;"
                    (click)="productDetails(19)">View Details</button>
                </div>
              </div>
            </div>

            <div class="column accel-col" style="margin-left: 25px;">
              <div class="card" style="height: 445px!important;">
                <img class="pointer" src="https://www.accelacademy.in/assets/img/course-full/5.jpg" alt="Avatar"
                  style="width:100%" (click)="productDetails(21)">
                <h4 class="desktop-only pointer"
                  style="height: 24%; line-height: 0.8;margin-top: 15px;text-align: left;" (click)="productDetails(21)">
                  <b>Certificate Program in Soft Skills</b>
                </h4>
                <p class="mobile-only"><b>Certificate Program in Soft Skills</b></p>
                <p style="line-height:1;text-align: left;font-size: 13px;margin-top: 2%;">Teach the creation of Software
                  Applications with the view of meeting certain requirements</p>

                <div style="display: flex;justify-content: center;">
                  <button type="button" class="btn btn-dark"
                    style="width: 58%;font-size: 13px;color: black; margin-top: 10%;height: 35px;background-color: #b1e8e8;"
                    (click)="productDetails(21)">View Details</button>
                </div>
              </div>
            </div>


          </div>



        </section>


      </div>
    </div>
    <!-- <div class="col-1"></div> -->

  </div>








</section>


<!-- <section  *ngIf="config.title == 'Accel'" style="overflow: hidden;">
      <div class="row" style="width: 117%;">
        <div class="col-10">
          <div class=" container container_home_product align_top_course ">
            <div class="mobile-only" > <h4 style="margin-bottom: -20%;">Campus Programs</h4></div>
          
            <aside class="sidebar desktop-only">
              <h3 class="accel_h23">Campus Programs</h3>
              
                <ul>
                    <li><a (click)="productDetails(13)" class="li_change">PG Diploma in IT Infrastructure Management Services</a></li>
                    <li><a (click)="productDetails(14)" class="li_change">PG Diploma in Cloud Engineering</a></li>
                    <li><a (click)="productDetails(15)" class="li_change">PG Diploma in Cyber Security</a></li>
                  </ul>
            </aside>
        
            <section class="main" style="width: 110%;">
              <div class="row">
                <div class="column accel-col">
                  <div class="card">
                    <img src="https://www.accelacademy.in/assets/img/course-full/1.jpg" (click)="productDetails(13)" alt="Avatar" style="width:100%">
                    <h4 class="desktop-only" style="height: 24%; line-height: 0.8;margin-top: 15px;text-align: left;" (click)="productDetails(13)" ><b >Post Graduate Diploma in IT Infrastructure Management Services</b></h4> 
                    <p class="mobile-only"><b >PG Diploma in IT Infrastructure Management Services</b></p> 
                    <p style="line-height:1;text-align: left;font-size: 13px;margin-top: 2%;">Teach the creation of Software Applications with the view of meeting certain requirements</p>

                    <div style="display: flex;justify-content: center;">
                      <button type="button" class="btn btn-dark" style="width: 58%;font-size: 13px;color: black; margin-top: 10%;height: 35px;background-color: #b1e8e8;">View Details</button>
                        </div>                  </div>
                </div>
              
                <div class="column accel-col" style="margin-left: 25px;">
                  <div class="card">
                    <img src="https://www.accelacademy.in/assets/img/course-full/3.jpg" (click)="productDetails(14)" alt="Avatar" style="width:100%">
                    <h4 class="desktop-only" style="height: 24%; line-height: 0.8;margin-top: 15px;text-align: left;" (click)="productDetails(14)" ><b >Post Graduate Diploma in Cloud Engineering</b></h4> 
                    <p class="mobile-only"><b >PG Diploma in Cloud Engineering</b></p> 
                    <p style="line-height:1;text-align: left;font-size: 13px;margin-top: 2%;">Teach the creation of Software Applications with the view of meeting certain requirements</p>

                    <div style="display: flex;justify-content: center;">
                      <button type="button" class="btn btn-dark" style="width: 58%;font-size: 13px;color: black; margin-top: 10%;height: 35px;background-color: #b1e8e8;">View Details</button>
                        </div>                  </div>
                </div>
                
                <div class="column accel-col" style="margin-left: 25px;">
                  <div class="card">
                    <img src="https://www.accelacademy.in/assets/img/course-full/2.jpg" (click)="productDetails(15)" alt="Avatar" style="width:100%">
                    <h4 class="desktop-only" style="height: 24%; line-height: 0.8;margin-top: 15px;text-align: left;" (click)="productDetails(15)" ><b >Post Graduate Diploma in Cyber Security</b></h4> 
                    <p class="mobile-only"><b >PG Diploma in Cyber Security</b></p> 
                    <p style="line-height:1;text-align: left;font-size: 13px;margin-top: 2%;">Teach the creation of Software Applications with the view of meeting certain requirements</p>
<div style="display: flex;justify-content: center;">
                <button type="button" class="btn btn-dark" style="width: 58%;font-size: 13px;color: black; margin-top: 10%;height: 35px;background-color: #b1e8e8;">View Details</button>
                  </div>
                </div>
              </div>
               
              </div>
                
        
              
          </section>
        
          
        </div>
  
        </div>
      </div>
     
      
    
    
    
    
      


    </section> -->



<section *ngIf="config.title == 'Accel'" class="bottom_banner" style="overflow: hidden;">
  <div class="row" style="justify-content: center;">
    <div class="col-8" class="container_h" (click)="productList()">
      <img class="img-fluid" src="../../../../assets/images/accel/accel_bottom_banner.png">
      <div class="overlay-left-slide"></div>
    </div>
  </div>
</section>
<section class="pt-5 pb-5" *ngIf="config.title == 'Accel'" style="overflow: hidden;">
  <div class="container">
    <div class="row">
      <div class="col-6">
        <h3 class="mb-3" style="color:#4880c3">FROM OUR REVIEWERS </h3>
      </div>
      <div class="col-6 text-right">
        <a class="btn btn-primary mb-3 mr-1" href="#carouselExampleIndicators2" role="button" data-slide="prev">
          <i class="fa fa-arrow-left"></i>
        </a>
        <a class="btn btn-primary mb-3 " href="#carouselExampleIndicators2" role="button" data-slide="next">
          <i class="fa fa-arrow-right"></i>
        </a>
      </div>
      <div class="col-12">
        <div id="carouselExampleIndicators2" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <div class="carousel-item active">
              <div class="row">
                <div class="col-md-4 mb-3">
                  <div class="card" style="height: 470px;">
                    <!-- <img class="img-fluid" alt="100%x280" src="https://images.unsplash.com/photo-1532781914607-2031eca2f00d?ixlib=rb-0.3.5&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1080&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjMyMDc0fQ&amp;s=7c625ea379640da3ef2e24f20df7ce8d"> -->
                    <div class="card-body">
                      <h5 class="card-title" style="font-weight: 700;">Sudhakar K </h5>
                      <h5 class="card-title" style="font-weight: 700;">Engineer -Platform Support</h5>
                      <h5 class="card-title" style="font-weight: 700;"> in Wipro Infotech</h5>
                      <p class="card-text font_size_review">IT Infrastructure training from an IT company makes a lot of
                        difference. Accel had a lot of real life scenarios in IT infrastructure management that prepared
                        me for both the interview and the job. I have experienced that studying from books can only set
                        the course, it takes hands-on experience to actually solve a problem and excel in the field.
                        Thanks to Accel I had a good initiation into the IT industry.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <div class="card" style="height: 470px;">
                    <!-- <img class="img-fluid" alt="100%x280" src="https://images.unsplash.com/photo-1517760444937-f6397edcbbcd?ixlib=rb-0.3.5&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1080&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjMyMDc0fQ&amp;s=42b2d9ae6feb9c4ff98b9133addfb698"> -->
                    <div class="card-body">
                      <h5 class="card-title" style="font-weight: 700;">Balasubramanian C</h5>
                      <h5 class="card-title" style="font-weight: 700;">Technical Head</h5>
                      <h5 class="card-title" style="font-weight: 700;">HCL Technologies</h5>
                      <p class="card-text font_size_review">Accel was my first choice for embedded systems training as
                        it was well established in the domain and also highly recommended by my seniors. I would advice
                        aspiring embedded systems professionals to look for a detailed syllabi and hands-on training
                        sessions. While getting a job is important, sustaining in the field requires a good knowledge of
                        the fundamentals, for which the right training is critical.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <div class="card" style="height: 470px;">
                    <!-- <img class="img-fluid" alt="100%x280" src="https://images.unsplash.com/photo-1532712938310-34cb3982ef74?ixlib=rb-0.3.5&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1080&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjMyMDc0fQ&amp;s=3d2e8a2039c06dd26db977fe6ac6186a"> -->
                    <div class="card-body">
                      <h5 class="card-title" style="font-weight: 700;">Nageswari Vijayakumar</h5>
                      <h5 class="card-title" style="font-weight: 700;">Technical Architect</h5>
                      <h5 class="card-title" style="font-weight: 700;">Hexaware</h5>
                      <p class="card-text font_size_review">I was apprehensive of a career in IT infrastructure
                        management when most of my friends had pursued software careers. But the systematic way in which
                        Accel's training programs were designed helped me understand the basics and opened my mind to
                        learn new technologies as they evolved.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="row">
                <div class="col-md-4 mb-3">
                  <div class="card" style="height: 470px;">
                    <!-- <img class="img-fluid" alt="100%x280" src="https://images.unsplash.com/photo-1532771098148-525cefe10c23?ixlib=rb-0.3.5&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1080&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjMyMDc0fQ&amp;s=3f317c1f7a16116dec454fbc267dd8e4"> -->
                    <div class="card-body">
                      <h5 class="card-title" style="font-weight: 700;">Mohana Krishnan</h5>
                      <h5 class="card-title" style="font-weight: 700;">Embedded Systems</h5>
                      <h5 class="card-title" style="font-weight: 700;">Robert Bosch Engineering and Business Solutions
                      </h5>
                      <p class="card-text font_size_review">Accel was one of the few center's offering embedded systems
                        training when I was eagerly looking forward to a technology based career option to go with my
                        subject background in engineering. I was aware of the firmware industry that thrives between the
                        hardware and software domains and wanted to get in. With Accel's well designed embedded systems
                        program, I was able to grasp the fundamentals very fast and saw myself ready for a leading role
                        in the global workplace.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <div class="card" style="height: 470px;">
                    <!-- <img class="img-fluid" alt="100%x280" src="https://images.unsplash.com/photo-1532715088550-62f09305f765?ixlib=rb-0.3.5&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1080&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjMyMDc0fQ&amp;s=ebadb044b374504ef8e81bdec4d0e840"> -->
                    <div class="card-body">
                      <h5 class="card-title" style="font-weight: 700;">Chandru Dhinaharan</h5>
                      <h5 class="card-title" style="font-weight: 700;">Global Practice Head</h5>
                      <h5 class="card-title" style="font-weight: 700;">Hitachi</h5>
                      <p class="card-text font_size_review">when most of my colleagues got placed in software companies,
                        I thought that I had missed the IT bus. That is when I came upon Accel's job guaranteed program
                        in IT Infrastructure Management. In six months I was ready and got placed. Looking back I find
                        myself better placed than some of my software colleagues who need to keep changing platforms
                        while my domain evolves systematically.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <div class="card" style="height: 470px;">
                    <!-- <img class="img-fluid" alt="100%x280" src="https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd?ixlib=rb-0.3.5&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1080&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjMyMDc0fQ&amp;s=0754ab085804ae8a3b562548e6b4aa2e"> -->
                    <div class="card-body">
                      <h5 class="card-title" style="font-weight: 700;">S. Saravanan</h5>
                      <h5 class="card-title" style="font-weight: 700;">Deputy General Manager</h5>
                      <h5 class="card-title" style="font-weight: 700;">The Karur Vysya Bank Limited</h5>
                      <p class="card-text font_size_review">We, at KVB, have been availing services of Accel IT Services
                        for close to 15 years. KVB’s presence has increased multi-fold in the last 15 years and Accel IT
                        Services has been able to extend their support pan-India, seamlessly. We thank Accel IT Services
                        for their services to KVB and wish them great success in their future endeavors.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="carousel-item">
                              <div class="row">
                                  <div class="col-md-4 mb-3">
                                      <div class="card">
                                          <img class="img-fluid" alt="100%x280" src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e?ixlib=rb-0.3.5&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1080&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjMyMDc0fQ&amp;s=ee8417f0ea2a50d53a12665820b54e23">
                                          <div class="card-body">
                                              <h5 class="card-title">Campus RecruitmentSpecial title treatment</h5>
                                              <p class="card-text font_size_review">With supporting text below as a natural lead-in to additional content.</p>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-4 mb-3">
                                      <div class="card">
                                          <img class="img-fluid" alt="100%x280" src="https://images.unsplash.com/photo-1532777946373-b6783242f211?ixlib=rb-0.3.5&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1080&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjMyMDc0fQ&amp;s=8ac55cf3a68785643998730839663129">
                                          <div class="card-body">
                                              <h5 class="card-title">Free Technology Seminar</h5>
                                              <p class="card-text font_size_review">With supporting text below as a natural lead-in to additional content.</p>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-4 mb-3">
                                      <div class="card">
                                          <img class="img-fluid" alt="100%x280" src="https://images.unsplash.com/photo-1532763303805-529d595877c5?ixlib=rb-0.3.5&amp;q=80&amp;fm=jpg&amp;crop=entropy&amp;cs=tinysrgb&amp;w=1080&amp;fit=max&amp;ixid=eyJhcHBfaWQiOjMyMDc0fQ&amp;s=5ee4fd5d19b40f93eadb21871757eda6">
                                          <div class="card-body">
                                              <h5 class="card-title">Certificate Program in Ethical Hacking</h5>
                                              <p class="card-text font_size_review">With supporting text below as a natural lead-in to additional content.</p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #content let-c="close" let-d="dismiss">
  <div id="myModal" role="dialog" *ngIf="config.title == 'Karupattiraja'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!-- <button type="button" #closebutton class="close" data-dismiss="modal">&times;</button> -->
          <button type="button" class="close" (click)="closeModal()">&times;</button>

          <h4 class="modal-title"></h4>
        </div>
        <div class="modal-body" style="display: flex;justify-content: center;">
          <img src="../../../../assets/images/vistas/Karupatti raja banner.png" style="width:60%;cursor:pointer"
            class="modal-hover-opacity home-popup" />

        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- <button  id="openimage"  *ngIf="config.title === 'Karupattiraja'" data-toggle="modal" data-target="#myModal">
        </button> -->

<!-- <div class="row" *ngIf="config.title == 'Accel'">
      <div class="col-2"></div>
      <div class="col-8">
        <section   >
          <div class="text-center mb-2">
              <h3 class="text-primary" style="font-family: Helvetica;"> Testimonials</h3>
              
          </div>
          <owl-carousel-o [options]="ProductSliderConfig" class="slider rounder-corner-nav">
            <ng-container
              *ngFor="let review of reviews2; let i = index"
            >
              <ng-template carouselSlide >
                <p style="font-family: Helvetica;">{{review.comment}}</p>
                <p style="font-family: Helvetica;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>--{{review.user}}</b></p>
              </ng-template>                 
            </ng-container>
          </owl-carousel-o>
        </section>
      </div>
      <div class="col-2"></div>
    </div> -->




<section class="featured-recommendations" *ngIf="config.title === 'Deera'">

  <div>
    <app-featured-collections *ngIf="config.title == 'Deera'"
      [collections]="featuredCollections1"></app-featured-collections>
  </div>
  <div *ngIf="newArrival.length != 0" class="container" style="width:94%!important">


    <h2 class="text-primary" style="display: flex; justify-content: center; margin-bottom: 35px;    margin-top: 2%;">New
      Arrival Products</h2>
    <owl-carousel-o [options]="ProductSliderConfig1" class="slider rounder-corner-nav"
      style="margin-top: 28px;position: relative;">
      <ng-container *ngFor="let product of newArrival; let i = index">
        <ng-template carouselSlide>
          <app-product-box-one [product]="product" [index]="i"
            style="display:block;width: 98%;margin-left: 1%;"></app-product-box-one>
        </ng-template>
      </ng-container>
    </owl-carousel-o>

  </div>


</section>
<section *ngIf="config.title === 'Deera'" style="overflow: hidden;" class="desktop-only">
  <div class="row">
    <div class="col-12">
      <div class="">
        <div style="object-fit: contain;">
          <img src="assets/images/deera/Deera-P-image-1.jpg" style="width: 100%;">

        </div>


      </div>

    </div>

  </div>

</section>
<section *ngIf="config.title === 'Deera'" class="mobile-only">
  <div class="row">
    <div class="col-12">
      <div class="">
        <div style="object-fit: contain;">
          <img src="assets/images/deera/Deera banner 2.jpg" style="width: 100%;">

        </div>


      </div>

    </div>

  </div>

</section>
<section class="featured-recommendations" *ngIf="config.title === 'Deera'" style="background-color: #f8f1eb;">


  <div *ngIf="newArrival.length != 0">
    <div class="container">


      <h2 class="text-primary deera-h4-align" style="padding-top: 2%;">Stand - up Pouch</h2>
      <owl-carousel-o [options]="ProductSliderConfig1" class="slider rounder-corner-nav"
        style="margin-top: 28px;position: relative;">
        <ng-container *ngFor="let product of ProductsbasedonCategory; let i = index">
          <ng-template carouselSlide>
            <app-product-box-one [product]="product" [index]="i"
              style="display:block;width: 98%;margin-left: 1%;"></app-product-box-one>
          </ng-template>
        </ng-container>
      </owl-carousel-o>

    </div>
  </div>
</section>
<section *ngIf="config.title === 'Deera'" style="overflow: hidden;" class="desktop-only">
  <div class="row">
    <div class="col-12">
      <div class="">
        <div style="object-fit: contain;">
          <img src="https://ecbee-labes-images1.s3.ap-south-1.amazonaws.com/Deera/StoreGallery/Deera-WC-image-1.jpg"
            style="width: 100%;">

        </div>


      </div>

    </div>

  </div>

</section>
<section *ngIf="config.title === 'Deera'" class="mobile-only">
  <div class="row">
    <div class="col-12">
      <div class="">
        <div style="object-fit: contain;">
          <img src="assets/images/deera/Deera banner 1.jpg" style="width: 100%;">

        </div>


      </div>

    </div>

  </div>

</section>
<section class="featured-recommendations" *ngIf="config.title === 'Deera'" style="background-color: #eae7e0;">


  <div *ngIf="newArrival.length != 0">
    <div class="container">


      <h2 class="text-primary" style="display: flex; justify-content: center; margin-bottom: 35px;    padding-top: 3%;">
        Disposable Cutlery</h2>
      <owl-carousel-o [options]="ProductSliderConfig1" class="slider rounder-corner-nav"
        style="margin-top: 28px;position: relative;">
        <ng-container *ngFor="let product of ProductsbasedonCategory1; let i = index">
          <ng-template carouselSlide>
            <app-product-box-one [product]="product" [index]="i"
              style="display:block;width: 98%;margin-left: 1%;"></app-product-box-one>
          </ng-template>
        </ng-container>
      </owl-carousel-o>

    </div>
  </div>
</section>

<section *ngIf="config.title == 'Deera'" style="margin-top: 2%;">
  <div class="text-center mb-2">
    <h3 class="text-primary" style=" margin-bottom: 25px;"> What Do Our Customers Say</h3>
    <!--<h3 class="text-primary">Shop from Top Categories</h3>-->
  </div>

  <div class="container">
    <owl-carousel-o [options]="ProductSliderConfig" class="slider rounder-corner-nav">
      <ng-container *ngFor="let review of reviews1; let i = index">
        <ng-template carouselSlide>
          <!-- <span [class]="'fa fa-star'"
                    style="font-size: 15px !important;color: orange !important;"></span>
                  <span [class]="'fa fa-star'"
                    style="font-size: 15px !important;color: orange !important;"></span>
                  <span [class]="'fa fa-star'"
                    style="font-size: 15px !important;color: orange !important;"></span>
                  <span [class]="'fa fa-star'"
                    style="font-size: 15px !important;color: orange !important;"></span>
                  <span [class]="'fa fa-star'"
                    style="font-size: 15px !important;color: orange !important; margin-bottom: 15px;"></span> -->
          <div style="display: flex;justify-content: center;">
            <img [src]="review.img" style="width: 25%;border-radius: 50%;">

          </div>

          <p style="font-family: Helvetica;margin-top: 5%;font-weight: 600;text-align: center;"
            class="deera_review_content">{{review.comment}}</p>
          <p style="color:#0c377b;font-weight: 700;text-align: center;width: 97%;">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>{{review.user}}</b></p>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</section>


<section *ngIf="config.title == 'Deera'" style="margin-top: 2%;">
  <div class="text-center mb-2">
    <h3 class="text-primary" style=" margin-bottom: 25px;font-size: 20px;
    font-weight: 700;">For Any Queries Contact - deera2021@gmail.com</h3>
    <!--<h3 class="text-primary">Shop from Top Categories</h3>-->
  </div>
</section>

<button  *ngIf="config.title == 'Schift Cosmetics'" style="cursor:pointer;visibility: hidden; " (click)="onClick($event)" id="schiftmodalforhomepage"
  class="modal-hover-opacity" data-toggle="modal" data-target="#myModal"></button>
<!-- <div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" #closebutton class="close" data-dismiss="modal">&times;</button>
      
      </div>
      <div class="modal-body">
      
      </div>
    </div>
  </div>
</div> -->



<!-- The Modal -->
<!-- <div class="modal fade" id="myModal" *ngIf="config.title == 'Schift Cosmetics'">
  <div class="modal-dialog modal-xl">
    <div class="modal-content" style="width: 100% !important;border: none;background-color: transparent;">
      <div class="modal-header" style="background-color: transparent;border: none;">
        <button type="button" class="close" data-dismiss="modal" (click)="scrollToTop()">&times;</button>
      </div>
      <div class="modal-body d-flex justify-content-center align-items-center schift_topdd">

        <img src="../../../../assets/images/schift/deskpop.jpg" style="max-width:100%;cursor:pointer"
          class="modal-hover-opacity desktop-only" data-dismiss="modal" (click)="scrollToTop()"/>
        <img src="../../../../assets/images/schift/mobpop.jpg" style="max-width:109%;cursor:pointer;margin-left: 0%;"
          class="modal-hover-opacity mobile-only" data-dismiss="modal" (click)="scrollToTop()"/>
      </div>
    </div>
  </div>
</div> -->